import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import VideocamIcon from '@mui/icons-material/Videocam'
import VideocamOffIcon from '@mui/icons-material/VideocamOff'
import MicIcon from '@mui/icons-material/Mic'
import MicOffIcon from '@mui/icons-material/MicOff'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import LoginIcon from '@mui/icons-material/Login'
import LayersClearIcon from '@mui/icons-material/LayersClear'
import ReplayIcon from '@mui/icons-material/Replay'
import RefreshIcon from '@mui/icons-material/Refresh'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import SearchIcon from '@mui/icons-material/Search'
import PreviewIcon from '@mui/icons-material/Preview'
import HistoryIcon from '@mui/icons-material/History'
import SettingsIcon from '@mui/icons-material/Settings'
import MedicationIcon from '@mui/icons-material/Medication'
import CloseIcon from '@mui/icons-material/Close'
import HeightIcon from '@mui/icons-material/Height'
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation'
import CropPortraitIcon from '@mui/icons-material/CropPortrait'
import CropLandscapeIcon from '@mui/icons-material/CropLandscape'
import { Box, IconButton, Select, MenuItem, FormControl, Typography, Paper, Tooltip, Avatar, Drawer, Fab, Button, ListItemIcon, ListItemText, CircularProgress, Menu } from '@mui/material'
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong'
import BoltIcon from '@mui/icons-material/Bolt'
import AssignmentIcon from '@mui/icons-material/Assignment'
import { getAndSetCameras, getAndSetMicrophones, getAndSetSpeakers } from 'src/consumer/components/LiveSessionPage/LiveSessionPageComponents'
import { getSelectedCameraInLocalStorage, getSelectedMicrophoneInLocalStorage, getSelectedSpeakerInLocalStorage } from 'src/consumer/services/localstorageServices'
import AgoraRTC from 'agora-rtc-sdk-ng'
import React, { useCallback, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { flushSync } from 'react-dom'
import { Spinner } from 'react-bootstrap'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'
import {
  AGORA_RTC_LAYOUTS,
  RTC_PROVIDERS,
  buildChamberShellSnapshot,
  createBookedEventLocalParticipantIdentity,
  createMentorChamberLocalParticipantIdentity,
  decorateSessionWithRouting,
  FLOW_TYPES,
  preloadAgoraRtcUIKitModule,
  readLocalParticipantIdentity,
  readSessionInterfaceId,
  resolveSessionRoutingContext,
  useRtcSessionShell,
} from 'src/live'
import { CheckoutButtonComponent, EmrCheckedInIdlePopup } from 'src/clinic/components/CheckIn/checkInComponents'
import {
  logAutoConnectPaused,
  logAutoConnectResumed,
} from 'src/clinic/components/CheckIn/services'
import DayViewCalendarComponent from 'src/clinic/components/ClinicManageBookingsPage/DayViewCalendarComponent'
import BookedSlotsDrawer from 'src/clinic/components/ClinicManageBookingsPage/components/BookedSlotsDrawer'
import PatientSearchDrawer from 'src/mentor/components/MentorClinicBookingsPage/component/PatientSearchDrawer'
import SplitScreenHeader from './components/SplitScreenHeader'
import NotificationPanel, { showNotification } from './components/NotificationPanel'
import DebugPanel from './components/DebugPanel'
import './VideoCallButtons.css' // Enhanced video call controls v2.1
import { getCPDataWithParams } from 'src/clinic/services'
import BaseUITabsComponent from 'src/common/tabs/BaseUITabs'
import {
  HCIPMenuContainer,
  HCIPMenuItem,
  HotlineChamberInteractionPart,
  HotlineSectionSeparator,
} from 'src/consumer/components/HotlineChamberPage/HotlineChamberStyles'
import MomentDatePicker from 'src/mentor/components/PrescriptionMakingPage/inputComponents/diagnosis/components/MomentDatePicker'
import {
  LSPastPrescriptionsComponent,
} from 'src/consumer/components/LiveSessionPage/LiveSessionPageComponents'
import {
  allAvailableEventTypes,
  BOOKING_SESSION_STATUS,
  CHAMBER_SCREEN_ACTIONS,
  CHAMBER_SCREEN_STATES,
  STATUS_SESSION_CANCELLED,
  BOOKING_STATUSES,
  BOOKING_PAYMENT_STATUSES,
} from 'src/consumer/constants'
import {
  askCheckedInChamberScreenToPollNextAction,
  checkChamberScreenStatus,
  getDataWithoutParams,
  markBookedEventLog,
  sendShowImageCommandToChamberScreen,
  getAgoraToken,
  sendReloadChamberRoomScreenSignal,
} from 'src/consumer/services/featureServices'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { useCheckedInOnlyChamberRoomId, useCheckedInOrPeekedInChamberRoomId } from 'src/customHooks/customHooks'
import AssessmentReportMakingPage from 'src/mentor/components/AssessmentReport/AssessmentReportMakingPage'
import PractitionerAssessmentDrawer from 'src/mentor/components/PractitionerAssessment/PractitionerAssessmentDrawer'
import {
  MENTOR_CLINIC_BOOKING_TABS,
  MENTOR_CLINIC_BOOKING_TABS_LIST,
} from 'src/mentor/components/MentorClinicBookingsPage/util'
import ChamberScreenSignallingActions from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/ChamberScreenSignallingActions'
import { ChamberScreenSignallingSnackBarContext } from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/ChamberScreenSignallingSnackBarProvider'
import LeaveButton from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/LeaveButton'
import ChamberRoomStatusIndicator from 'src/mentor/components/MentorClinicSomeChamberAutoJoiningPage/components/ChamberRoomStatusIndicator'
import ScreeningSectionsProvider from 'src/mentor/components/PrescriptionMakingPage/context/ScreeningSectionsProvider'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { DocSideContext } from 'src/context/DocSideContextProvider'
import {
  isCommonResponseSuccessful,
  markBookedSessionAsCompletedFunction,
  sleep,
} from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { buildMentorRtmUsername } from './utils/rtmUsernameBuilder'
import PrescriptionMakingPage from '../PrescriptionMakingPage'
import PrescriptionDataProvider from '../PrescriptionMakingPage/context/PrescriptionDataProvider'
import ScreeningReportMakingPage from '../ScreeningReportMakingPage'
import TherapyReportMakingPage from '../TherapyReportMakingPage'
import VitalsListingPage from '../VitalsListingPage'
import LSPastVisitReportsComponent from 'src/consumer/components/LiveSessionPage/components/LSPastVisitReportsComponent/LSPastVisitReportsComponent'
import { getPastPatientReports } from 'src/reducers/emr/services/pastPatientReports'
import store from 'src/store'
import { FLOW_STATUSES_FOR_LEAVING_SESSION } from 'src/consumer/components/LiveSessionPage/utils/sessionNavigationUtils'
import RXDrawerComponent from 'src/consumer/components/LiveSessionPage/components/RXDrawerComponent/RXDrawerComponent'
import MentorChamberAgoraVideoSurface from 'src/live/shell/components/MentorChamberAgoraVideoSurface'

const MENTOR_SPLIT_HEADER_OFFSET_PX = 44
const AUTO_CONNECT_PAUSE_OPTIONS = Object.freeze([
  { value: 1 * 60 * 1000, label: '1 min' },
  { value: 3 * 60 * 1000, label: '3 min' },
  { value: 5 * 60 * 1000, label: '5 min' },
  { value: 10 * 60 * 1000, label: '10 min' },
  { value: 15 * 60 * 1000, label: '15 min' },
  { value: 30 * 60 * 1000, label: '30 min' },
])
const AUDIO_PREVIEW_BAR_COUNT = 12
const AUDIO_PREVIEW_IDLE_LEVELS = Object.freeze(
  Array.from({ length: AUDIO_PREVIEW_BAR_COUNT }, (_, index) =>
    index % 3 === 1 ? 20 : 10,
  ),
)
const REPORT_EVENT_TYPE_ALIASES = Object.freeze({
  [allAvailableEventTypes.consultation]: ['consultation', 'prescription'],
  [allAvailableEventTypes.therapySession]: ['therapy-session', 'therapy', 'therapy-report'],
  [allAvailableEventTypes.screening]: ['screening', 'screening-report'],
  [allAvailableEventTypes.assessment]: ['assessment', 'assessment-report'],
})

function formatAutoConnectRemaining(remainingMs) {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  if (minutes <= 0) {
    return `${seconds}s`
  }

  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

function buildAudioPreviewBars(dataArray, barCount = AUDIO_PREVIEW_BAR_COUNT) {
  if (!dataArray || dataArray.length === 0 || barCount <= 0) {
    return [...AUDIO_PREVIEW_IDLE_LEVELS]
  }

  const bucketSize = Math.max(1, Math.floor(dataArray.length / barCount))

  return Array.from({ length: barCount }, (_, index) => {
    const start = index * bucketSize
    const end = Math.min(dataArray.length, start + bucketSize)
    const slice = dataArray.slice(start, end)
    const average =
      slice.length > 0 ? slice.reduce((sum, value) => sum + value, 0) / slice.length : 0

    return Math.max(8, Math.min(100, Math.round((average / 255) * 100)))
  })
}

function AudioPreviewBars({ bars = AUDIO_PREVIEW_IDLE_LEVELS, active = false }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        gap: '4px',
        height: '42px',
        px: 1,
        py: 0.75,
        borderRadius: '10px',
        background: active ? 'rgba(16, 185, 129, 0.08)' : 'rgba(107, 114, 128, 0.08)',
        border: `1px solid ${
          active ? 'rgba(16, 185, 129, 0.18)' : 'rgba(107, 114, 128, 0.18)'
        }`,
      }}
    >
      {bars.map((level, index) => (
        <Box
          key={`audio-preview-bar-${index}`}
          sx={{
            flex: 1,
            minWidth: '6px',
            borderRadius: '999px',
            height: `${level}%`,
            transition: 'height 120ms ease-out, background-color 160ms ease-out',
            background: active
              ? 'linear-gradient(180deg, rgba(52, 211, 153, 0.95) 0%, rgba(16, 185, 129, 0.78) 100%)'
              : 'rgba(107, 114, 128, 0.45)',
          }}
        />
      ))}
    </Box>
  )
}

function normalizeEventTypeCandidate(value) {
  return typeof value === 'string' ? value.trim().toLowerCase() : ''
}

function resolveBookedEventPatientId(bookedEvent) {
  return (
    bookedEvent?.patientId ||
    bookedEvent?.patientInfo?.id ||
    bookedEvent?.patientInfoData?.id ||
    bookedEvent?.patientInfo?.patientId ||
    bookedEvent?.patientInfoData?.patientId ||
    null
  )
}

function resolveBookedEventReportType(bookedEvent, auxiliaryDataFromApi = null) {
  const rawCandidates = [
    bookedEvent?.eventType,
    bookedEvent?.type,
    bookedEvent?.eventTypeSlug,
    bookedEvent?.eventTypeData?.type,
    bookedEvent?.eventTypeData?.eventType,
    bookedEvent?.eventTypeData?.slug,
    auxiliaryDataFromApi?.eventType,
    auxiliaryDataFromApi?.eventTypeSlug,
    auxiliaryDataFromApi?.consultationDetails?.eventType,
    auxiliaryDataFromApi?.consultationDetails?.type,
  ]
    .map(normalizeEventTypeCandidate)
    .filter(Boolean)

  for (const [canonicalEventType, aliases] of Object.entries(REPORT_EVENT_TYPE_ALIASES)) {
    if (rawCandidates.some((candidate) => aliases.includes(candidate))) {
      return canonicalEventType
    }
  }

  return bookedEvent?.eventType
}

function readCheckedInRoomContext() {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const raw = localStorage.getItem('checkedInDetails')
    if (!raw) {
      return null
    }

    const parsed = JSON.parse(raw)
    if (!parsed?.chamberRoomId || !parsed?.clinicLocationId || !parsed?.clinicBrandId) {
      return null
    }

    return parsed
  } catch (error) {
    console.error('[MentorClinicSomeChamberAutoJoiningPage] Failed to read checked-in room context', error)
    return null
  }
}

// 3-dot menu component for Screening Report actions
function ScreeningReportActionsMenu({ screeningReportRef }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSaveAndPrint = async () => {
    if (screeningReportRef?.current?.saveAndPrint) {
      await screeningReportRef.current.saveAndPrint()
    }
    handleClose()
  }

  return (
    <>
      <HCIPMenuItem
        onClick={handleClick}
        style={{
          background: '#fff',
          color: '#64748b',
          border: '1px solid #e2e8f0',
          fontSize: '12px',
          padding: '6px 12px',
          fontWeight: 500,
          minWidth: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <MoreVertIcon sx={{ fontSize: 18 }} />
      </HCIPMenuItem>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 160,
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            border: '1px solid rgba(103, 121, 227, 0.1)',
          },
        }}
      >
        <MenuItem
          onClick={handleSaveAndPrint}
          sx={{
            fontSize: '14px',
            padding: '10px 16px',
            '&:hover': {
              backgroundColor: 'rgba(103, 121, 227, 0.08)',
            },
          }}
        >
          Save & Print
        </MenuItem>
      </Menu>
    </>
  )
}

export default function MentorClinicSomeChamberAutoJoiningPage() {
  const { clinicId, clinicBrandId, sessionSlug } = useParams()
  const { mentorClinicAssociationData } = useContext(MentorProfileContext)

  // wakelock - Only request when page is visible
  useEffect(() => {
    let wakeLock = null

    const requestWakeLock = async () => {
      // Check if page is visible before requesting wake lock
      if (document.hidden || !document.visibilityState || document.visibilityState === 'hidden') {
        return
      }

      // Check if WakeLock API is available
      if (!('wakeLock' in navigator)) {
        return
      }

      try {
        wakeLock = await navigator.wakeLock.request('screen')

        // Optionally handle the wake lock release
        wakeLock.addEventListener('release', () => {
          // Wake lock released
        })
      } catch (err) {
        // Silently handle errors (e.g., page not visible, user denied, etc.)
        if (err.name !== 'NotAllowedError') {
        console.error(`${err.name}: ${err.message}`)
        }
      }
    }

    // Request wake lock when page becomes visible
    const handleVisibilityChange = () => {
      if (!document.hidden && document.visibilityState === 'visible') {
    requestWakeLock()
      } else if (wakeLock) {
        // Release wake lock when page becomes hidden
        wakeLock.release().catch(() => {})
        wakeLock = null
      }
    }

    // Initial request if page is visible
    if (!document.hidden) {
      requestWakeLock()
    }

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Clean up on component unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      if (wakeLock) {
        wakeLock.release().then(() => {
          // Wake lock released
        }).catch(() => {})
      }
    }
  }, [])

  const showPredecidedUIComponent =
    clinicId && mentorClinicAssociationData?.find((item) => item?.id === clinicId)

  useEffect(() => {
    const debugPayload = {
      debugVersion: 'mentor-chamber-shared-renderer-default-v1',
      componentPath: showPredecidedUIComponent ? 'predecided-clinic-chamber' : 'undecided-clinic-selector',
      clinicBrandId: clinicBrandId || null,
      clinicId: clinicId || null,
      sessionSlug: sessionSlug || null,
    }

    if (typeof window !== 'undefined') {
      window.__AUMHUM_MENTOR_CHAMBER_RTC_DEBUG__ = debugPayload
    }

    console.info('[MentorClinicSomeChamberAutoJoiningPage] Route debug', debugPayload)
  }, [clinicBrandId, clinicId, sessionSlug, showPredecidedUIComponent])

  return (
    <div
      className={
        'vh-100 vw-100 justify-content-center align-items-center' +
        (showPredecidedUIComponent ? ' d-flex' : '')
      }
    >
      {showPredecidedUIComponent ? (
        <PredecidedClinicIdUIComponent 
          clinicLocationId={clinicId}
          clinicBrandId={clinicBrandId}
          sessionSlug={sessionSlug}
        />
      ) : (
        <UndecidedClinicIdUIComponent />
      )}
    </div>
  )
}

const PredecidedClinicIdUIComponent = ({ clinicLocationId, clinicBrandId, sessionSlug }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const { showSnackBar } = useContext(ChamberScreenSignallingSnackBarContext)
  const [serverGivenNextAction, setServerGivenNextAction] = useState()
  const { mentorClinicAssociationData, mentorProfileData } = useContext(MentorProfileContext)
  const { setFlowId, setButtonTopOffset } = useContext(DocSideContext)
  const chosenClinicData = mentorClinicAssociationData?.find(
    (item) => item?.id === clinicLocationId,
  )

  // const [anchorElForMenu, setAnchorElForMenu] = useState(null)
  // const menuOpen = Boolean(anchorElForMenu)
  // const handleClickMenuOpener = (event) => {
  //   setAnchorElForMenu(event.currentTarget)
  // }
  // const handleCloseMenu = () => {
  //   setAnchorElForMenu(null)
  // }

  // serverGivenNextAction?.channel?.chamberRoomId

  const [chamberScreenStateNow, setChamberScreenStateNow] = useState(CHAMBER_SCREEN_STATES.IDLING)
  const [joinedChamberName, setJoinedChamberName] = useState('')
  const [joinedChannelName, setJoinedChannelName] = useState('')
  const [agoraRtcProps, setAgoraRtcProps] = useState({})
  const [agoraRtmProps, setAgoraRtmProps] = useState({})
  
  // Store original chamber room channel to reconnect after booked event session
  const [originalChamberRoomChannel, setOriginalChamberRoomChannel] = useState(null)
  const [isInBookedEventSession, setIsInBookedEventSession] = useState(false)

  // interaction menu related:
  const [triggerSave, setTriggerSave] = useState()
  const [newWantedMenuItemId, setNewWantedMenuItemId] = useState()
  const [patientMenuOptions, setPatientMenuOptions] = useState([])
  const [selectedOptionPatientMenu, setSelectedOptionPatientMenu] = useState()
  const [patientBookedSlotDetailsLoading, setPatientBookedSlotDetailsLoading] = useState(false)
  const [patientSelected, setPatientSelected] = useState(false)
  const [selectedPatientBookedEventId, setSelectedPatientBookedEventId] = useState()
  const [selectedPatientBookedEventData, setSelectedPatientBookedEventData] = useState()
  const [auxiliaryData, setAuxiliaryData] = useState()
  const [rxDrawerOpen, setRxDrawerOpen] = useState(false)
  const [assessmentDrawerOpen, setAssessmentDrawerOpen] = useState(false)
  
  // Ref to prevent multiple LEAVE API calls
  const isClosingBookedEventRef = useRef(false)
  
  // Ref to track if we've already determined this is an offline meeting
  const isOfflineMeetingRef = useRef(false)
  
  // Ref to track the last report mode that was active (for cleanup)
  const lastActiveReportModeRef = useRef(null)
  
  // Ref to prevent multiple calls to getEventBySlug
  const isFetchingEventBySlugRef = useRef(false)
  
  // Ref to prevent URL updates when leaving session
  // CRITICAL: This ref MUST be set to true BEFORE clearing selectedOptionPatientMenu
  // to prevent the menu setup useEffect from re-selecting the menu after leaving
  // See: finallyCloseBookedEvent() and the menu setup useEffect at line ~1821
  const isLeavingSessionRef = useRef(false)
  
  // Ref to track the last slug we intentionally removed from URL
  const lastRemovedSlugRef = useRef(null)
  const [hideLayoutComponents, setHideLayoutComponents] = useState({
    sidebar: false,
    endSession: false,
    patientDetails: false,
  })

  const chamberRoomId = useCheckedInOnlyChamberRoomId()

  // Chamber screen status tracking
  const [chamberScreenStatus, setChamberScreenStatus] = useState('unknown') // 'online', 'offline', or 'unknown'

  const [showDocOnSidebar, setShowDocOnSidebar] = useState()

  const [isCameraOpen, setIsCameraOpen] = useState(false)
  const [isAudioOpen, setIsAudioOpen] = useState(false)
  
  // Device preview states
  const [availableCameras, setAvailableCameras] = useState([])
  const [availableMicrophones, setAvailableMicrophones] = useState([])
  const [availableSpeakers, setAvailableSpeakers] = useState([])
  const [selectedCamera, setSelectedCamera] = useState('')
  const [selectedMicrophone, setSelectedMicrophone] = useState('')
  const [selectedSpeaker, setSelectedSpeaker] = useState('')
  const [previewStream, setPreviewStream] = useState(null)
  const previewVideoRef = useRef(null)
  const [audioPreviewBars, setAudioPreviewBars] = useState(() => [
    ...AUDIO_PREVIEW_IDLE_LEVELS,
  ])
  const audioPreviewStreamRef = useRef(null)
  const audioPreviewContextRef = useRef(null)
  const audioPreviewAnalyserRef = useRef(null)
  const audioPreviewAnimationFrameRef = useRef(null)
  const [autoConnectPauseDurationMs, setAutoConnectPauseDurationMs] = useState(
    AUTO_CONNECT_PAUSE_OPTIONS[2].value,
  )
  const [autoConnectPausedUntil, setAutoConnectPausedUntil] = useState(null)
  const [autoConnectRemainingMs, setAutoConnectRemainingMs] = useState(0)
  const getAndHandleNextActionRef = useRef(null)
  const autoConnectPausedUntilRef = useRef(null)
  const autoConnectResumeInFlightRef = useRef(false)
  const activeAutoConnectPauseDurationRef = useRef(null)
  const activeAutoConnectLogContextRef = useRef({
    bookedEventId: null,
    checkedInRoomContext: null,
  })
  const isCameraOpenRef = useRef(isCameraOpen)
  const isAudioOpenRef = useRef(isAudioOpen)

  useEffect(() => {
    isCameraOpenRef.current = isCameraOpen
  }, [isCameraOpen])

  useEffect(() => {
    isAudioOpenRef.current = isAudioOpen
  }, [isAudioOpen])

  useEffect(() => {
    autoConnectPausedUntilRef.current = autoConnectPausedUntil
  }, [autoConnectPausedUntil])

  const buildAutoConnectIoState = useCallback(
    (autoConnectState = {}) => ({
      camera: isCameraOpenRef.current,
      mic: isAudioOpenRef.current,
      autoConnectPaused: autoConnectState?.autoConnectPaused,
      autoConnectPauseDurationMs: autoConnectState?.autoConnectPauseDurationMs,
      autoConnectResumeAtEpochMs: autoConnectState?.autoConnectResumeAtEpochMs,
    }),
    [],
  )

  const logAutoConnectPauseState = useCallback(
    async ({
      paused,
      pauseDurationMs = null,
      resumeAtEpochMs = null,
      bookedEventId = null,
      checkedInRoomContext = null,
    }) => {
      const ioState = buildAutoConnectIoState({
        autoConnectPaused: paused,
        autoConnectPauseDurationMs: pauseDurationMs,
        autoConnectResumeAtEpochMs: resumeAtEpochMs,
      })
      const resolvedBookedEventId = bookedEventId || selectedPatientBookedEventId
      const resolvedCheckedInRoomContext = checkedInRoomContext || readCheckedInRoomContext()

      const pendingLogs = []

      if (resolvedBookedEventId) {
        pendingLogs.push(
          markBookedEventLog(
            resolvedBookedEventId,
            paused ? 'AUTO_CONNECT_PAUSED' : 'AUTO_CONNECT_RESUMED',
            'mentor',
            ioState,
          ),
        )
      }

      if (resolvedCheckedInRoomContext) {
        pendingLogs.push(
          paused
            ? logAutoConnectPaused(resolvedCheckedInRoomContext, {
                autoConnectPauseDurationMs: pauseDurationMs,
                autoConnectResumeAtEpochMs: resumeAtEpochMs,
              })
            : logAutoConnectResumed(resolvedCheckedInRoomContext, {
                autoConnectPauseDurationMs: pauseDurationMs,
                autoConnectResumeAtEpochMs: resumeAtEpochMs,
              }),
        )
      }

      if (pendingLogs.length === 0) {
        return
      }

      try {
        await Promise.allSettled(pendingLogs)
      } catch (error) {
        console.warn(
          '[MentorClinicSomeChamberAutoJoiningPage] Failed to log auto-connect pause state',
          error,
        )
      }
    },
    [buildAutoConnectIoState, selectedPatientBookedEventId],
  )

  // Tab state for calendar views
  const [selectedTab, setSelectedTab] = useState(MENTOR_CLINIC_BOOKING_TABS.calendar.id)
  
  // Calendar date state
  const [selectedDate, setSelectedDate] = useState(dayjs().format('DD-MM-YYYY'))
  const isToday = dayjs().format('DD-MM-YYYY') === selectedDate

  // Action button states
  const [patientSearchOpen, setPatientSearchOpen] = useState(false)
  const [bookedSlotsDrawerOpen, setBookedSlotsDrawerOpen] = useState(false)
  const [calendarDrawerOpen, setCalendarDrawerOpen] = useState(false) // Calendar drawer for mobile
  const [combinedMenuAnchorEl, setCombinedMenuAnchorEl] = useState(null) // For 3-dots menu in drawer
  const [isRefreshingBookings, setIsRefreshingBookings] = useState(false)
  const [isLeavingSession, setIsLeavingSession] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [isVideoLandscape, setIsVideoLandscape] = useState(false) // Video view mode: false = portrait (full height), true = landscape (full width)
  const [chamberLocalParticipantIdentity, setChamberLocalParticipantIdentity] = useState(null)
  const [bookedSlotsInDay, setBookedSlotsInDay] = useState([])
  const stopAudioPreview = useCallback(() => {
    if (audioPreviewAnimationFrameRef.current) {
      cancelAnimationFrame(audioPreviewAnimationFrameRef.current)
      audioPreviewAnimationFrameRef.current = null
    }

    if (audioPreviewStreamRef.current) {
      audioPreviewStreamRef.current.getTracks().forEach((track) => {
        if (track.readyState !== 'ended') {
          track.stop()
        }
      })
      audioPreviewStreamRef.current = null
    }

    if (audioPreviewContextRef.current) {
      audioPreviewContextRef.current.close().catch(() => {})
      audioPreviewContextRef.current = null
    }

    audioPreviewAnalyserRef.current = null
    setAudioPreviewBars([...AUDIO_PREVIEW_IDLE_LEVELS])
  }, [])

  const enrichBookedEventWithPatientData = useCallback((bookedEvent, auxiliaryDataFromApi = null) => {
    if (!bookedEvent || typeof bookedEvent !== 'object') return bookedEvent

    const selectedPatientInfo =
      selectedPatientBookedEventData?.patientInfoData?.id === bookedEvent?.patientId
        ? selectedPatientBookedEventData?.patientInfoData
        : selectedPatientBookedEventData?.patientInfo?.id === bookedEvent?.patientId
          ? selectedPatientBookedEventData?.patientInfo
          : null

    const slotMatch = bookedSlotsInDay?.find(
      (slot) => slot?.id === bookedEvent?.id || slot?.slug === bookedEvent?.slug,
    )
    const patientMatchById = bookedSlotsInDay?.find((slot) => slot?.patientId === bookedEvent?.patientId)

    const auxiliaryPatientInfo = Array.isArray(auxiliaryDataFromApi?.patientInfo)
      ? auxiliaryDataFromApi.patientInfo.find((patient) => patient?.id === bookedEvent?.patientId)
      : auxiliaryDataFromApi?.patientInfo?.id === bookedEvent?.patientId
        ? auxiliaryDataFromApi.patientInfo
        : null

    const resolvedPatientInfo =
      selectedPatientInfo ??
      slotMatch?.patientInfoData ??
      slotMatch?.patientInfo ??
      patientMatchById?.patientInfoData ??
      patientMatchById?.patientInfo ??
      auxiliaryPatientInfo ??
      null

    if (!resolvedPatientInfo) return bookedEvent

    return {
      ...bookedEvent,
      patientId:
        bookedEvent?.patientId ??
        resolvedPatientInfo?.id ??
        resolvedPatientInfo?.patientId ??
        null,
      patientInfo: {
        ...(bookedEvent?.patientInfo ?? {}),
        ...resolvedPatientInfo,
      },
      patientInfoData: {
        ...(bookedEvent?.patientInfoData ?? {}),
        ...resolvedPatientInfo,
      },
      patientDateOfBirth:
        bookedEvent?.patientDateOfBirth ?? resolvedPatientInfo?.dateOfBirth ?? null,
      patientGender: bookedEvent?.patientGender ?? resolvedPatientInfo?.gender ?? null,
      patientNumber: bookedEvent?.patientNumber ?? resolvedPatientInfo?.patientNumber ?? null,
      patientName: bookedEvent?.patientName ?? resolvedPatientInfo?.name ?? bookedEvent?.userName ?? null,
    }
  }, [bookedSlotsInDay, selectedPatientBookedEventData])

  const fetchPatientInfoById = useCallback(async (patientId) => {
    if (!patientId) return null
    try {
      const response = await getDataWithParams('/api/secure/patient/get', { patientId })
      if (response?.status === 200 && response?.data?.data) {
        return response.data.data
      }
    } catch (error) {
      console.error('Error fetching patient info for booked event', error)
    }
    return null
  }, [])
  
  // Slot duration state
  const [eachSlotDurationInMins, setEachSlotDurationInMins] = useState(30)
  
  // Calendar navigation functions
  const onPrevClick = useCallback(() => {
    const newDate = dayjs(selectedDate, 'DD-MM-YYYY').subtract(1, 'day').format('DD-MM-YYYY')
    setSelectedDate(newDate)
    // Defer event dispatch to avoid updating components during render
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('calendar-date-change', { detail: { date: newDate } }))
    }, 0)
  }, [selectedDate])
  
  const onNextClick = useCallback(() => {
    const newDate = dayjs(selectedDate, 'DD-MM-YYYY').add(1, 'day').format('DD-MM-YYYY')
    setSelectedDate(newDate)
    // Defer event dispatch to avoid updating components during render
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('calendar-date-change', { detail: { date: newDate } }))
    }, 0)
  }, [selectedDate])
  
  const handleGoToToday = useCallback(() => {
    setSelectedDate(dayjs().format('DD-MM-YYYY'))
  }, [])

  // Action button handlers
  const handleOpenPatientSearch = useCallback(() => {
    setPatientSearchOpen(true)
  }, [])

  const handleOpenBookedSlotsDrawer = useCallback(() => {
    setBookedSlotsDrawerOpen(true)
  }, [])

  const handleRefreshBookings = useCallback(() => {
    // Trigger refresh using the calendar ref
    setIsRefreshingBookings(true)
    if (calendarRef.current?.refresh) {
      calendarRef.current.refresh()
    }
    // Reset the refreshing state after a short delay
    setTimeout(() => {
      setIsRefreshingBookings(false)
    }, 1000)
  }, [])
  
  const clinicSchedules = chosenClinicData?.schedules

  const therapyReportRef = useRef()
  const prescriptionRef = useRef()
  const screeningReportRef = useRef() // NEW: Ref for screening report
  const assessmentReportRef = useRef()
  const calendarRef = useRef() // Ref for calendar component

  if (!chosenClinicData) {
    navigate('/mentor-home')
  }

  useEffect(() => {
    preloadAgoraRtcUIKitModule().catch(() => {})
  }, [])

  useEffect(() => {
    const debugPayload = {
      componentPath: 'predecided-clinic-chamber',
      clinicBrandId,
      clinicLocationId,
      chamberRoomId: serverGivenNextAction?.channel?.chamberRoomId || chamberRoomId || null,
      joinedChannelName: joinedChannelName || null,
      chamberScreenState: chamberScreenStateNow,
      debugVersion: 'mentor-chamber-shared-renderer-v1',
      rtcSurface: 'shared-renderer-agora-surface',
    }

    if (typeof window !== 'undefined') {
      window.__AUMHUM_MENTOR_CHAMBER_RTC_DEBUG__ = debugPayload
    }

    console.info('[MentorClinicSomeChamberAutoJoiningPage] RTC surface', debugPayload)
  }, [
    chamberRoomId,
    chamberScreenStateNow,
    clinicBrandId,
    clinicLocationId,
    joinedChannelName,
    serverGivenNextAction?.channel?.chamberRoomId,
  ])

  const getAndHandleNextAction = async (options = {}) => {
    // Don't poll for server actions if we're in a booked event session
    if (isInBookedEventSession) {
      return
    }

    if (
      options?.force !== true &&
      autoConnectPausedUntil &&
      autoConnectPausedUntil > Date.now()
    ) {
      return
    }
    
    const response = await getCPDataWithParams(
      `/api/secure/teacher/mentor-screen/get-next-action`,
      {
        clinicLocationId: clinicLocationId,
        screenState: chamberScreenStateNow,
        joinedChannelName: agoraRtcProps?.channel,
        chamberRoomId: chamberRoomId,
      },
    )
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      handleIncomingNextActionFromServer(response?.data?.data)
      setServerGivenNextAction(response?.data?.data)
    } else {
      showNotification.error('Error getting next action')
    }
  }

  useEffect(() => {
    getAndHandleNextActionRef.current = getAndHandleNextAction
  }, [getAndHandleNextAction])

  const handleResumeAutoConnect = useCallback(
    async ({ source = 'manual', pauseDurationMs = null } = {}) => {
      if (autoConnectResumeInFlightRef.current) {
        return
      }

      const pausedUntil = autoConnectPausedUntilRef.current
      if (!pausedUntil) {
        return
      }
      const effectivePauseDurationMs =
        pauseDurationMs || activeAutoConnectPauseDurationRef.current || null
      const logContext = activeAutoConnectLogContextRef.current || {
        bookedEventId: null,
        checkedInRoomContext: null,
      }

      autoConnectResumeInFlightRef.current = true
      autoConnectPausedUntilRef.current = null
      activeAutoConnectPauseDurationRef.current = null
      activeAutoConnectLogContextRef.current = {
        bookedEventId: null,
        checkedInRoomContext: null,
      }
      setAutoConnectPausedUntil(null)
      setAutoConnectRemainingMs(0)

      try {
        await logAutoConnectPauseState({
          paused: false,
          pauseDurationMs: effectivePauseDurationMs,
          resumeAtEpochMs: pausedUntil,
          bookedEventId: logContext?.bookedEventId,
          checkedInRoomContext: logContext?.checkedInRoomContext,
        })
      } finally {
        autoConnectResumeInFlightRef.current = false
      }

      showNotification.success(
        source === 'timer' ? 'Auto-connect resumed automatically' : 'Auto-connect resumed',
      )
      setTimeout(() => {
        if (chamberRoomId && chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING) {
          getAndHandleNextActionRef.current?.({ force: true })
        }
      }, 0)
    },
    [chamberRoomId, chamberScreenStateNow, logAutoConnectPauseState],
  )

  const handlePauseAutoConnect = useCallback(async () => {
    const nextPauseDuration = Number(autoConnectPauseDurationMs) || AUTO_CONNECT_PAUSE_OPTIONS[2].value
    const resumeAtEpochMs = Date.now() + nextPauseDuration
    const checkedInRoomContext = readCheckedInRoomContext()
    activeAutoConnectPauseDurationRef.current = nextPauseDuration
    activeAutoConnectLogContextRef.current = {
      bookedEventId: selectedPatientBookedEventId || null,
      checkedInRoomContext,
    }
    autoConnectPausedUntilRef.current = resumeAtEpochMs
    setAutoConnectPausedUntil(resumeAtEpochMs)
    setAutoConnectRemainingMs(nextPauseDuration)
    await logAutoConnectPauseState({
      paused: true,
      pauseDurationMs: nextPauseDuration,
      resumeAtEpochMs,
      bookedEventId: selectedPatientBookedEventId,
      checkedInRoomContext,
    })
    showNotification.info(`Auto-connect paused for ${formatAutoConnectRemaining(nextPauseDuration)}`)
  }, [autoConnectPauseDurationMs, logAutoConnectPauseState, selectedPatientBookedEventId])

  async function handleIncomingNextActionFromServer(nextActionData) {
    // Don't override if we're in a booked event session
    if (isInBookedEventSession) {
      return
    }
    
    const data = nextActionData?.chamberScreenAction
    switch (data?.action) {
      case CHAMBER_SCREEN_ACTIONS.ACTION_JOIN:
        try {
          showNotification.info('Server commanded to join a session...')
          
          await sleep(5000)
          
          await joinAgoraChannelAndStartVideo(data)

          // Call askCheckedInChamberScreenToPollNextAction only after joinAgoraChannelAndStartVideo completes
          const chamberRoomIdForSignal = nextActionData?.channel?.chamberRoomId
          
          if (chamberRoomIdForSignal) {
            await askCheckedInChamberScreenToPollNextAction(chamberRoomIdForSignal)
          }
        } catch (error) {
          showNotification.error('Error joining session. Please try again.')
          // Don't rethrow - allow the function to continue processing other actions
        }
        break
      case CHAMBER_SCREEN_ACTIONS.ACTION_CONTINUE_SESSION:
        // toast.info('Server commanded to continue session...')
        setTimeout(() => continueSession(data), 5000)
        break
      case CHAMBER_SCREEN_ACTIONS.ACTION_LEAVE:
        showNotification.info('Server commanded to leave the current session...')
        setTimeout(() => {
          leaveThisSession()
        }, 5000)
        break
      case CHAMBER_SCREEN_ACTIONS.ACTION_CONTINUE_IDLING:
        // toast.info('Server commanded to continue idling...')
        setTimeout(() => continueIdling(data), 5000)
        break
      default:
        // Unknown action received
        break
    }
  }

  async function informChamberRoomChannelJoin(channelName) {
    const responseOne = await getCPDataWithParams(
      `/api/secure/teacher/mentor-screen/chamber-room-channel/log/join`,
      {
        channelName: channelName,
      },
    )
    // Channel join logged to server
  }

  async function informChamberRoomChannelLeave(channelName) {
    const responseOne = await getCPDataWithParams(
      `/api/secure/teacher/mentor-screen/chamber-room-channel/log/leave`,
      {
        channelName: channelName,
      },
    )
    // Channel leave logged to server
  }

  // Load available devices only when a patient is selected
  // Skip device loading for offline meetings to avoid browser permission prompts
  // Don't load devices just because mentor is checked in - wait until patient is selected
  useEffect(() => {
    // CRITICAL: Check ref FIRST - this is the source of truth set synchronously in getAndSetPatientBookedEventDetails
    // If ref says offline, return immediately without any checks that might trigger device enumeration
    if (isOfflineMeetingRef.current) {
      setAvailableCameras([])
      setAvailableMicrophones([])
      setAvailableSpeakers([])
      return // Don't proceed with device loading - CRITICAL to prevent permission requests
    }
    
    // If no patient is selected and camera/mic are not enabled, don't load devices
    // But if camera/mic are enabled, allow device loading for preview
    if (!selectedPatientBookedEventData && !isCameraOpen && !isAudioOpen) {
      // Don't clear devices if they're already loaded and camera/mic are enabled
      // This allows device dropdowns to remain populated when user enables camera/mic
      if (availableCameras.length === 0 && availableMicrophones.length === 0) {
        return
      }
    }
    
    // Check meetingSrc as additional safeguard (ref should already be set, but double-check)
    const meetingSrc = selectedPatientBookedEventData?.meetingSrc
    const isOffline = meetingSrc === 'offline'
    
    // Update ref to track offline status immediately (synchronously)
    // This ensures ref is always in sync with current data
    isOfflineMeetingRef.current = isOffline
    
    // For offline meetings, explicitly set empty device lists and return early
    // Do this BEFORE any async operations that might request permissions
    if (isOffline) {
      setAvailableCameras([])
      setAvailableMicrophones([])
      setAvailableSpeakers([])
      return // Don't proceed with device loading - CRITICAL to prevent permission requests
    }
    
    // Load devices when:
    // 1. We're in IDLING state (checked in)
    // 2. Either a patient is selected OR camera/mic are enabled (for preview)
    // 3. The meeting is NOT offline (ref is false AND meetingSrc is not 'offline')
    const shouldLoadDevices = 
      chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING &&
      !isOfflineMeetingRef.current &&
      (selectedPatientBookedEventData || isCameraOpen || isAudioOpen) &&
      (!selectedPatientBookedEventData || meetingSrc !== 'offline')
    
    if (shouldLoadDevices) {
      const loadDevices = async () => {
        // Final check before calling functions that might request permissions
        // This is a safety check in case state changed during async operation
        // Check ref FIRST, then data
        if (isOfflineMeetingRef.current) {
          return
        }

        if (!selectedPatientBookedEventData || selectedPatientBookedEventData.meetingSrc === 'offline') {
          return
        }
        
        try {
          // Check permissions first - some browsers require permissions before device enumeration
          let hasCameraPermission = false
          let hasMicrophonePermission = false
          
          try {
            if (navigator.permissions) {
              const [cameraPerm, micPerm] = await Promise.all([
                navigator.permissions.query({ name: 'camera' }).catch(() => ({ state: 'prompt' })),
                navigator.permissions.query({ name: 'microphone' }).catch(() => ({ state: 'prompt' })),
              ])
              hasCameraPermission = cameraPerm.state === 'granted'
              hasMicrophonePermission = micPerm.state === 'granted'
            }
          } catch (permError) {
            // Permissions API not available, try to request permissions via getUserMedia
          }
          
          // Request permissions if not granted (this enables device enumeration)
          if (!hasCameraPermission || !hasMicrophonePermission) {
            try {
              const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true,
              })
              // Stop the stream immediately - we just needed permissions
              stream.getTracks().forEach(track => track.stop())
              hasCameraPermission = true
              hasMicrophonePermission = true
            } catch (mediaError) {
              // Continue anyway - some browsers allow device enumeration without permissions
            }
          }
          
          // Load devices - these may return empty arrays if permissions aren't granted
          // but we'll try anyway as some browsers allow enumeration without permissions
          const [cameras, microphones, speakers] = await Promise.all([
            AgoraRTC.getCameras().catch(err => {
              // Suppress permission errors - they're expected if permissions weren't granted
              if (err?.code === 'PERMISSION_DENIED' || err?.name === 'NotAllowedError' || err?.message?.includes('Permission denied')) {
                return []
              }
              // Log other unexpected errors
              console.warn('Error getting cameras:', err)
              return []
            }),
            AgoraRTC.getMicrophones().catch(err => {
              // Suppress permission errors
              if (err?.code === 'PERMISSION_DENIED' || err?.name === 'NotAllowedError' || err?.message?.includes('Permission denied')) {
                return []
              }
              // Log other unexpected errors
              console.warn('Error getting microphones:', err)
              return []
            }),
            AgoraRTC.getPlaybackDevices().catch(err => {
              // Check if it's a permission error (some browsers may require permissions for speakers)
              const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                      err?.name === 'NotAllowedError' || 
                                      err?.message?.includes('Permission denied') ||
                                      err?.message?.includes('PERMISSION_DENIED')
              if (isPermissionError) {
                // Don't log permission errors for speakers
                return []
              }
              // Log other unexpected errors (but not permission errors)
              console.warn('Error getting speakers:', err)
              return []
            }),
          ])
          
          // Update state with devices
          if (cameras.length > 0) {
            setAvailableCameras(cameras)
            const defaultCam = cameras[0].deviceId
            const localStorageCam = getSelectedCameraInLocalStorage()
            const isLocalCamAvailable = cameras.find((item) => item.deviceId === localStorageCam)
            if (localStorageCam && isLocalCamAvailable) {
              setSelectedCamera(localStorageCam)
            } else {
              setSelectedCamera(defaultCam)
              localStorage.setItem('selectedCamera', defaultCam)
            }
          } else {
            console.warn('No cameras found - permissions may not be granted or no camera available')
            setAvailableCameras([])
            setSelectedCamera('')
          }
          
          if (microphones.length > 0) {
            setAvailableMicrophones(microphones)
            const defaultMic = microphones[0].deviceId
            const localStorageMic = getSelectedMicrophoneInLocalStorage()
            const isLocalMicAvailable = microphones.find((item) => item.deviceId === localStorageMic)
            if (localStorageMic && isLocalMicAvailable) {
              setSelectedMicrophone(localStorageMic)
            } else {
              setSelectedMicrophone(defaultMic)
              localStorage.setItem('selectedMicrophone', defaultMic)
            }
          } else {
            console.warn('No microphones found - permissions may not be granted or no microphone available')
            setAvailableMicrophones([])
            setSelectedMicrophone('')
          }
          
          if (speakers.length > 0) {
            setAvailableSpeakers(speakers)
            const defaultSpeaker = speakers[0].deviceId
            const localStorageSpeaker = getSelectedSpeakerInLocalStorage()
            const isLocalSpeakerAvailable = speakers.find((item) => item.deviceId === localStorageSpeaker)
            if (localStorageSpeaker && isLocalSpeakerAvailable) {
              setSelectedSpeaker(localStorageSpeaker)
            } else {
              setSelectedSpeaker(defaultSpeaker)
              localStorage.setItem('selectedSpeaker', defaultSpeaker)
            }
          } else {
            console.warn('No speakers found')
            setAvailableSpeakers([])
            setSelectedSpeaker('')
          }
        } catch (error) {
          console.error('Error loading devices:', error)
        }
      }
      loadDevices()
    }
  }, [chamberScreenStateNow, selectedPatientBookedEventData, isCameraOpen, isAudioOpen])

  // Refresh devices when session starts (when call auto-joins)
  // This ensures device lists are populated even if initial load failed
  useEffect(() => {
    if (chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && joinedChannelName) {
      // Session has started, refresh devices to ensure UI is up to date
      const refreshDevices = async () => {
        try {
          // Check if devices are already loaded
          if (availableCameras.length === 0 || availableMicrophones.length === 0) {
            // Request permissions if needed (this enables device enumeration)
            let permissionsExplicitlyDenied = false
            try {
              const stream = await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: true,
              })
              // Stop the stream immediately - we just needed permissions
              stream.getTracks().forEach(track => track.stop())
            } catch (mediaError) {
              // Permission denied is expected if user hasn't granted access
              if (mediaError.name === 'NotAllowedError' || mediaError.name === 'PermissionDeniedError') {
                permissionsExplicitlyDenied = true
              }
            }
            
            // Don't try to enumerate devices if permissions were explicitly denied
            if (permissionsExplicitlyDenied) {
              return
            }
            
            // Load devices (permissions might already be granted or we'll handle errors gracefully)
            const [cameras, microphones, speakers] = await Promise.all([
              AgoraRTC.getCameras().catch(err => {
                // Suppress permission errors - they're expected if permissions weren't granted
                const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                        err?.name === 'NotAllowedError' || 
                                        err?.message?.includes('Permission denied') ||
                                        err?.message?.includes('PERMISSION_DENIED')
                if (isPermissionError) {
                  // Silently handle permission errors
                  return []
                }
                // Log other unexpected errors
                // Error getting cameras
                return []
              }),
              AgoraRTC.getMicrophones().catch(err => {
                // Suppress permission errors
                const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                        err?.name === 'NotAllowedError' || 
                                        err?.message?.includes('Permission denied') ||
                                        err?.message?.includes('PERMISSION_DENIED')
                if (isPermissionError) {
                  return []
                }
                // Log other unexpected errors
                // Error getting microphones
                return []
              }),
              AgoraRTC.getPlaybackDevices().catch(err => {
                // Check if it's a permission error (some browsers may require permissions for speakers)
                const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                        err?.name === 'NotAllowedError' || 
                                        err?.message?.includes('Permission denied') ||
                                        err?.message?.includes('PERMISSION_DENIED')
                if (isPermissionError) {
                  // Don't log permission errors for speakers
                  return []
                }
                // Log other unexpected errors (but not permission errors)
                // Error getting speakers
                return []
              }),
            ])
            
            // Update state with devices
            if (cameras.length > 0) {
              setAvailableCameras(cameras)
              if (!selectedCamera || !cameras.find(cam => cam.deviceId === selectedCamera)) {
                const defaultCam = cameras[0].deviceId
                setSelectedCamera(defaultCam)
                localStorage.setItem('selectedCamera', defaultCam)
              }
            }
            
            if (microphones.length > 0) {
              setAvailableMicrophones(microphones)
              if (!selectedMicrophone || !microphones.find(mic => mic.deviceId === selectedMicrophone)) {
                const defaultMic = microphones[0].deviceId
                setSelectedMicrophone(defaultMic)
                localStorage.setItem('selectedMicrophone', defaultMic)
              }
            }
            
            if (speakers.length > 0) {
              setAvailableSpeakers(speakers)
              if (!selectedSpeaker || !speakers.find(sp => sp.deviceId === selectedSpeaker)) {
                const defaultSpeaker = speakers[0].deviceId
                setSelectedSpeaker(defaultSpeaker)
                localStorage.setItem('selectedSpeaker', defaultSpeaker)
              }
            }
          }
        } catch (error) {
          console.error('[Device Refresh] Error refreshing devices:', error)
        }
      }
      
      // Small delay to ensure permissions are granted after call starts
      const timeoutId = setTimeout(refreshDevices, 500)
      return () => clearTimeout(timeoutId)
    }
  }, [chamberScreenStateNow, joinedChannelName, availableCameras.length, availableMicrophones.length, selectedCamera, selectedMicrophone, selectedSpeaker])

  // Handle camera preview stream
  // Skip camera preview for offline meetings to avoid permission requests
  useEffect(() => {
    let currentStream = null
    
    // Don't start preview for offline meetings - check both ref and meetingSrc
    // But allow preview if no patient is selected (waiting screen)
    const isOfflineMeeting = 
      selectedPatientBookedEventData &&
      (isOfflineMeetingRef.current || selectedPatientBookedEventData?.meetingSrc === 'offline')
    
    if (
      chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING &&
      isCameraOpen &&
      selectedCamera &&
      previewVideoRef.current &&
      !isOfflineMeeting
    ) {
      const startPreview = async () => {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { deviceId: { exact: selectedCamera } },
            audio: false,
          })
          if (previewVideoRef.current) {
            previewVideoRef.current.srcObject = stream
            setPreviewStream(stream)
            currentStream = stream
          }
        } catch (error) {
          console.error('Error starting camera preview:', error)
        }
      }
      startPreview()
    } else {
      // Stop preview when camera is turned off
      setPreviewStream((prevStream) => {
        if (prevStream) {
          prevStream.getTracks().forEach(track => track.stop())
          if (previewVideoRef.current) {
            previewVideoRef.current.srcObject = null
          }
        }
        return null
      })
    }

    return () => {
      if (currentStream) {
        currentStream.getTracks().forEach(track => track.stop())
      }
      setPreviewStream((prevStream) => {
        if (prevStream) {
          prevStream.getTracks().forEach(track => track.stop())
        }
        return null
      })
    }
  }, [chamberScreenStateNow, isCameraOpen, selectedCamera, selectedPatientBookedEventData?.meetingSrc])

  useEffect(() => {
    let cancelled = false

    const isOfflineMeeting =
      selectedPatientBookedEventData &&
      (isOfflineMeetingRef.current || selectedPatientBookedEventData?.meetingSrc === 'offline')

    const startAudioPreview = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: selectedMicrophone
            ? {
                deviceId: { exact: selectedMicrophone },
              }
            : true,
          video: false,
        })

        if (cancelled) {
          stream.getTracks().forEach((track) => track.stop())
          return
        }

        const AudioContextClass = window.AudioContext || window.webkitAudioContext

        stopAudioPreview()

        if (!AudioContextClass) {
          audioPreviewStreamRef.current = stream
          setAudioPreviewBars([...AUDIO_PREVIEW_IDLE_LEVELS])
          return
        }

        const audioContext = new AudioContextClass()
        const analyser = audioContext.createAnalyser()
        const microphone = audioContext.createMediaStreamSource(stream)

        analyser.fftSize = 256
        analyser.smoothingTimeConstant = 0.82
        microphone.connect(analyser)

        audioPreviewStreamRef.current = stream
        audioPreviewContextRef.current = audioContext
        audioPreviewAnalyserRef.current = analyser

        const updateAudioPreview = () => {
          if (!audioPreviewAnalyserRef.current) {
            return
          }

          const frequencyData = new Uint8Array(
            audioPreviewAnalyserRef.current.frequencyBinCount,
          )
          audioPreviewAnalyserRef.current.getByteFrequencyData(frequencyData)
          setAudioPreviewBars(buildAudioPreviewBars(frequencyData))
          audioPreviewAnimationFrameRef.current = requestAnimationFrame(updateAudioPreview)
        }

        updateAudioPreview()
      } catch (error) {
        console.error('Error starting microphone preview:', error)
        stopAudioPreview()
      }
    }

    if (
      chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING &&
      isAudioOpen &&
      !isOfflineMeeting
    ) {
      startAudioPreview()
    } else {
      stopAudioPreview()
    }

    return () => {
      cancelled = true
      stopAudioPreview()
    }
  }, [
    chamberScreenStateNow,
    isAudioOpen,
    selectedMicrophone,
    selectedPatientBookedEventData?.meetingSrc,
    stopAudioPreview,
  ])

  async function joinAgoraChannelAndStartVideo(data) {
    // Don't join chamber room channel if we're in a booked event session
    // Also check if current channel is a booked event channel (not a chamber room channel)
    const currentChannel = agoraRtcProps?.channel
    const isCurrentChannelBookedEvent = currentChannel && !currentChannel.includes('chamber-room') && !currentChannel.includes('CHAMBER')
    
    if (isInBookedEventSession || isCurrentChannelBookedEvent) {
      return
    }
    
    // Stop preview stream before joining
    setPreviewStream((prevStream) => {
      if (prevStream) {
        prevStream.getTracks().forEach(track => track.stop())
        if (previewVideoRef.current) {
          previewVideoRef.current.srcObject = null
        }
      }
      return null
    })
    stopAudioPreview()
    
    // Validate and refresh device IDs before joining to prevent NotFoundError
    // Also load devices to populate UI dropdowns even if camera/audio aren't enabled yet
    let validCameraDeviceId = undefined
    let validMicrophoneDeviceId = undefined
    
    try {
      // Track permission state to provide better UI feedback
      let cameraPermissionDenied = false
      let microphonePermissionDenied = false
      let speakerError = false
      
      // Always load all devices to populate UI dropdowns, not just when camera/audio are enabled
      // This ensures device lists are available in the UI
      const [currentCameras, currentMicrophones, currentSpeakers] = await Promise.all([
        AgoraRTC.getCameras().catch(err => {
          // Check if it's a permission error
          const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                   err?.name === 'NotAllowedError' || 
                                   err?.message?.includes('Permission denied') ||
                                   err?.message?.includes('PERMISSION_DENIED')
          
          if (isPermissionError) {
            cameraPermissionDenied = true
            return []
          }
          // Log other unexpected errors
          // Error getting cameras
          return []
        }),
        AgoraRTC.getMicrophones().catch(err => {
          // Check if it's a permission error
          const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                   err?.name === 'NotAllowedError' || 
                                   err?.message?.includes('Permission denied') ||
                                   err?.message?.includes('PERMISSION_DENIED')
          
          if (isPermissionError) {
            microphonePermissionDenied = true
            return []
          }
          // Log other unexpected errors
          // Error getting microphones
          return []
        }),
        AgoraRTC.getPlaybackDevices().catch(err => {
          // Check if it's a permission error (some browsers may require permissions for speakers)
          const isPermissionError = err?.code === 'PERMISSION_DENIED' || 
                                   err?.name === 'NotAllowedError' || 
                                   err?.message?.includes('Permission denied') ||
                                   err?.message?.includes('PERMISSION_DENIED')
          
          if (isPermissionError) {
            // Speakers typically don't require permissions, but some browsers might throw this
            // Don't show a warning for permission errors on speakers
            return []
          }
          // Log other unexpected errors (but not permission errors)
          speakerError = true
          // Error getting speakers
          return []
        }),
      ])
      
      // Update camera devices in state
      if (currentCameras && currentCameras.length > 0) {
        setAvailableCameras(currentCameras)
        const defaultCam = currentCameras[0].deviceId
        const localStorageCam = getSelectedCameraInLocalStorage()
        const isLocalCamAvailable = currentCameras.find((item) => item.deviceId === localStorageCam)
        
        if (localStorageCam && isLocalCamAvailable) {
          setSelectedCamera(localStorageCam)
          if (isCameraOpen) {
            validCameraDeviceId = localStorageCam
          }
        } else {
          setSelectedCamera(defaultCam)
          localStorage.setItem('selectedCamera', defaultCam)
          if (isCameraOpen) {
            validCameraDeviceId = defaultCam
          }
        }
      } else {
        // Only log warning if it's not a permission issue
        if (!cameraPermissionDenied) {
          // No cameras available
        }
        setAvailableCameras([])
      }
      
      // Update microphone devices in state
      if (currentMicrophones && currentMicrophones.length > 0) {
        setAvailableMicrophones(currentMicrophones)
        const defaultMic = currentMicrophones[0].deviceId
        const localStorageMic = getSelectedMicrophoneInLocalStorage()
        const isLocalMicAvailable = currentMicrophones.find((item) => item.deviceId === localStorageMic)
        
        if (localStorageMic && isLocalMicAvailable) {
          setSelectedMicrophone(localStorageMic)
          if (isAudioOpen) {
            validMicrophoneDeviceId = localStorageMic
          }
        } else {
          setSelectedMicrophone(defaultMic)
          localStorage.setItem('selectedMicrophone', defaultMic)
          if (isAudioOpen) {
            validMicrophoneDeviceId = defaultMic
          }
        }
      } else {
        // Only log warning if it's not a permission issue
        if (!microphonePermissionDenied) {
          // No microphones available
        }
        setAvailableMicrophones([])
      }
      
      // Update speaker devices in state
      if (currentSpeakers && currentSpeakers.length > 0) {
        setAvailableSpeakers(currentSpeakers)
        const defaultSpeaker = currentSpeakers[0].deviceId
        const localStorageSpeaker = getSelectedSpeakerInLocalStorage()
        const isLocalSpeakerAvailable = currentSpeakers.find((item) => item.deviceId === localStorageSpeaker)
        
        if (localStorageSpeaker && isLocalSpeakerAvailable) {
          setSelectedSpeaker(localStorageSpeaker)
        } else {
          setSelectedSpeaker(defaultSpeaker)
          localStorage.setItem('selectedSpeaker', defaultSpeaker)
        }
      } else {
        // Only log warning if it's not a permission error
        if (speakerError) {
          // No speakers available
        }
        setAvailableSpeakers([])
      }
      
      // Show user-friendly toast messages if permissions are needed
      if (cameraPermissionDenied || microphonePermissionDenied) {
        const missingPermissions = []
        if (cameraPermissionDenied) missingPermissions.push('camera')
        if (microphonePermissionDenied) missingPermissions.push('microphone')
        
        toast.info(
          `Please allow ${missingPermissions.join(' and ')} access in your browser settings to use video/audio features.`,
          {
            autoClose: 5000,
            toastId: 'media-permissions-needed', // Prevent duplicate toasts
          }
        )
      }
    } catch (error) {
      console.error('[joinAgoraChannelAndStartVideo] Error validating devices:', error)
      // Continue without device IDs if validation fails - Agora will use default devices
    }
    
    await informChamberRoomChannelJoin(data?.joinChannelName)
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.SESSION_RUNNING)
    setJoinedChamberName(data?.chamberRoomName)
    setJoinedChannelName(data?.joinChannelName)
    const resolvedVideoQuality =
      data?.sessionRoutingDecision?.videoQuality || data?.videoQuality || null
    setAgoraRtcProps({
      appId: import.meta.env.VITE_AGORA_APP_ID,
      channel: data?.joinChannelName,
      uid: parseInt(data?.joinChannelUid),
      token: data?.joinChannelRtcToken,
      layout: AGORA_RTC_LAYOUTS.pin,
      role: 'host',
      enableDualStream: resolvedVideoQuality?.enableDualStream === true,
      enableAudio: isAudioOpen,
      enableVideo: isCameraOpen,
      cameraDeviceId: validCameraDeviceId,
      microphoneDeviceId: validMicrophoneDeviceId,
      videoQuality: resolvedVideoQuality,
    })
    setChamberLocalParticipantIdentity(
      readLocalParticipantIdentity(
        data,
        createMentorChamberLocalParticipantIdentity(data, mentorProfileData),
      ),
    )
    // Build RTM username as JSON string with role, name, and profilePicId
    const rtmUsername = buildMentorRtmUsername(mentorProfileData)
    let parsedUsername = null
    try {
      parsedUsername = JSON.parse(rtmUsername)
    } catch (e) {
      console.error('Error parsing RTM username:', e)
    }
    // RTM props set for chamber room
    setAgoraRtmProps({
      username: rtmUsername,
      displayUsername: true,
      token: data?.joinChannelRtmToken,
    })
  }

  // Join booked event video call channel - navigates to /l/* page
  async function joinBookedEventVideoCall(bookedEventData) {
    try {
      // Check if session is blocked (payment pending - slot held but not confirmed)
      // No one should be able to join blocked sessions
      const isSessionBlocked = 
        bookedEventData?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
        bookedEventData?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING
      
      if (isSessionBlocked) {
        toast.warning('This session is awaiting payment confirmation and cannot be joined yet.')
        return
      }
      
      // Check if this is a video call event type
      const isVideoCallEvent = 
        bookedEventData?.eventType === allAvailableEventTypes.consultation ||
        bookedEventData?.eventType === allAvailableEventTypes.therapySession ||
        bookedEventData?.eventType === allAvailableEventTypes.screening ||
        bookedEventData?.eventType === allAvailableEventTypes.assessment

      if (!isVideoCallEvent) {
        // Not a video call, just set the selected event
        setSelectedPatientBookedEventId(bookedEventData?.id)
        setPatientSelected(true)
        return
      }

      // Store current chamber room state for reconnection BEFORE closing the session
      if (joinedChannelName && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
        setOriginalChamberRoomChannel(joinedChannelName)
        // Store current Agora props in sessionStorage for reconnection
        sessionStorage.setItem('chamberRoomRtcProps', JSON.stringify(agoraRtcProps))
        sessionStorage.setItem('chamberRoomRtmProps', JSON.stringify(agoraRtmProps))
        sessionStorage.setItem('chamberRoomChannelName', joinedChannelName)
        sessionStorage.setItem('chamberRoomChamberName', joinedChamberName)
        sessionStorage.setItem(
          'chamberRoomLocalParticipantIdentity',
          JSON.stringify(chamberLocalParticipantIdentity),
        )
        sessionStorage.setItem('chamberRoomUrl', window.location.pathname)
        
        // Close the current video call session to free camera and mic
        // Stop preview stream if active
        setPreviewStream((prevStream) => {
          if (prevStream) {
            prevStream.getTracks().forEach(track => track.stop())
            if (previewVideoRef.current) {
              previewVideoRef.current.srcObject = null
            }
          }
          return null
        })
        
        // Inform server that we're leaving the chamber room channel
        await informChamberRoomChannelLeave(joinedChannelName)
        
        // Use flushSync to ensure state updates complete before navigation
        // This prevents React warnings about updating components during render
        flushSync(() => {
          setAgoraRtcProps({})
          setAgoraRtmProps({})
          setChamberLocalParticipantIdentity(null)
          setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
        })
        
        // Small delay to ensure Agora cleanup completes before navigating
        await new Promise(resolve => setTimeout(resolve, 300))
      }

      // Mark that we're joining this event
      markBookedEventLog(bookedEventData?.id, 'JOIN', 'mentor')
      
      // Navigate to live session page with return state
      const eventSlug = bookedEventData?.slug || bookedEventData?.id
      navigate(`/l/${eventSlug}`, {
        state: {
          from: 'mentor-chamber-room',
          returnUrl: window.location.pathname,
          chamberRoomId: chamberRoomId,
        },
      })
    } catch (error) {
      console.error('Error joining booked event video call:', error)
      showNotification.error('Error joining video call')
    }
  }

  function continueIdling(data) {
    setJoinedChamberName()
    setJoinedChannelName()
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
  }

  function continueSession(data) {
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.SESSION_RUNNING)
  }

  /**
   * CRITICAL FIX: Header Persistence After Leaving Session
   * 
   * This function has a specific order of operations that MUST be maintained to prevent
   * the session header from persisting on the calendar page after leaving.
   * 
   * CRITICAL ORDER OF OPERATIONS (DO NOT CHANGE):
   * 1. Set isLeavingSessionRef.current = true FIRST (line ~1102)
   *    - This prevents the menu setup useEffect from re-selecting the menu
   * 2. Refresh event data if markAsCompleted (line ~1140)
   *    - Must happen AFTER guard is set, BEFORE clearing state
   *    - The guard prevents menu re-selection even though data is refreshed
   * 3. Clear selectedOptionPatientMenu and selectedPatientBookedEventData (line ~1147)
   *    - This triggers the header management useEffect to reset header
   * 
   * DEPENDENCIES:
   * - Menu setup useEffect (line ~1821) MUST check isLeavingSessionRef.current FIRST
   * - Header management useEffect (line ~2007) watches selectedOptionPatientMenu
   * - Child report components MUST NOT set headers (they were removed)
   * 
   * IF THIS BREAKS:
   * - Check that isLeavingSessionRef.current is set BEFORE clearing selectedOptionPatientMenu
   * - Check that menu setup useEffect still has the guard check
   * - Check that header management useEffect is still watching selectedOptionPatientMenu
   * - Check that child components aren't setting headers again
   */
  async function finallyCloseBookedEvent(markAsCompleted = false) {
    // Guard against multiple simultaneous calls
    if (isClosingBookedEventRef.current) {
      return
    }
    
    // CRITICAL: Mark that we're leaving FIRST, before any state changes
    // This MUST happen before clearing selectedOptionPatientMenu to prevent the menu setup
    // useEffect from re-selecting the menu. See menu setup useEffect at line ~1821
    // 
    // IMPORTANT: If this line is moved or removed, the header will persist after leaving
    isLeavingSessionRef.current = true
    
    // Reset header IMMEDIATELY before any state changes to prevent it from being re-set
    // This must happen before setSelectedOptionPatientMenu() to ensure header is cleared
    // Reset for ALL report types: prescription, therapy_report, screening_report, assessment_report
    // Use flushSync to ensure this happens synchronously before other state updates
    flushSync(() => {
      setFlowId(null)
      setButtonTopOffset(0)
    })
    
    // Immediately set to mentor-portal to ensure calendar header shows
    // Use requestAnimationFrame to ensure this runs after the null reset but still quickly
    requestAnimationFrame(() => {
      setFlowId('mentor-portal')
    })
    
    // Only log LEAVE if we have a valid booked event ID
    const bookedEventId = selectedPatientBookedEventData?.id
    if (bookedEventId) {
      isClosingBookedEventRef.current = true
      try {
        await markBookedEventLog(bookedEventId, 'LEAVE', 'mentor')
      } catch (error) {
        console.error('Error logging LEAVE event:', error)
      } finally {
        // Reset the guard after a short delay to allow state updates to complete
        setTimeout(() => {
          isClosingBookedEventRef.current = false
        }, 1000)
      }
    }
    
    // If marking as completed, refresh event data BEFORE clearing state
    // This ensures the calendar shows the updated "completed" status
    // 
    // CRITICAL ORDER: This MUST happen:
    // 1. AFTER isLeavingSessionRef.current = true (already set above)
    // 2. BEFORE clearing selectedOptionPatientMenu (below)
    // 
    // The isLeavingSessionRef guard in the menu setup useEffect will prevent menu re-selection
    // even though we're refreshing the event data here
    if (markAsCompleted && selectedPatientBookedEventId) {
      // Verify guard is set (defensive check)
      if (!isLeavingSessionRef.current) {
        isLeavingSessionRef.current = true
      }
      
      await markBookedSessionAsCompletedFunction(selectedPatientBookedEventData)
      // Refresh event data to show updated "completed" status
      // isLeavingSessionRef is already true, so the menu setup useEffect won't re-select the menu
      await getAndSetPatientBookedEventDetails(false)
    }
    
    // Clear state in a batch to prevent multiple re-renders
    // Use flushSync to ensure these happen synchronously and in order
    flushSync(() => {
      // Clear selectedOptionPatientMenu FIRST - this will trigger the parent's useEffect
      // to automatically reset the header (since parent manages header based on this state)
      setSelectedOptionPatientMenu()
      
      // Clear selectedPatientBookedEventData - this also triggers parent's header reset
      setSelectedPatientBookedEventData(null)
      
      // Then clear other state
      setSelectedPatientBookedEventId()
      setPatientSelected(false)
      setNewWantedMenuItemId()
    })
    
    // Header will be automatically reset by the parent's useEffect that watches selectedOptionPatientMenu
    // No need to manually reset it here - the parent is the single source of truth
    
    // Remove /l/<slug> from URL when leaving session
    // Use flushSync to ensure URL is updated synchronously before any other effects run
    if (clinicBrandId && clinicLocationId) {
      const basePath = `/mentor-home/join-chamber-room/${clinicBrandId}/${clinicLocationId}`
      const currentPath = window.location.pathname // Use window.location to get absolute latest
      // If URL contains /l/, remove it immediately
      if (currentPath.includes('/l/')) {
        // Extract the slug we're removing to prevent re-adding it
        const slugMatch = currentPath.match(/\/l\/([^/]+)/)
        if (slugMatch) {
          lastRemovedSlugRef.current = slugMatch[1]
        }
        // Use navigate with replace to update URL and prevent back navigation
        flushSync(() => {
          navigate(basePath, { replace: true })
        })
        // Force a small delay to ensure URL change is processed before any effects run
        await new Promise(resolve => setTimeout(resolve, 100))
      }
    }
    
    // Keep the leaving flag set for longer to prevent URL updates from re-triggering
    // Reset after a longer delay to ensure all effects have completed
    setTimeout(() => {
      isLeavingSessionRef.current = false
      // Clear the removed slug ref after a longer delay to allow new sessions to be opened
      setTimeout(() => {
        lastRemovedSlugRef.current = null
      }, 2000) // Increased delay to prevent re-opening
    }, 1000) // Increased delay to ensure all effects have completed
    
    // If we were in a booked event video call session, reconnect to chamber room
    if (isInBookedEventSession) {
      setIsInBookedEventSession(false)
      // Leave the booked event channel
      if (joinedChannelName) {
        informChamberRoomChannelLeave(joinedChannelName)
      }
      // Reset video call state
      setJoinedChamberName()
      setJoinedChannelName()
      setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
      setAgoraRtcProps({})
      setAgoraRtmProps({})
      // Trigger reconnection to chamber room by calling getAndHandleNextAction
      // The server will send the chamber room join action
      setTimeout(() => {
        if (chamberRoomId) {
          getAndHandleNextAction()
        }
      }, 500)
    }
  }

  // Function to mark as completed without leaving the page
  async function markAsCompletedOnly() {
    if (selectedOptionPatientMenu === 'screening_report') {
      // For screening reports, use the new markAsCompletedOnly function
      await screeningReportRef?.current?.markAsCompletedOnly()
      // Mark the event as completed via API
      if (selectedPatientBookedEventData) {
        await markBookedSessionAsCompletedFunction(selectedPatientBookedEventData)
        // Refresh the event data to show updated status
        await getAndSetPatientBookedEventDetails(false)
      }
      return
    }
    
    // For other report types, fall back to closeBookedEvent
    await closeBookedEvent(true)
  }

  async function closeBookedEvent(markAsCompleted = true) {
    // Default to true - "Save & Leave Session" should always mark as completed
    if (selectedOptionPatientMenu === 'prescription') {
      setNewWantedMenuItemId('end')
      await prescriptionRef?.current?.savePrescriptionData()
    }
    if (selectedOptionPatientMenu === 'therapy_report') {
      try {
        const result = await therapyReportRef?.current?.checkAndOpenModal(markAsCompleted)
        // Therapy checkAndOpenModal only saves and returns continue/stop; it does NOT call leaveRoom.
        // When result is continue, we must call finallyCloseBookedEvent to clear state and return to calendar (same as screening).
        if (result === FLOW_STATUSES_FOR_LEAVING_SESSION.continue) {
          await finallyCloseBookedEvent(markAsCompleted)
        }
        return result
      } catch (error) {
        console.error('Error in checkAndOpenModal:', error)
        throw error
      }
    }
    if (selectedOptionPatientMenu === 'screening_report') {
      // For screening reports, checkAndOpenModal with shouldLeave=true will handle leaving
      const result = await screeningReportRef?.current?.checkAndOpenModal(markAsCompleted, true)
      if (result === FLOW_STATUSES_FOR_LEAVING_SESSION.continue) {
        await finallyCloseBookedEvent(markAsCompleted)
      }
      return result
    }

    await finallyCloseBookedEvent(markAsCompleted)
  }

  // Cleanup function to stop all media tracks (both video and audio)
  const cleanupMediaTracks = useCallback(() => {
    try {
      // Stop all tracks from any active media streams
      // This includes tracks from getUserMedia, Agora local streams, and preview streams
      
      // 1. Clean up video elements
      const videoElements = document.querySelectorAll('video')
      videoElements.forEach((video) => {
        if (video.srcObject) {
          const stream = video.srcObject
          if (stream instanceof MediaStream) {
            stream.getTracks().forEach((track) => {
              if (track.readyState !== 'ended') {
                track.stop()
              }
            })
          }
          video.srcObject = null
        }
      })

      // 2. Clean up audio elements
      const audioElements = document.querySelectorAll('audio')
      audioElements.forEach((audio) => {
        if (audio.srcObject) {
          const stream = audio.srcObject
          if (stream instanceof MediaStream) {
            stream.getTracks().forEach((track) => {
              if (track.readyState !== 'ended') {
                track.stop()
              }
            })
          }
          audio.srcObject = null
        }
      })

      // 3. Clean up preview stream if active
      setPreviewStream((prevStream) => {
        if (prevStream) {
          prevStream.getTracks().forEach((track) => {
            if (track.readyState !== 'ended') {
              track.stop()
            }
          })
          if (previewVideoRef.current) {
            previewVideoRef.current.srcObject = null
          }
        }
        return null
      })
      stopAudioPreview()

      // 4. Explicitly stop all audio and video tracks from any active streams
      const allMediaElements = document.querySelectorAll('video, audio')
      allMediaElements.forEach((element) => {
        if (element.srcObject) {
          const stream = element.srcObject
          if (stream instanceof MediaStream) {
            stream.getAudioTracks().forEach((audioTrack) => {
              if (audioTrack.readyState !== 'ended') {
                audioTrack.stop()
              }
            })
            stream.getVideoTracks().forEach((videoTrack) => {
              if (videoTrack.readyState !== 'ended') {
                videoTrack.stop()
              }
            })
          }
        }
      })

      // 5. Clean up any tracked streams in global scope (if used)
      if (window.localMediaStreams && Array.isArray(window.localMediaStreams)) {
        window.localMediaStreams.forEach((stream) => {
          if (stream instanceof MediaStream) {
            stream.getTracks().forEach((track) => {
              if (track.readyState !== 'ended') {
                track.stop()
              }
            })
          }
        })
        window.localMediaStreams = []
      }
    } catch (error) {
      console.error('Error cleaning up media tracks:', error)
    }
  }, [stopAudioPreview])

  async function leaveThisSession() {
    // Cleanup all media tracks (camera and microphone) before leaving
    cleanupMediaTracks()
    
    informChamberRoomChannelLeave(joinedChannelName)
    setJoinedChamberName()
    setJoinedChannelName()
    setChamberScreenStateNow(CHAMBER_SCREEN_STATES.IDLING)
    setAgoraRtcProps({})
    setAgoraRtmProps({})
    
    // If we were in a booked event session, reconnect to chamber room
    if (isInBookedEventSession) {
      setIsInBookedEventSession(false)
      // Trigger reconnection to chamber room
      setTimeout(() => {
        if (chamberRoomId) {
          getAndHandleNextAction()
        }
      }, 500)
    }
  }

  const handleRefreshStatusForUser = useCallback(() => {
    if (!selectedPatientBookedEventId) return
    markBookedEventLog(selectedPatientBookedEventId, 'REFRESH', 'mentor', {
      camera: isCameraOpenRef.current,
      mic: isAudioOpenRef.current,
    })
  }, [selectedPatientBookedEventId])

  useEffect(() => {
    let interval = null
    if (selectedPatientBookedEventId) {
      // Immediately log status when session starts
      handleRefreshStatusForUser()
      // Set up periodic logging every 3 minutes (180000ms)
      interval = setInterval(() => {
        handleRefreshStatusForUser()
      }, 180000)
    }
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [selectedPatientBookedEventId, handleRefreshStatusForUser])

  // Log camera/mic state changes immediately when they toggle (without resetting the interval)
  // Use refs to track previous values and only log when they actually change
  const prevCameraStateRef = useRef(isCameraOpen)
  const prevAudioStateRef = useRef(isAudioOpen)
  const prevBookedEventIdRef = useRef(selectedPatientBookedEventId)

  useEffect(() => {
    // If session changed (new session started or ended), reset tracking refs
    // This ensures we don't log on session start (interval effect handles that)
    if (prevBookedEventIdRef.current !== selectedPatientBookedEventId) {
      prevBookedEventIdRef.current = selectedPatientBookedEventId
      prevCameraStateRef.current = isCameraOpen
      prevAudioStateRef.current = isAudioOpen
      return
    }

    // Only log if we have an active session and the state actually changed
    if (selectedPatientBookedEventId) {
      const cameraChanged = prevCameraStateRef.current !== isCameraOpen
      const audioChanged = prevAudioStateRef.current !== isAudioOpen

      if (cameraChanged || audioChanged) {
        // Log the state change immediately
        markBookedEventLog(selectedPatientBookedEventId, 'REFRESH', 'mentor', {
          camera: isCameraOpen,
          mic: isAudioOpen,
        })

        // Update refs to track current state
        prevCameraStateRef.current = isCameraOpen
        prevAudioStateRef.current = isAudioOpen
      }
    }
  }, [isCameraOpen, isAudioOpen, selectedPatientBookedEventId])

  // Store channel in ref to avoid recreating interval unnecessarily
  const currentChannelRef = useRef(agoraRtcProps?.channel)
  useEffect(() => {
    currentChannelRef.current = agoraRtcProps?.channel
  }, [agoraRtcProps?.channel])

  useEffect(() => {
    if (!autoConnectPausedUntil) {
      setAutoConnectRemainingMs(0)
      return
    }

    const syncPauseState = () => {
      const remaining = Math.max(0, autoConnectPausedUntil - Date.now())

      if (remaining <= 0) {
        handleResumeAutoConnect({ source: 'timer' })
        return
      }

      setAutoConnectRemainingMs(remaining)
    }

    syncPauseState()
    const intervalId = setInterval(syncPauseState, 1000)

    return () => {
      clearInterval(intervalId)
    }
  }, [
    autoConnectPausedUntil,
    chamberRoomId,
    chamberScreenStateNow,
    handleResumeAutoConnect,
  ])

  useEffect(() => {
    if (chamberRoomId) {
      getAndHandleNextAction() // Initial call
    }
  }, [chamberRoomId])

  // Cleanup media tracks on component unmount
  useEffect(() => {
    return () => {
      cleanupMediaTracks()
    }
  }, [cleanupMediaTracks])

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (chamberRoomId) {
        getAndHandleNextAction()
      }
    }, 60000)
    return () => {
      clearInterval(intervalId)
    }
    // Only recreate interval when these core values change, not when agoraRtcProps object reference changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chamberRoomId, chamberScreenStateNow, clinicLocationId])

  // Periodically check chamber screen status
  useEffect(() => {
    if (!chamberRoomId) {
      setChamberScreenStatus('unknown')
      return
    }

    // Initial check
    const checkStatus = async () => {
      try {
        const status = await checkChamberScreenStatus(chamberRoomId)
        setChamberScreenStatus(status)
      } catch (error) {
        console.error('[MENTOR PORTAL] Error checking chamber screen status:', error)
        setChamberScreenStatus('unknown')
      }
    }

    checkStatus()

    // Check every 30 seconds
    const statusIntervalId = setInterval(() => {
      checkStatus()
    }, 30000)

    return () => {
      clearInterval(statusIntervalId)
    }
  }, [chamberRoomId])

  // Auto-refresh calendar bookings (similar to calendar page)
  useEffect(() => {
    // Only auto-refresh when viewing calendar tab
    if (selectedTab !== MENTOR_CLINIC_BOOKING_TABS.calendar.id) {
      return
    }
    
    // Initial refresh
    if (calendarRef.current?.refresh) {
      calendarRef.current.refresh()
    }
    
    // Scroll to current time when returning to calendar view
    // Only scroll if viewing today's date
    const isToday = dayjs().format('DD-MM-YYYY') === selectedDate
    if (isToday && calendarRef.current?.scrollToPresentLine) {
      // Small delay to ensure calendar is rendered
      setTimeout(() => {
        calendarRef.current?.scrollToPresentLine()
      }, 500)
    }
    
    // Set up interval to refresh every 75 seconds (same as calendar page)
    const intervalId = setInterval(() => {
      if (calendarRef.current?.refresh) {
        calendarRef.current.refresh()
      }
    }, 75000)
    
    return () => {
      clearInterval(intervalId)
    }
  }, [selectedTab, selectedDate]) // Refresh when tab or date changes

  // interaction part:

  async function getAndSetPatientBookedEventDetails(updateBookedEventDatOnly = false) {
    if (!selectedPatientBookedEventId) {
      return null
    }

    const bookedEventDetailResponse = await getDataWithoutParams(
      `/api/secure/user/booked-slot/details?eventId=${selectedPatientBookedEventId}&send-auxiliary-data=true`,
    )
    if (
      isCommonResponseSuccessful(bookedEventDetailResponse?.data?.code) &&
      Object.keys(bookedEventDetailResponse?.data?.data?.bookedEvent)?.length !== 0
    ) {
      const { bookedEvent, ...auxiliaryDataFromApi } = bookedEventDetailResponse.data.data
      const backendSessionRoutingDecision =
        auxiliaryDataFromApi?.sessionRoutingDecision || bookedEvent?.sessionRoutingDecision || null
      const routingContext = resolveSessionRoutingContext({
        flowType: FLOW_TYPES.mentorChamberAutoJoin,
        sessionData: {
          ...bookedEvent,
          sessionRoutingDecision: backendSessionRoutingDecision,
        },
        sessionRoutingDecision: backendSessionRoutingDecision,
      })
      const routedBookedEvent = decorateSessionWithRouting(bookedEvent, {
        flowType: FLOW_TYPES.mentorChamberAutoJoin,
        sessionRoutingDecision:
          backendSessionRoutingDecision || routingContext.sessionRoutingDecision,
      })
      const routedAuxiliaryData = {
        ...auxiliaryDataFromApi,
        sessionInterfaceId: readSessionInterfaceId(
          auxiliaryDataFromApi,
          FLOW_TYPES.mentorChamberAutoJoin,
        ),
        localParticipantIdentity: readLocalParticipantIdentity(
          auxiliaryDataFromApi,
          createBookedEventLocalParticipantIdentity(bookedEvent, bookedEvent?.userRole),
        ),
        legacyPlatformId: routingContext.legacyPlatformId,
        sessionMode: routingContext.sessionMode,
        rtcProviderResolved: routingContext.rtcProviderResolved,
        signalingProviderResolved: routingContext.signalingProviderResolved,
        sessionRoutingDecision:
          backendSessionRoutingDecision || routingContext.sessionRoutingDecision,
      }
      
      // Immediately check if this is an offline meeting and set the ref
      if (routedBookedEvent?.meetingSrc === 'offline') {
        isOfflineMeetingRef.current = true
        // Clear devices immediately for offline meetings
        setAvailableCameras([])
        setAvailableMicrophones([])
        setAvailableSpeakers([])
      } else {
        isOfflineMeetingRef.current = false
      }
      
      let enrichedBookedEvent = enrichBookedEventWithPatientData(
        routedBookedEvent,
        routedAuxiliaryData,
      )
      if (!(
        enrichedBookedEvent?.patientInfoData?.dateOfBirth ||
        enrichedBookedEvent?.patientInfo?.dateOfBirth ||
        enrichedBookedEvent?.patientDateOfBirth
      )) {
        const fetchedPatientInfo = await fetchPatientInfoById(routedBookedEvent?.patientId)
        if (fetchedPatientInfo) {
          enrichedBookedEvent = enrichBookedEventWithPatientData(routedBookedEvent, {
            ...routedAuxiliaryData,
            patientInfo: fetchedPatientInfo,
          })
        }
      }

      if (updateBookedEventDatOnly) {
        setSelectedPatientBookedEventData(enrichedBookedEvent)
      } else {
        setAuxiliaryData(routedAuxiliaryData)
        setSelectedPatientBookedEventData(enrichedBookedEvent)
      }

      return enrichedBookedEvent
    }

    return null
  }

  // Function to get event by slug (for URL-based session opening)
  async function getEventBySlug(slug) {
    try {
      const response = await getDataWithoutParams(
        `/api/secure/user/booked-slot/details?slug=${slug}&send-auxiliary-data=true`,
      )
      if (
        isCommonResponseSuccessful(response?.data?.code) &&
        Object.keys(response?.data?.data?.bookedEvent)?.length !== 0
      ) {
        const { bookedEvent, ...auxiliaryDataFromApi } = response.data.data
        const backendSessionRoutingDecision =
          auxiliaryDataFromApi?.sessionRoutingDecision || bookedEvent?.sessionRoutingDecision || null
        const routingContext = resolveSessionRoutingContext({
          flowType: FLOW_TYPES.mentorChamberAutoJoin,
          sessionData: {
            ...bookedEvent,
            sessionRoutingDecision: backendSessionRoutingDecision,
          },
          sessionRoutingDecision: backendSessionRoutingDecision,
        })
        const routedBookedEvent = decorateSessionWithRouting(bookedEvent, {
          flowType: FLOW_TYPES.mentorChamberAutoJoin,
          sessionRoutingDecision:
            backendSessionRoutingDecision || routingContext.sessionRoutingDecision,
        })
        const routedAuxiliaryData = {
          ...auxiliaryDataFromApi,
          sessionInterfaceId: readSessionInterfaceId(
            auxiliaryDataFromApi,
            FLOW_TYPES.mentorChamberAutoJoin,
          ),
          localParticipantIdentity: readLocalParticipantIdentity(
            auxiliaryDataFromApi,
            createBookedEventLocalParticipantIdentity(bookedEvent, bookedEvent?.userRole),
          ),
          legacyPlatformId: routingContext.legacyPlatformId,
          sessionMode: routingContext.sessionMode,
          rtcProviderResolved: routingContext.rtcProviderResolved,
          signalingProviderResolved: routingContext.signalingProviderResolved,
          sessionRoutingDecision:
            backendSessionRoutingDecision || routingContext.sessionRoutingDecision,
        }
        let enrichedBookedEvent = enrichBookedEventWithPatientData(
          routedBookedEvent,
          routedAuxiliaryData,
        )
        if (!(
          enrichedBookedEvent?.patientInfoData?.dateOfBirth ||
          enrichedBookedEvent?.patientInfo?.dateOfBirth ||
          enrichedBookedEvent?.patientDateOfBirth
        )) {
          const fetchedPatientInfo = await fetchPatientInfoById(routedBookedEvent?.patientId)
          if (fetchedPatientInfo) {
            enrichedBookedEvent = enrichBookedEventWithPatientData(routedBookedEvent, {
              ...routedAuxiliaryData,
              patientInfo: fetchedPatientInfo,
            })
          }
        }
        setAuxiliaryData(routedAuxiliaryData)
        setSelectedPatientBookedEventData(enrichedBookedEvent)
        setSelectedPatientBookedEventId(bookedEvent?.id)
        setPatientSelected(true)
        return bookedEvent
      }
    } catch (error) {
      console.error('Error fetching event by slug:', error)
    }
    return null
  }

  async function setup() {
    setPatientBookedSlotDetailsLoading(true)
    if (selectedPatientBookedEventId) {
      await getAndSetPatientBookedEventDetails()
    } else if (sessionSlug) {
      await getEventBySlug(sessionSlug)
    }
    setPatientBookedSlotDetailsLoading(false)
  }

  const selectedPatientId = resolveBookedEventPatientId(selectedPatientBookedEventData)
  const selectedPatientEventType = resolveBookedEventReportType(
    selectedPatientBookedEventData,
    auxiliaryData,
  )
  const selectedPatientClinicId =
    selectedPatientBookedEventData?.clinicId || chosenClinicData?.id || null
  const selectedPatientClinicBrandId =
    selectedPatientBookedEventData?.clinicBrandId || chosenClinicData?.clinicBrandId || ''

  const allowPrescribing =
    selectedPatientId &&
    (getAllRolesInBoolean().isDoctor ||
      selectedPatientEventType === allAvailableEventTypes.consultation) &&
    mentorProfileData?.allowedToPrescribe

  const allowTherapyReport =
    selectedPatientId && selectedPatientEventType === allAvailableEventTypes.therapySession
  const allowAssessmentReport =
    selectedPatientId && selectedPatientEventType === allAvailableEventTypes.assessment

  const allowScreeningReport =
    selectedPatientId && selectedPatientEventType === allAvailableEventTypes.screening

  function showPaymentQrToPatient(paymentLinkWithPatientDetails) {
    if (paymentLinkWithPatientDetails?.userPaymentLink?.paymentLink) {
      showSnackBar(
        'Showing payment QR with patient details on room screen',
        200,
        serverGivenNextAction?.channel?.chamberRoomId,
      )
    } else {
      showSnackBar(
        'Showing created patient details on room screen',
        200,
        serverGivenNextAction?.channel?.chamberRoomId,
      )
    }

    sendShowImageCommandToChamberScreen(
      serverGivenNextAction?.channel?.chamberRoomId,
      'event-booking-payment-qr-with-patient-details',
      paymentLinkWithPatientDetails,
    )
  }

  // Desktop horizontal resizer - waits for refs to be ready
  useEffect(() => {
    if (isMobile) {
      return undefined
    }

    let cleanup = null
    let interval = null
    const minLeftWidth = 200
    const minRightWidth = 400

    // Check if refs are ready
    const checkRefs = () => {
      const dragger = refLeft?.current
      const leftPanel = refVideoContainer?.current
      const rightPanel = refBox?.current

      if (!dragger || !leftPanel || !rightPanel) {
        return false
      }

      // Check if resizer is visible (not hidden on mobile)
      const resizerStyles = window.getComputedStyle(dragger)
      const isVisible = resizerStyles.display !== 'none'

      if (!isVisible) {
        return false
      }

      return true
    }

    function setupResizer() {
      const dragger = refLeft?.current
      const leftPanel = refVideoContainer?.current
      const rightPanel = refBox?.current

      if (!dragger || !leftPanel || !rightPanel) {
        return null
      }

      let startX = 0
      let startLeftWidth = 0
      let startRightWidth = 0
      let isDragging = false

      const applyPanelWidths = (leftWidth, rightWidth) => {
        leftPanel.style.width = `${leftWidth}px`
        leftPanel.style.flexShrink = '0'
        leftPanel.style.flexGrow = '0'
        leftPanel.style.flexBasis = `${leftWidth}px`

        rightPanel.style.width = `${rightWidth}px`
        rightPanel.style.flexShrink = '0'
        rightPanel.style.flexGrow = '0'
        rightPanel.style.flexBasis = `${rightWidth}px`
      }

      /**
       * Get clientX from either mouse or touch event
       */
      const getClientX = (e) => {
        return e.touches ? e.touches[0].clientX : e.clientX
      }

      const getAvailableWidth = () => {
        const separatorWidth = dragger.getBoundingClientRect().width || dragger.offsetWidth || 0
        const containerWidth =
          dragger.parentElement?.getBoundingClientRect().width ||
          leftPanel.offsetWidth + rightPanel.offsetWidth + separatorWidth

        return Math.max(minLeftWidth + minRightWidth, containerWidth - separatorWidth)
      }

      const getNextWidths = (deltaX) => {
        const availableWidth = getAvailableWidth()
        const minDelta = minLeftWidth - startLeftWidth
        const maxDelta = startRightWidth - minRightWidth
        const boundedDelta = Math.min(maxDelta, Math.max(minDelta, deltaX))
        const nextLeftWidth = Math.min(
          availableWidth - minRightWidth,
          Math.max(minLeftWidth, startLeftWidth + boundedDelta),
        )
        const nextRightWidth = Math.max(minRightWidth, availableWidth - nextLeftWidth)

        return { nextLeftWidth, nextRightWidth }
      }

      /**
       * Handle movement during drag (works for both mouse and touch)
       * Calculates new panel widths and applies them in real-time
       */
      const handleMove = (e) => {
        if (!isDragging) return

        if (e.touches) {
          e.preventDefault()
        }

        const currentX = getClientX(e)
        const deltaX = currentX - startX
        const { nextLeftWidth, nextRightWidth } = getNextWidths(deltaX)
        applyPanelWidths(nextLeftWidth, nextRightWidth)
      }

      /**
       * Handle end of drag - clean up event listeners and reset styles
       */
      const handleEnd = () => {
        isDragging = false
        document.removeEventListener('mousemove', handleMove)
        document.removeEventListener('mouseup', handleEnd)
        document.removeEventListener('touchmove', handleMove)
        document.removeEventListener('touchend', handleEnd)
        document.removeEventListener('touchcancel', handleEnd)
        window.removeEventListener('blur', handleEnd)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
        document.body.style.touchAction = ''
      }

      /**
       * Handle start of drag (works for both mouse and touch)
       */
      const handleStart = (e) => {
        if (!e.touches && e.button !== undefined && e.button !== 0) {
          return
        }

        e.preventDefault()
        e.stopPropagation()

        // Store initial state
        startX = getClientX(e)
        startLeftWidth = leftPanel.offsetWidth
        startRightWidth = rightPanel.offsetWidth
        isDragging = true

        // Set drag cursor and disable text selection
        document.body.style.cursor = 'col-resize'
        document.body.style.userSelect = 'none'
        document.body.style.touchAction = 'none' // Prevent scrolling while dragging

        // Add document-level event listeners for smooth dragging
        if (e.touches) {
          // Touch events
          document.addEventListener('touchmove', handleMove, { passive: false })
          document.addEventListener('touchend', handleEnd)
          document.addEventListener('touchcancel', handleEnd)
        } else {
          // Mouse events
          document.addEventListener('mousemove', handleMove)
          document.addEventListener('mouseup', handleEnd)
        }

        window.addEventListener('blur', handleEnd)
      }

      // Attach event listeners for both mouse and touch
      dragger.addEventListener('mousedown', handleStart, true) // Use capture phase
      dragger.addEventListener('touchstart', handleStart, { passive: false, capture: true })

      // Return cleanup function
      return () => {
        isDragging = false
        dragger.removeEventListener('mousedown', handleStart, true)
        dragger.removeEventListener('touchstart', handleStart, true)
        document.removeEventListener('mousemove', handleMove)
        document.removeEventListener('mouseup', handleEnd)
        document.removeEventListener('touchmove', handleMove)
        document.removeEventListener('touchend', handleEnd)
        document.removeEventListener('touchcancel', handleEnd)
        window.removeEventListener('blur', handleEnd)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
        document.body.style.touchAction = ''
      }
    }

    // Wait for refs to be ready
    if (!checkRefs()) {
      // Set up interval to check periodically until refs are ready
      interval = setInterval(() => {
        if (checkRefs()) {
          clearInterval(interval)
          cleanup = setupResizer()
        }
      }, 100)
    } else {
      // Refs are ready, set up immediately
      cleanup = setupResizer()
    }

    return () => {
      if (interval) {
        clearInterval(interval)
      }
      if (cleanup) {
        cleanup()
      }
    }
  }, [chamberScreenStateNow, isMobile])

  useEffect(() => {
    // CRITICAL GUARD: Don't set menu options or selectedOptionPatientMenu if we're leaving a session
    // This prevents the menu from being re-selected after we've cleared it in finallyCloseBookedEvent()
    // 
    // IMPORTANT: This guard MUST be checked FIRST, before any other logic
    // If this guard is removed or moved, the header will persist after leaving a session
    // 
    // The guard works by checking isLeavingSessionRef.current, which is set to true
    // in finallyCloseBookedEvent() BEFORE clearing selectedOptionPatientMenu
    if (isLeavingSessionRef.current) {
      return
    }
    
    // Additional defensive check: If selectedOptionPatientMenu was just cleared (undefined/null)
    // and we're not in a normal session setup flow, don't auto-select
    // This is a secondary guard in case isLeavingSessionRef gets reset too early
    if (!selectedOptionPatientMenu && !selectedPatientBookedEventData) {
      // Both are cleared - likely we're leaving, don't set menu
      return
    }
    
    if (selectedPatientBookedEventData) {
      const menu = []
      if (allowPrescribing) {
        menu.unshift({ label: 'Vitals', id: 'vitals' })
        menu.unshift({ label: 'Patient History', id: 'patient_history' })
        menu.unshift({ label: 'Prescription', id: 'prescription' })
      }
      if (allowTherapyReport) {
        menu.unshift({ label: 'Patient History', id: 'patient_history' })
        menu.unshift({ label: 'Therapy Report', id: 'therapy_report' })
      }
      if (allowAssessmentReport) {
        menu.unshift({ label: 'Patient History', id: 'patient_history' })
        menu.unshift({ label: 'Assessment Report', id: 'assessment_report' })
      }
      if (allowScreeningReport) {
        menu.unshift({ label: 'Screening Report', id: 'screening_report' })
      }
      // Assessments tab on prescription/therapy/screening sessions (not on Assessment Report page — that page has its own launcher)
      if (allowPrescribing || allowTherapyReport || allowScreeningReport) {
        menu.push({ label: 'Assessments', id: 'assessments' })
      }
      setPatientMenuOptions(menu)
      if (menu.length === 0) {
        if (selectedOptionPatientMenu) {
          setSelectedOptionPatientMenu(undefined)
        }
        return
      }

      const hasValidSelectedOption = menu.some((menuItem) => menuItem?.id === selectedOptionPatientMenu)
      if (!hasValidSelectedOption) {
        setSelectedOptionPatientMenu(menu[0]?.id)
      }
      return
    }

    setPatientMenuOptions([])
    if (selectedOptionPatientMenu) {
      setSelectedOptionPatientMenu(undefined)
    }
  }, [selectedPatientBookedEventData, selectedOptionPatientMenu, allowPrescribing, allowTherapyReport, allowAssessmentReport, allowScreeningReport])

  useEffect(() => {
    setup()
  }, [selectedPatientBookedEventId])

  useEffect(() => {
    if (!selectedPatientBookedEventData?.id || !selectedPatientId) return

    const hasUsablePatientDob = Boolean(
      selectedPatientBookedEventData?.patientInfoData?.dateOfBirth ||
      selectedPatientBookedEventData?.patientInfo?.dateOfBirth ||
      selectedPatientBookedEventData?.patientDateOfBirth,
    )

    if (hasUsablePatientDob) return

    const enriched = enrichBookedEventWithPatientData(selectedPatientBookedEventData)
    if (enriched !== selectedPatientBookedEventData) {
      setSelectedPatientBookedEventData(enriched)
    }
  }, [bookedSlotsInDay, enrichBookedEventWithPatientData, selectedPatientBookedEventData, selectedPatientId])

  // Handle URL-based session opening (when URL contains /l/<slug>)
  useEffect(() => {
    // Don't open session if we're leaving
    if (isLeavingSessionRef.current) {
      return
    }
    
    // Don't open session if we just removed this slug
    if (sessionSlug && lastRemovedSlugRef.current === sessionSlug) {
      return
    }
    
    // Check if the current URL actually contains the slug (React Router params might be stale)
    const currentUrlPath = window.location.pathname
    const expectedSlugPath = sessionSlug ? `/l/${sessionSlug}` : ''
    if (sessionSlug && !currentUrlPath.includes(expectedSlugPath)) {
      return
    }
    
    // Use requestAnimationFrame to ensure this runs after render, not during
    if (sessionSlug && clinicBrandId && clinicLocationId && !selectedPatientBookedEventData && !isFetchingEventBySlugRef.current) {
      isFetchingEventBySlugRef.current = true
      requestAnimationFrame(() => {
        // Double-check we're not leaving before fetching
        if (isLeavingSessionRef.current || lastRemovedSlugRef.current === sessionSlug) {
          isFetchingEventBySlugRef.current = false
          return
        }
        
        // Triple-check URL still contains the slug
        const currentUrlPathCheck = window.location.pathname
        if (!currentUrlPathCheck.includes(`/l/${sessionSlug}`)) {
          isFetchingEventBySlugRef.current = false
          return
        }
        
        // URL has a session slug, fetch and open that session
        getEventBySlug(sessionSlug).finally(() => {
          isFetchingEventBySlugRef.current = false
        })
      })
    }
  }, [sessionSlug, clinicBrandId, clinicLocationId, selectedPatientBookedEventData, location.pathname])

  // Update URL when session is opened
  useEffect(() => {
    // Don't update URL if we're in the process of leaving
    if (isLeavingSessionRef.current) {
      return
    }
    
    // Don't update URL if selectedPatientBookedEventData is null/undefined (we've left the session)
    if (!selectedPatientBookedEventData) {
      return
    }
    
    // Get clinicBrandId from props or from chosenClinicData
    const effectiveClinicBrandId = clinicBrandId || chosenClinicData?.clinicBrandId
    
    // Check if current URL is the base path (no /l/) - if so, don't add session slug
    // Use window.location to get the absolute latest pathname (React Router location might be stale)
    const currentPath = window.location.pathname
    const basePath = `/mentor-home/join-chamber-room/${effectiveClinicBrandId}/${clinicLocationId}`
    
    // If we're on the base path (no /l/), don't add session slug - we've left the session
    if (currentPath === basePath || (!currentPath.includes('/l/') && effectiveClinicBrandId && clinicLocationId)) {
      return
    }
    
    // Don't add a slug that was just removed
    if (selectedPatientBookedEventData?.slug && lastRemovedSlugRef.current === selectedPatientBookedEventData.slug) {
      return
    }
    
    if (selectedPatientBookedEventData?.slug && effectiveClinicBrandId && clinicLocationId) {
      // Use requestAnimationFrame to ensure this runs after render, not during
      requestAnimationFrame(() => {
        // Triple-check we're not leaving and data still exists before updating URL
        if (isLeavingSessionRef.current || !selectedPatientBookedEventData) {
          return
        }
        
        // Don't re-add a slug we just removed (check again in case it changed)
        if (lastRemovedSlugRef.current === selectedPatientBookedEventData.slug) {
          return
        }
        
        // Double-check current path hasn't changed to base path
        const currentPathCheck = window.location.pathname
        const basePathCheck = `/mentor-home/join-chamber-room/${effectiveClinicBrandId}/${clinicLocationId}`
        if (currentPathCheck === basePathCheck || !currentPathCheck.includes('/l/')) {
          return
        }
        
        const sessionPath = `${basePathCheck}/l/${selectedPatientBookedEventData.slug}`
        
        // Only update URL if it doesn't already have the session slug
        if (!currentPathCheck.includes(`/l/${selectedPatientBookedEventData.slug}`)) {
          navigate(sessionPath, { replace: true })
          // Clear the removed slug ref since we're adding it back
          lastRemovedSlugRef.current = null
        }
      })
    }
  }, [selectedPatientBookedEventData, selectedPatientBookedEventData?.slug, clinicBrandId, clinicLocationId, chosenClinicData?.clinicBrandId, navigate, location.pathname])
  
  // SIMPLIFIED DESIGN: Parent component is the SINGLE SOURCE OF TRUTH for header state
  // Child components should NOT set headers - they just render their content
  // Parent manages header based on selectedOptionPatientMenu state
  const reportModes = ['prescription', 'therapy_report', 'screening_report', 'assessment_report']
  useEffect(() => {
    const isInReportMode = selectedOptionPatientMenu && reportModes.includes(selectedOptionPatientMenu)
    const hasValidEventData = selectedPatientBookedEventData?.id && selectedPatientId
    
    // Map report modes to their flowId values
    const flowIdMap = {
      'prescription': 'prescription-making-page',
      'therapy_report': 'therapy-report-making-page',
      'screening_report': 'screening-report-making-page',
      'assessment_report': 'assessment-report-making-page',
    }
    
    if (isInReportMode && hasValidEventData) {
      // We're in a report mode with valid data - set the appropriate header
      const flowId = flowIdMap[selectedOptionPatientMenu]
      if (flowId) {
        setFlowId(flowId)
        setButtonTopOffset(50)
      }
    } else {
      // Not in report mode or no valid event data - show calendar header
      // This should run immediately when selectedOptionPatientMenu is cleared
      setFlowId('mentor-portal')
      setButtonTopOffset(0)
    }
  }, [selectedOptionPatientMenu, selectedPatientBookedEventData?.id, selectedPatientId, setFlowId, setButtonTopOffset])
  
  // Reconnect to chamber room when returning from live session page
  useEffect(() => {
    const returnFromLiveSession = sessionStorage.getItem('returnFromLiveSession')
    const storedChamberRoomRtcProps = sessionStorage.getItem('chamberRoomRtcProps')
    const storedChamberRoomRtmProps = sessionStorage.getItem('chamberRoomRtmProps')
    const storedChannelName = sessionStorage.getItem('chamberRoomChannelName')
    const storedChamberName = sessionStorage.getItem('chamberRoomChamberName')
    const storedLocalParticipantIdentity = sessionStorage.getItem(
      'chamberRoomLocalParticipantIdentity',
    )
    
    if (returnFromLiveSession === 'true' && storedChamberRoomRtcProps && storedChannelName) {
      try {
        const rtcProps = JSON.parse(storedChamberRoomRtcProps)
        const rtmProps = JSON.parse(storedChamberRoomRtmProps)
        const normalizedRtcProps = {
          ...rtcProps,
          layout: AGORA_RTC_LAYOUTS.pin,
        }
        delete normalizedRtcProps.CustomVideoPlaceholder

        // Restore chamber room session
        setChamberScreenStateNow(CHAMBER_SCREEN_STATES.SESSION_RUNNING)
        setJoinedChamberName(storedChamberName || 'Chamber Room')
        setJoinedChannelName(storedChannelName)
        setAgoraRtcProps(normalizedRtcProps)
        setAgoraRtmProps(rtmProps)
        setChamberLocalParticipantIdentity(
          storedLocalParticipantIdentity ? JSON.parse(storedLocalParticipantIdentity) : null,
        )
        
        // Clear stored data
        sessionStorage.removeItem('returnFromLiveSession')
        sessionStorage.removeItem('chamberRoomRtcProps')
        sessionStorage.removeItem('chamberRoomRtmProps')
        sessionStorage.removeItem('chamberRoomChannelName')
        sessionStorage.removeItem('chamberRoomChamberName')
        sessionStorage.removeItem('chamberRoomLocalParticipantIdentity')
        sessionStorage.removeItem('chamberRoomUrl')
      } catch (error) {
        console.error('Error reconnecting to chamber room:', error)
        // If reconnection fails, try to get next action from server
        getAndHandleNextAction()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const refBox = useRef(null) // Right panel (calendar/interaction part)
  const refLeft = useRef(null) // Resizer separator
  const refVideoContainer = useRef(null) // Left panel (video container)
  const refMobileResizer = useRef(null) // Mobile vertical resizer
  
  // Mobile scroll state for floating video
  const [isScrolledDown, setIsScrolledDown] = useState(false)
  const calendarScrollContainerRef = useRef(null)
  const videoContainerRef = useRef(null)
  const lastScrollTop = useRef(0)
  
  // Mobile actions menu state
  const [mobileActionsMenuAnchor, setMobileActionsMenuAnchor] = useState(null)
  const mobileActionsMenuOpen = Boolean(mobileActionsMenuAnchor)
  
  // Video container ref (used for finding video elements)
  const videoFullscreenRef = useRef(null)
  const mentorChamberProviderInitialConfig = useMemo(
    () => ({
      rtcProps: agoraRtcProps || {},
      rtmProps: agoraRtmProps || null,
    }),
    [agoraRtcProps, agoraRtmProps],
  )
  const mentorChamberShell = useRtcSessionShell({
    providerId: RTC_PROVIDERS.agora,
    sessionKey: `${agoraRtcProps?.channel || ''}:${agoraRtcProps?.uid || ''}`,
    surfacePolicyId: 'mentor-chamber',
    localParticipantIdentity: chamberLocalParticipantIdentity,
    providerInitialConfig: mentorChamberProviderInitialConfig,
  })
  const mentorChamberSnapshot = useMemo(
    () =>
      buildChamberShellSnapshot({
        controllerState: mentorChamberShell,
      }),
    [
      mentorChamberShell.dominantParticipantId,
      mentorChamberShell.participants,
      mentorChamberShell.visibleParticipants,
    ],
  )
  const debugUidToUsernameMap = mentorChamberSnapshot.usernameMap
  const debugRemoteUsers = mentorChamberSnapshot.remoteUsers
  const remoteParticipantCount = mentorChamberSnapshot.remoteParticipantCount
  const getFocusMenuUsers = mentorChamberSnapshot.focusMenuParticipants
  const effectiveStageFocusUid = mentorChamberSnapshot.activeSpotlightUid
  const resolvedMentorAgoraRtcProps = useMemo(() => {
    if (!agoraRtcProps?.channel || !agoraRtcProps?.appId) {
      return agoraRtcProps
    }

    return {
      ...agoraRtcProps,
      layout: AGORA_RTC_LAYOUTS.pin,
    }
  }, [
    agoraRtcProps,
  ])

  const getProfilePictureUrl = (profilePicId) => {
    if (!profilePicId) return null

    if (profilePicId.startsWith('http://') || profilePicId.startsWith('https://')) {
      return profilePicId
    }

    return `https://media.aumhum.com/images/prod/${profilePicId}`
  }

  const getInitials = (name) => {
    if (!name || name === 'Loading...' || name === 'You' || name === 'Guest') {
      return 'U'
    }

    const trimmedName = name.trim()
    const words = trimmedName.split(/\s+/).filter((w) => w.length > 0)

    if (words.length > 1) {
      return (words[0][0] + words[words.length - 1][0]).toUpperCase()
    }
    if (trimmedName.length > 0) {
      return trimmedName.charAt(0).toUpperCase()
    }

    return 'U'
  }

  const [focusMenuAnchor, setFocusMenuAnchor] = useState(null)
  const focusMenuOpen = Boolean(focusMenuAnchor)
  const allowChamberManualFocus =
    mentorChamberShell?.surfacePolicy?.allowManualFocus !== false

  const desktopVideoUtilityButtonSx = {
    backgroundColor: 'rgba(255, 255, 255, 0.94)',
    backdropFilter: 'blur(14px) saturate(180%)',
    WebkitBackdropFilter: 'blur(14px) saturate(180%)',
    border: '1px solid rgba(196, 181, 253, 0.7)',
    color: '#5b21b6',
    width: '42px',
    height: '42px',
    boxShadow: '0 14px 28px rgba(91, 33, 182, 0.12)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      borderColor: 'rgba(167, 139, 250, 0.92)',
      transform: 'translateY(-1px)',
      boxShadow: '0 18px 34px rgba(91, 33, 182, 0.18)',
    },
    transition: 'all 0.2s ease',
  }

  const [isIdle, setIsIdle] = useState(false)
  const idleTimerRef = useRef(null)
  const IDLE_TIME = 180000

  useEffect(() => {
    const shouldCountIdle =
      chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && remoteParticipantCount === 0

    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current)
      idleTimerRef.current = null
    }

    if (remoteParticipantCount > 0 || chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
      setIsIdle(false)
      return
    }

    if (!shouldCountIdle) {
      setIsIdle(false)
      return
    }

    idleTimerRef.current = setTimeout(() => {
      setIsIdle(true)
    }, IDLE_TIME)

    const resetTimer = () => {
      if (idleTimerRef.current && shouldCountIdle) {
        clearTimeout(idleTimerRef.current)
        setIsIdle(false)
        idleTimerRef.current = setTimeout(() => {
          setIsIdle(true)
        }, IDLE_TIME)
      }
    }

    const events = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart']
    events.forEach((event) => window.addEventListener(event, resetTimer))

    return () => {
      if (idleTimerRef.current) {
        clearTimeout(idleTimerRef.current)
        idleTimerRef.current = null
      }
      events.forEach((event) => window.removeEventListener(event, resetTimer))
    }
  }, [chamberScreenStateNow, remoteParticipantCount])


  // Compute video container styles for mobile floating
  const videoContainerSx = useMemo(() => {
    const baseStyles = {
      flex: { xs: '1 1 0', md: '1 1 0' }, // Take full space on mobile
      flexShrink: { xs: 0, md: 1 },
      flexBasis: { xs: '100%', md: 0 }, // Full width/height on mobile
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(241, 245, 249, 0.98) 100%)',
      borderRadius: '0',
      overflow: { xs: 'hidden', md: 'hidden' }, // Hidden on both to prevent scroll
      overflowY: { xs: 'hidden', md: 'hidden' }, // Hidden vertical scroll on both
      position: {
        xs: 'relative', // Always relative on mobile for full height
        md: 'relative'
      },
      transition: 'all 0.3s ease',
      boxShadow: {
        xs: 'none', // No shadow on mobile
        md: 'none'
      },
    }

    // Mobile: Switch between portrait (full height) and landscape (full width) modes
    if (isMobile) {
      if (isVideoLandscape) {
        // Landscape mode: Full width (100vw), height calculated from 16:9 aspect ratio
        // Height = width * (9/16) = 100vw * 0.5625 = 56.25vw
      return {
        ...baseStyles,
          width: '100vw', // Full viewport width
          maxWidth: '100vw',
          height: '56.25vw', // 16:9 aspect ratio (9/16 = 0.5625)
          minHeight: 0,
          maxHeight: '100vh', // Don't exceed viewport height
          flex: '0 0 auto', // Don't grow/shrink
          margin: '0 auto',
          alignSelf: 'center',
        }
      } else {
        // Portrait mode: Full height (current behavior)
        return {
          ...baseStyles,
          minWidth: '100%',
          minHeight: '100vh',
          height: '100vh',
          maxHeight: '100vh',
        width: '100%',
        }
      }
    }

    // Desktop: Return base styles
    return {
      ...baseStyles,
      minWidth: '400px',
      minHeight: 0,
      height: '100%',
      maxHeight: '100%',
      width: undefined,
    }
  }, [isMobile, isVideoLandscape])

  // Detect mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // Handle scroll detection for mobile floating video
  useEffect(() => {
    if (!isMobile || chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
      setIsScrolledDown(false)
      return
    }

    const handleScroll = () => {
      if (!calendarScrollContainerRef.current) return
      
      const scrollTop = calendarScrollContainerRef.current.scrollTop
      const scrollThreshold = 100 // Start floating after 100px scroll
      
      if (scrollTop > scrollThreshold && scrollTop > lastScrollTop.current) {
        // Scrolling down
        setIsScrolledDown(true)
      } else if (scrollTop <= scrollThreshold || scrollTop < lastScrollTop.current) {
        // Scrolling up or near top
        setIsScrolledDown(false)
      }
      
      lastScrollTop.current = scrollTop
    }

    const container = calendarScrollContainerRef.current
    if (container) {
      container.addEventListener('scroll', handleScroll, { passive: true })
      return () => {
        container.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isMobile, chamberScreenStateNow, selectedTab])
  
  // Mobile vertical resizer logic
  useEffect(() => {
    if (!isMobile || chamberScreenStateNow !== CHAMBER_SCREEN_STATES.SESSION_RUNNING) return
    
    const resizer = refMobileResizer.current
    const videoContainer = videoContainerRef.current
    const calendarContainer = calendarScrollContainerRef.current
    
    if (!resizer || !videoContainer || !calendarContainer) return
    
    let startY = 0
    let startVideoHeight = 0
    
    const handleTouchMove = (e) => {
      e.preventDefault()
      const deltaY = e.touches[0].clientY - startY
      
      // Calculate new heights with minimum constraints
      const newVideoHeight = Math.max(150, startVideoHeight + deltaY)
      
      // Apply new heights
      videoContainer.style.height = `${newVideoHeight}px`
      videoContainer.style.maxHeight = `${newVideoHeight}px`
      calendarContainer.style.height = `calc(100% - ${newVideoHeight}px - 8px)` // 8px for resizer
    }
    
    const handleMouseMove = (e) => {
      const deltaY = e.clientY - startY
      
      // Calculate new heights with minimum constraints
      const newVideoHeight = Math.max(150, startVideoHeight + deltaY)
      
      // Apply new heights
      videoContainer.style.height = `${newVideoHeight}px`
      videoContainer.style.maxHeight = `${newVideoHeight}px`
      calendarContainer.style.height = `calc(100% - ${newVideoHeight}px - 8px)` // 8px for resizer
    }
    
    const handleEnd = () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleEnd)
      document.removeEventListener('touchmove', handleTouchMove, { passive: false })
      document.removeEventListener('touchend', handleEnd)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    }
    
    const handleStart = (e) => {
      e.preventDefault()
      
      // Get initial state
      const clientY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY
      startY = clientY
      startVideoHeight = videoContainer.offsetHeight
      
      // Set drag cursor and disable text selection
      document.body.style.cursor = 'row-resize'
      document.body.style.userSelect = 'none'
      
      // Add document-level event listeners
      if (e.type === 'touchstart') {
        document.addEventListener('touchmove', handleTouchMove, { passive: false })
        document.addEventListener('touchend', handleEnd)
      } else {
        document.addEventListener('mousemove', handleMouseMove)
        document.addEventListener('mouseup', handleEnd)
      }
    }
    
    resizer.addEventListener('mousedown', handleStart)
    resizer.addEventListener('touchstart', handleStart, { passive: false })
    
    return () => {
      resizer.removeEventListener('mousedown', handleStart)
      resizer.removeEventListener('touchstart', handleStart)
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleEnd)
      document.removeEventListener('touchmove', handleTouchMove)
      document.removeEventListener('touchend', handleEnd)
    }
  }, [isMobile, chamberScreenStateNow])

  const handleAssessmentReportSaved = useCallback(() => {
    getAndSetPatientBookedEventDetails?.()
    const pid = selectedPatientId
    const refId = selectedPatientBookedEventData?.id
    if (pid != null && refId != null) {
      store.dispatch(getPastPatientReports({ patientId: pid, referenceBookedEventId: refId }))
    }
  }, [selectedPatientId, selectedPatientBookedEventData?.id, getAndSetPatientBookedEventDetails])

  return (
    <div 
      className="w-100 d-flex flex-column full-width-child-resizable-box-print-only"
      style={{
        // Mobile: Full viewport height. Desktop: 100vh
        height: isMobile ? '100vh' : '100vh',
        overflow: isMobile ? 'visible' : 'hidden', // Allow overflow on mobile so fixed controls aren't clipped
      }}
    >
      <ScreeningSectionsProvider>
        <SplitScreenHeader
          chosenClinicData={chosenClinicData}
          chamberScreenStateNow={chamberScreenStateNow}
          leaveThisSession={leaveThisSession}
          serverGivenNextAction={serverGivenNextAction}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          onPrevClick={onPrevClick}
          onNextClick={onNextClick}
          handleGoToToday={handleGoToToday}
          isToday={isToday}
          clinicSchedules={clinicSchedules}
          onOpenPatientSearch={handleOpenPatientSearch}
          onOpenBookedSlotsDrawer={handleOpenBookedSlotsDrawer}
          onRefreshBookings={handleRefreshBookings}
          isRefreshing={isRefreshingBookings}
          eachSlotDurationInMins={eachSlotDurationInMins}
          setEachSlotDurationInMins={setEachSlotDurationInMins}
          onOpenCalendarDrawer={() => setCalendarDrawerOpen(true)} // Calendar drawer callback for mobile
          // Report mode props - when a report page is open
          selectedOptionPatientMenu={selectedOptionPatientMenu}
          selectedPatientBookedEventData={selectedPatientBookedEventData}
          auxiliaryData={auxiliaryData}
          // Chamber screen status props
          chamberScreenStatus={chamberScreenStatus}
          joinedChamberName={joinedChamberName}
          onSaveReport={async () => {
            if (selectedOptionPatientMenu === 'screening_report') {
              await screeningReportRef?.current?.saveScreeningReport()
            } else if (selectedOptionPatientMenu === 'prescription') {
              await prescriptionRef?.current?.savePrescriptionData()
            } else if (selectedOptionPatientMenu === 'therapy_report') {
              await therapyReportRef?.current?.saveTherapyReport()
            }
          }}
          onLeaveSession={async (markAsCompleted = false) => {
            setIsLeavingSession(true)
            showNotification.info('Saving and returning to calendar...')
            try {
              await closeBookedEvent(markAsCompleted)
            } finally {
              setIsLeavingSession(false)
            }
          }}
          onCompleteSession={async () => {
            // Use closeBookedEvent with markAsCompleted=true for all report types
            // This ensures proper cleanup and state reset
            await closeBookedEvent(true)
          }}
          isSavingReport={
            selectedOptionPatientMenu === 'screening_report' ? screeningReportRef?.current?.isSaving :
            selectedOptionPatientMenu === 'prescription' ? prescriptionRef?.current?.isSaving :
            selectedOptionPatientMenu === 'therapy_report' ? therapyReportRef?.current?.isSaving :
            false
          }
          isLeavingSession={isLeavingSession}
        />
        <PractitionerAssessmentDrawer
          open={assessmentDrawerOpen}
          onClose={() => setAssessmentDrawerOpen(false)}
          bookedEventId={selectedPatientBookedEventId}
          bookedEventInfo={selectedPatientBookedEventData}
          onRunSubmitted={() => getAndSetPatientBookedEventDetails?.()}
          patientId={selectedPatientId}
          mentorId={mentorProfileData?.id}
          onAssessmentReportSaved={handleAssessmentReportSaved}
        />
        <NerdStatComponent serverGivenNextAction={serverGivenNextAction} />
        {/* Mobile: Full screen video (calendar in drawer) | Desktop: Horizontal layout (side by side) */}
        <Box
          className="d-flex flex-grow-1"
          sx={{
            // Mobile: Full viewport height (header overlays). Desktop: Subtract header height
            marginTop: { xs: 0, sm: 0, md: `${MENTOR_SPLIT_HEADER_OFFSET_PX}px` },
            height: {
              xs: '100vh',
              sm: '100vh',
              md: `calc(100vh - ${MENTOR_SPLIT_HEADER_OFFSET_PX}px)`,
            },
            maxHeight: {
              xs: '100vh',
              sm: '100vh',
              md: `calc(100vh - ${MENTOR_SPLIT_HEADER_OFFSET_PX}px)`,
            }, // Constrain height
            overflow: 'hidden', // Prevent outer container from scrolling - children handle their own scroll
            flexDirection: { xs: 'column', md: 'row' },
            position: 'relative',
            display: 'flex', // Ensure flex is enabled
            // Mobile: Center video in landscape mode
            alignItems: { xs: isVideoLandscape ? 'center' : 'stretch', md: 'stretch' },
            justifyContent: { xs: isVideoLandscape ? 'center' : 'flex-start', md: 'flex-start' },
            minHeight: 0, // Critical for flex children to allow scrolling
          }}
        >
        {chamberScreenStateNow === CHAMBER_SCREEN_STATES.IDLING && (
          <Box sx={{ 
            width: '100%', 
            // Mobile: Show with proper sizing. Desktop: Show normally
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            p: { xs: 2, sm: 2, md: 2 }, 
            position: 'relative',
            flex: { xs: '1 1 0', md: '1 1 0' },
            overflowY: 'auto',
            overflowX: 'hidden',
            minHeight: 0,
          }}>
            <Box sx={{ 
              maxWidth: { xs: '100%', sm: '400px', md: '420px', lg: '480px' }, 
              width: '100%',
              px: { xs: 1, sm: 2 },
            }} className="hide-on-print-only">
              {/* Subtle status indicator with reconnect button */}
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                gap: { xs: 0.75, sm: 1 }, 
                mb: { xs: 1.5, sm: 2 },
                flexWrap: 'wrap',
              }}>
                {joinedChamberName && (
                  <Typography variant="caption" sx={{ 
                    textAlign: 'center', 
                    color: 'rgba(107, 114, 128, 0.6)', 
                    fontSize: { xs: '12px', sm: '11px' }, 
                    fontWeight: 400,
                    flex: { xs: '1 1 100%', sm: '0 0 auto' },
                    mb: { xs: 0.5, sm: 0 },
                  }}>
                    Joining {joinedChamberName}
                  </Typography>
                )}
                {!joinedChamberName && (
                  <Typography variant="caption" sx={{ 
                    textAlign: 'center', 
                    color: 'rgba(107, 114, 128, 0.5)', 
                    fontSize: { xs: '12px', sm: '11px' }, 
                    fontWeight: 400,
                    flex: { xs: '1 1 100%', sm: '0 0 auto' },
                    mb: { xs: 0.5, sm: 0 },
                  }}>
                    Waiting for connection...
                  </Typography>
                )}
                <IconButton
                  onClick={() => {
                    if (chamberRoomId) {
                      getAndHandleNextAction({ force: true })
                    }
                  }}
                  size="small"
                  sx={{
                    padding: { xs: '6px', sm: '4px' },
                    backgroundColor: 'rgba(103, 121, 227, 0.08)',
                    color: '#6779e3',
                    border: '1px solid rgba(103, 121, 227, 0.2)',
                    '&:hover': {
                      backgroundColor: 'rgba(103, 121, 227, 0.15)',
                      borderColor: 'rgba(103, 121, 227, 0.4)',
                    },
                  }}
                  title="Reconnect to server"
                >
                  <RefreshIcon sx={{ fontSize: { xs: 18, sm: 16 } }} />
                </IconButton>
              </Box>

              <Paper
                elevation={1}
                sx={{
                  p: { xs: 1.5, sm: 1.75 },
                  borderRadius: '12px',
                  background: autoConnectRemainingMs > 0
                    ? 'rgba(254, 243, 199, 0.65)'
                    : 'rgba(255, 255, 255, 0.82)',
                  backdropFilter: 'blur(10px)',
                  border: `1px solid ${
                    autoConnectRemainingMs > 0
                      ? 'rgba(245, 158, 11, 0.28)'
                      : 'rgba(0, 0, 0, 0.08)'
                  }`,
                  mb: { xs: 1.5, sm: 2 },
                  width: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    color: 'rgba(107, 114, 128, 0.82)',
                    fontWeight: 600,
                    fontSize: { xs: '12px', sm: '11px' },
                    display: 'block',
                    mb: 0.75,
                  }}
                >
                  Auto-connect
                </Typography>

                <Typography
                  variant="caption"
                  sx={{
                    color: autoConnectRemainingMs > 0 ? 'rgba(146, 64, 14, 0.92)' : 'rgba(107, 114, 128, 0.76)',
                    fontWeight: 500,
                    fontSize: { xs: '12px', sm: '11px' },
                    display: 'block',
                    mb: 1.25,
                  }}
                >
                  {autoConnectRemainingMs > 0
                    ? `Paused. Auto-resume in ${formatAutoConnectRemaining(autoConnectRemainingMs)}.`
                    : 'Active. Chamber auto-connect will use the current camera and mic settings.'}
                </Typography>

                <Box
                  sx={{
                    display: 'flex',
                    gap: 1,
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                    alignItems: 'center',
                  }}
                >
                  <FormControl
                    size="small"
                    sx={{
                      minWidth: { xs: '100%', sm: 120 },
                      flex: { xs: '1 1 100%', sm: '0 0 auto' },
                    }}
                  >
                    <Select
                      value={autoConnectPauseDurationMs}
                      onChange={(event) => setAutoConnectPauseDurationMs(Number(event.target.value))}
                      sx={{
                        fontSize: { xs: '12px', sm: '11px' },
                        height: { xs: '32px', sm: '30px' },
                        '& .MuiSelect-select': {
                          padding: { xs: '6px 10px', sm: '4px 8px' },
                        },
                      }}
                    >
                      {AUTO_CONNECT_PAUSE_OPTIONS.map((option) => (
                        <MenuItem
                          key={`auto-connect-pause-${option.value}`}
                          value={option.value}
                          sx={{ fontSize: { xs: '12px', sm: '11px' } }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handlePauseAutoConnect}
                    disabled={autoConnectRemainingMs > 0}
                    sx={{
                      minWidth: { xs: '100%', sm: 'auto' },
                      textTransform: 'none',
                      fontSize: { xs: '12px', sm: '11px' },
                      borderRadius: '10px',
                    }}
                  >
                    Pause auto-connect
                  </Button>

                  <Button
                    variant={autoConnectRemainingMs > 0 ? 'contained' : 'text'}
                    size="small"
                    onClick={handleResumeAutoConnect}
                    disabled={autoConnectRemainingMs <= 0}
                    sx={{
                      minWidth: { xs: '100%', sm: 'auto' },
                      textTransform: 'none',
                      fontSize: { xs: '12px', sm: '11px' },
                      borderRadius: '10px',
                    }}
                  >
                    Resume now
                  </Button>
                </Box>
              </Paper>

              {/* Device Preview Section - Compact and Subtle */}
              <Paper
                elevation={1}
                sx={{
                  p: { xs: 1.5, sm: 2, md: 2 },
                  borderRadius: '12px',
                  background: 'rgba(255, 255, 255, 0.85)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(0, 0, 0, 0.08)',
                  mb: { xs: 1.5, sm: 2 },
                  width: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <Typography variant="caption" sx={{ 
                  mb: { xs: 1.5, sm: 2 }, 
                  color: 'rgba(107, 114, 128, 0.7)', 
                  fontWeight: 500, 
                  fontSize: { xs: '12px', sm: '11px' }, 
                  display: 'block' 
                }}>
                  Device Settings
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    mb: { xs: 1.5, sm: 2 },
                    color: 'rgba(107, 114, 128, 0.6)',
                    fontWeight: 400,
                    fontSize: { xs: '12px', sm: '11px' },
                    display: 'block',
                    lineHeight: 1.45,
                  }}
                >
                  Test your camera and mic here. These toggles become your join settings when the chamber auto-connect starts.
                </Typography>

                {/* Compact Video Preview */}
                <Box sx={{ 
                  mb: { xs: 1.5, sm: 2 }, 
                  display: 'flex', 
                  justifyContent: 'center',
                  width: '100%',
                }}>
                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: { xs: '100%', sm: '240px', md: '280px', lg: '320px' },
                      aspectRatio: '16/9',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      background: '#000',
                      position: 'relative',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                    }}
                  >
                    <video
                      ref={previewVideoRef}
                      autoPlay
                      playsInline
                      muted
            style={{ 
                        width: '100%',
              height: '100%', 
                        objectFit: 'cover',
                      }}
                    />
                    {!isCameraOpen && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
              display: 'flex', 
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: 'rgba(0, 0, 0, 0.6)',
                          color: 'rgba(255, 255, 255, 0.7)',
                        }}
                      >
                        <Typography variant="caption" sx={{ fontSize: '10px' }}>Camera Off</Typography>
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* Camera Toggle - Compact */}
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: { xs: 0.75, sm: 1 }, 
                  mb: { xs: 1.25, sm: 1.5 },
                  flexWrap: { xs: 'wrap', sm: 'nowrap' },
                }}>
                  <IconButton
                    onClick={async () => {
                      const newCameraState = !isCameraOpen
                      setIsCameraOpen(newCameraState)
                      
                      // Load devices if not already loaded and camera is being turned on
                      if (newCameraState && availableCameras.length === 0) {
                        try {
                          // Request camera permission first
                          await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
                          // Then load devices
                          await getAndSetCameras({ setAvailableCameras, setSelectedCamera })
                        } catch (error) {
                          console.error('Error loading cameras:', error)
                          setIsCameraOpen(false) // Revert if permission denied
                        }
                      }
                    }}
                    size="small"
                    sx={{
                      backgroundColor: isCameraOpen ? 'rgba(16, 185, 129, 0.08)' : 'rgba(239, 68, 68, 0.08)',
                      color: isCameraOpen ? 'rgba(16, 185, 129, 0.8)' : 'rgba(239, 68, 68, 0.8)',
                      border: `1px solid ${isCameraOpen ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`,
                      padding: { xs: '6px', sm: '4px' },
                      flexShrink: 0,
                      '&:hover': {
                        backgroundColor: isCameraOpen ? 'rgba(16, 185, 129, 0.15)' : 'rgba(239, 68, 68, 0.15)',
                      },
                    }}
                  >
                    {isCameraOpen ? <VideocamIcon sx={{ fontSize: { xs: 18, sm: 16 } }} /> : <VideocamOffIcon sx={{ fontSize: { xs: 18, sm: 16 } }} />}
                  </IconButton>
                  <Typography variant="caption" sx={{ 
                    flex: { xs: '1 1 auto', sm: 1 }, 
                    fontWeight: 400, 
                    color: 'rgba(107, 114, 128, 0.7)', 
                    fontSize: { xs: '12px', sm: '11px' },
                    minWidth: { xs: '60px', sm: 'auto' },
                  }}>
                    Join with Camera
                  </Typography>
                  <FormControl size="small" sx={{ 
                    minWidth: { xs: '100%', sm: 140 },
                    width: { xs: '100%', sm: 'auto' },
                    flex: { xs: '1 1 100%', sm: '0 0 auto' },
                  }}>
                    <Select
                      value={selectedCamera}
                      onChange={(e) => {
                        setSelectedCamera(e.target.value)
                        localStorage.setItem('selectedCamera', e.target.value)
                      }}
                      disabled={!isCameraOpen}
                      sx={{
                        fontSize: { xs: '12px', sm: '11px' },
                        height: { xs: '32px', sm: '28px' },
                        '& .MuiSelect-select': {
                          padding: { xs: '6px 10px', sm: '4px 8px' },
                        },
                      }}
                    >
                      {availableCameras.map((camera) => (
                        <MenuItem key={camera.deviceId} value={camera.deviceId} sx={{ fontSize: { xs: '12px', sm: '11px' } }}>
                          {camera.label || `Camera ${camera.deviceId.slice(0, 8)}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                {/* Microphone Toggle - Compact */}
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: { xs: 0.75, sm: 1 }, 
                  mb: { xs: 1.25, sm: 1.5 },
                  flexWrap: { xs: 'wrap', sm: 'nowrap' },
                }}>
                  <IconButton
                    onClick={async () => {
                      const newAudioState = !isAudioOpen
                      setIsAudioOpen(newAudioState)
                      
                      // Load devices if not already loaded and audio is being turned on
                      if (newAudioState && availableMicrophones.length === 0) {
                        try {
                          // Request microphone permission first
                          await navigator.mediaDevices.getUserMedia({ video: false, audio: true })
                          // Then load devices
                          await getAndSetMicrophones({ setAvailableMicrophones, setSelectedMicrophone })
                          await getAndSetSpeakers({ setAvailableSpeakers, setSelectedSpeaker })
                        } catch (error) {
                          console.error('Error loading microphones:', error)
                          setIsAudioOpen(false) // Revert if permission denied
                        }
                      }
                    }}
                    size="small"
                    sx={{
                      backgroundColor: isAudioOpen ? 'rgba(16, 185, 129, 0.08)' : 'rgba(239, 68, 68, 0.08)',
                      color: isAudioOpen ? 'rgba(16, 185, 129, 0.8)' : 'rgba(239, 68, 68, 0.8)',
                      border: `1px solid ${isAudioOpen ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`,
                      padding: { xs: '6px', sm: '4px' },
                      flexShrink: 0,
                      '&:hover': {
                        backgroundColor: isAudioOpen ? 'rgba(16, 185, 129, 0.15)' : 'rgba(239, 68, 68, 0.15)',
                      },
                    }}
                  >
                    {isAudioOpen ? <MicIcon sx={{ fontSize: { xs: 18, sm: 16 } }} /> : <MicOffIcon sx={{ fontSize: { xs: 18, sm: 16 } }} />}
                  </IconButton>
                  <Typography variant="caption" sx={{ 
                    flex: { xs: '1 1 auto', sm: 1 }, 
                    fontWeight: 400, 
                    color: 'rgba(107, 114, 128, 0.7)', 
                    fontSize: { xs: '12px', sm: '11px' },
                    minWidth: { xs: '60px', sm: 'auto' },
                  }}>
                    Join with Mic
                  </Typography>
                  <FormControl size="small" sx={{ 
                    minWidth: { xs: '100%', sm: 140 },
                    width: { xs: '100%', sm: 'auto' },
                    flex: { xs: '1 1 100%', sm: '0 0 auto' },
                  }}>
                    <Select
                      value={selectedMicrophone}
                      onChange={(e) => {
                        setSelectedMicrophone(e.target.value)
                        localStorage.setItem('selectedMicrophone', e.target.value)
                      }}
                      disabled={!isAudioOpen}
                      sx={{
                        fontSize: { xs: '12px', sm: '11px' },
                        height: { xs: '32px', sm: '28px' },
                        '& .MuiSelect-select': {
                          padding: { xs: '6px 10px', sm: '4px 8px' },
                        },
                      }}
                    >
                      {availableMicrophones.map((mic) => (
                        <MenuItem key={mic.deviceId} value={mic.deviceId} sx={{ fontSize: { xs: '12px', sm: '11px' } }}>
                          {mic.label || `Mic ${mic.deviceId.slice(0, 8)}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <Box sx={{ mb: { xs: 1.25, sm: 1.5 } }}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'rgba(107, 114, 128, 0.72)',
                      fontWeight: 500,
                      fontSize: { xs: '12px', sm: '11px' },
                      display: 'block',
                      mb: 0.75,
                    }}
                  >
                    Mic Preview
                  </Typography>
                  <AudioPreviewBars
                    bars={audioPreviewBars}
                    active={isAudioOpen}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      mt: 0.75,
                      color: 'rgba(107, 114, 128, 0.62)',
                      fontWeight: 400,
                      fontSize: { xs: '11px', sm: '10px' },
                      display: 'block',
                    }}
                  >
                    {isAudioOpen
                      ? 'Speak into the selected microphone to verify live input levels.'
                      : 'Turn the mic on to preview input activity before auto-connect.'}
                  </Typography>
                </Box>

                {/* Speaker Selection - Compact */}
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: { xs: 0.75, sm: 1 },
                  flexWrap: { xs: 'wrap', sm: 'nowrap' },
                }}>
                  <IconButton
                    disabled
                    size="small"
                    sx={{
                      backgroundColor: 'rgba(107, 114, 128, 0.08)',
                      color: 'rgba(107, 114, 128, 0.6)',
                      border: '1px solid rgba(107, 114, 128, 0.2)',
                      padding: { xs: '6px', sm: '4px' },
                      flexShrink: 0,
                    }}
                  >
                    <VolumeUpIcon sx={{ fontSize: { xs: 18, sm: 16 } }} />
                  </IconButton>
                  <Typography variant="caption" sx={{ 
                    flex: { xs: '1 1 auto', sm: 1 }, 
                    fontWeight: 400, 
                    color: 'rgba(107, 114, 128, 0.7)', 
                    fontSize: { xs: '12px', sm: '11px' },
                    minWidth: { xs: '60px', sm: 'auto' },
                  }}>
                    Speaker
                  </Typography>
                  <FormControl size="small" sx={{ 
                    minWidth: { xs: '100%', sm: 140 },
                    width: { xs: '100%', sm: 'auto' },
                    flex: { xs: '1 1 100%', sm: '0 0 auto' },
                  }}>
                    <Select
                      value={selectedSpeaker}
                      onChange={(e) => {
                        setSelectedSpeaker(e.target.value)
                        localStorage.setItem('selectedSpeaker', e.target.value)
                      }}
                      sx={{
                        fontSize: { xs: '12px', sm: '11px' },
                        height: { xs: '32px', sm: '28px' },
                        '& .MuiSelect-select': {
                          padding: { xs: '6px 10px', sm: '4px 8px' },
                        },
                      }}
                    >
                      {availableSpeakers.map((speaker) => (
                        <MenuItem key={speaker.deviceId} value={speaker.deviceId} sx={{ fontSize: { xs: '12px', sm: '11px' } }}>
                          {speaker.label || `Speaker ${speaker.deviceId.slice(0, 8)}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Paper>

              {/* Exit Button */}
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <CheckoutButtonComponent
                  text="Exit"
                  exitButtonText="Exit"
                  showExitButtonIfNotCheckedIn={true}
                  styleProp={{
                    fontSize: '11px',
                    fontWeight: 500,
                    padding: '6px 12px',
                    backgroundColor: 'rgba(239, 68, 68, 0.08)',
                    color: 'rgba(220, 38, 38, 0.8)',
                    border: '1px solid rgba(239, 68, 68, 0.15)',
                    borderRadius: '8px',
                    boxShadow: 'none',
                    '&:hover': {
                      background: 'rgba(239, 68, 68, 0.12)',
                      borderColor: 'rgba(239, 68, 68, 0.25)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                  buttonColor="error"
                  buttonVariant="outlined"
                />
              </Box>
            </Box>
          </Box>
        )}
        {chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <Box
            ref={videoContainerRef}
            sx={videoContainerSx}
            className="hide-on-print-only mobile-video-container"
          >
            {/* Desktop: Signal actions as fixed sidebar - Hidden on mobile */}
            {!isMobile && (
            <ChamberScreenSignallingActions
              chamberRoomId={serverGivenNextAction?.channel?.chamberRoomId}
            />
            )}
            
            {/* Mobile: Floating buttons on top right - View toggle, Focus, then Bolt */}
            {isMobile && (
              <Box
                sx={{
                  position: 'fixed',
                  top: '80px',
                  right: '16px',
                  zIndex: 1400,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                }}
              >
                {/* View Toggle Button - Portrait/Landscape */}
                <Tooltip title={isVideoLandscape ? "Switch to Portrait View" : "Switch to Landscape View"} arrow>
                  <IconButton
                    onClick={() => setIsVideoLandscape(!isVideoLandscape)}
                    size="small"
                    sx={{
                      backgroundColor: 'rgba(103, 121, 227, 0.2)',
                      backdropFilter: 'blur(12px) saturate(180%)',
                      WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                      border: '1px solid rgba(103, 121, 227, 0.4)',
                      color: '#6779e3',
                      width: { xs: '40px', sm: '44px' },
                      height: { xs: '40px', sm: '44px' },
                      boxShadow: '0 4px 16px rgba(103, 121, 227, 0.2)',
                      '&:hover': {
                        backgroundColor: 'rgba(103, 121, 227, 0.3)',
                        borderColor: 'rgba(103, 121, 227, 0.6)',
                        transform: 'scale(1.1)',
                        boxShadow: '0 6px 20px rgba(103, 121, 227, 0.3)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    {isVideoLandscape ? (
                      <CropPortraitIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                    ) : (
                      <CropLandscapeIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                    )}
                  </IconButton>
                </Tooltip>
                
                {/* Focus button - Third */}
                {allowChamberManualFocus ? (
                  <Tooltip title="Select video to focus" arrow>
                    <IconButton
                      onClick={(e) => setFocusMenuAnchor(e.currentTarget)}
                      size="small"
                      sx={{
                        backgroundColor: 'rgba(103, 121, 227, 0.2)',
                        backdropFilter: 'blur(12px) saturate(180%)',
                        WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                        border: '1px solid rgba(103, 121, 227, 0.4)',
                        color: '#6779e3',
                        width: { xs: '40px', sm: '44px' },
                        height: { xs: '40px', sm: '44px' },
                        boxShadow: '0 4px 16px rgba(103, 121, 227, 0.2)',
                        '&:hover': {
                          backgroundColor: 'rgba(103, 121, 227, 0.3)',
                          borderColor: 'rgba(103, 121, 227, 0.6)',
                          transform: 'scale(1.1)',
                          boxShadow: '0 6px 20px rgba(103, 121, 227, 0.3)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                    >
                      <CenterFocusStrongIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                    </IconButton>
                  </Tooltip>
                ) : null}
                
                {/* Bolt button - Second */}
                <IconButton
                  size="small"
                  onClick={(e) => setMobileActionsMenuAnchor(e.currentTarget)}
                  sx={{
                    backgroundColor: 'rgba(103, 121, 227, 0.15)',
                    border: '2px solid rgba(103, 121, 227, 0.3)',
                    color: '#6779e3',
                    width: { xs: '40px', sm: '44px' },
                    height: { xs: '40px', sm: '44px' },
                    boxShadow: '0 4px 12px rgba(103, 121, 227, 0.25)',
                    '&:hover': {
                      backgroundColor: 'rgba(103, 121, 227, 0.25)',
                      borderColor: 'rgba(103, 121, 227, 0.5)',
                      transform: 'scale(1.1)',
                      boxShadow: '0 6px 16px rgba(103, 121, 227, 0.35)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                  <BoltIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                </IconButton>
                
                {/* Assessments - full-page /l/* when no split (right panel hidden); only when patient in session */}
                {patientSelected && (
                  <Tooltip title="Conduct assessment" arrow>
                    <IconButton
                      size="small"
                      onClick={() => setAssessmentDrawerOpen(true)}
                      sx={{
                        backgroundColor: 'rgba(103, 121, 227, 0.2)',
                        backdropFilter: 'blur(12px) saturate(180%)',
                        WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                        border: '1px solid rgba(103, 121, 227, 0.4)',
                        color: '#6779e3',
                        width: { xs: '40px', sm: '44px' },
                        height: { xs: '40px', sm: '44px' },
                        boxShadow: '0 4px 16px rgba(103, 121, 227, 0.2)',
                        '&:hover': {
                          backgroundColor: 'rgba(103, 121, 227, 0.3)',
                          borderColor: 'rgba(103, 121, 227, 0.6)',
                          transform: 'scale(1.1)',
                          boxShadow: '0 6px 20px rgba(103, 121, 227, 0.3)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                    >
                      <AssignmentIcon sx={{ fontSize: { xs: 20, sm: 22 } }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            )}
            
            {/* Mobile: Focus/Swap Menu */}
            {isMobile && allowChamberManualFocus && (
              <Menu
                anchorEl={focusMenuAnchor}
                open={focusMenuOpen}
                onClose={() => setFocusMenuAnchor(null)}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                PaperProps={{
                  sx: {
                    mt: 1,
                    minWidth: 240,
                    maxHeight: 400,
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                    border: '1px solid rgba(103, 121, 227, 0.1)',
                    overflow: 'auto',
                  },
                }}
              >
                {mentorChamberShell.isManualFocusActive ? (
                  <MenuItem
                    onClick={() => {
                      mentorChamberShell.clearManualFocus()
                      setFocusMenuAnchor(null)
                    }}
                    sx={{ fontSize: '13px', fontWeight: 600, color: '#6779e3' }}
                  >
                    Use automatic focus
                  </MenuItem>
                ) : null}
                {getFocusMenuUsers.length > 0 ? (
                  getFocusMenuUsers.map((userInfo) => {
                    const stageUid = effectiveStageFocusUid
                    const isFocused =
                      stageUid !== null &&
                      stageUid !== undefined &&
                      (stageUid === userInfo.uid ||
                        String(stageUid) === String(userInfo.uid) ||
                        Number(stageUid) === Number(userInfo.uid))
                    const profilePicUrl = getProfilePictureUrl(userInfo.profilePicId)
                    const initials = getInitials(userInfo.name)

                    return (
                      <MenuItem
                        key={userInfo.uid}
                        onClick={() => {
                          mentorChamberShell.setPreferredDominantParticipantId(
                            userInfo.participantId,
                          )
                          setFocusMenuAnchor(null)
                        }}
                        sx={{
                          '&:hover': {
                            backgroundColor: 'rgba(103, 121, 227, 0.1)',
                          },
                          backgroundColor: isFocused ? 'rgba(103, 121, 227, 0.15)' : 'transparent',
                          borderLeft: isFocused ? '3px solid #6779e3' : '3px solid transparent',
                        }}
                      >
                        <Avatar
                          src={profilePicUrl || undefined}
                          sx={{
                            width: 32,
                            height: 32,
                            mr: 1.5,
                            fontSize: '14px',
                            bgcolor: profilePicUrl ? 'transparent' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          }}
                        >
                          {!profilePicUrl && initials}
                        </Avatar>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontSize: '14px',
                              fontWeight: isFocused ? 600 : 400,
                              color: isFocused ? '#6779e3' : 'inherit',
                            }}
                          >
                            {userInfo.name}
                            {userInfo.isLocal && (
                              <Typography component="span" variant="caption" sx={{ ml: 0.5, color: 'text.secondary', fontSize: '11px' }}>
                                (You)
                              </Typography>
                            )}
                          </Typography>
                          {userInfo.role && (
                            <Typography variant="caption" sx={{ fontSize: '11px', color: 'text.secondary', display: 'block' }}>
                              {userInfo.role === 'mentor' ? 'Mentor' : 
                               userInfo.role === 'patient' ? 'Patient' : 
                               userInfo.role === 'chamber-room' ? 'Chamber Room' : 
                               userInfo.role}
                            </Typography>
                          )}
                        </Box>
                        {isFocused && (
                          <CenterFocusStrongIcon sx={{ fontSize: 18, color: '#6779e3', ml: 1 }} />
                        )}
                      </MenuItem>
                    )
                  })
                ) : (
                  <MenuItem disabled>
                    <Typography variant="body2" sx={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.5)' }}>
                      No participants available
                    </Typography>
                  </MenuItem>
                )}
              </Menu>
            )}

            {/* Mobile: Menu for room screen actions */}
            {isMobile && (
                <Menu
                  anchorEl={mobileActionsMenuAnchor}
                  open={mobileActionsMenuOpen}
                  onClose={() => setMobileActionsMenuAnchor(null)}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      minWidth: 200,
                      borderRadius: '12px',
                      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                      border: '1px solid rgba(103, 121, 227, 0.1)',
                    },
                  }}
                >
                  <MenuItem
                    onClick={async () => {
                      await sendShowImageCommandToChamberScreen(serverGivenNextAction?.channel?.chamberRoomId, 'payment-qr')
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <QrCodeScannerIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Show Payment QR
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      askCheckedInChamberScreenToPollNextAction(serverGivenNextAction?.channel?.chamberRoomId)
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <LoginIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Fast-track Connect
                  </MenuItem>
                  <MenuItem
                    onClick={async () => {
                      sendShowImageCommandToChamberScreen(serverGivenNextAction?.channel?.chamberRoomId, 'clear-screen')
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <LayersClearIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Clear Screen
                  </MenuItem>
                  <MenuItem
                    onClick={async () => {
                      await sendReloadChamberRoomScreenSignal(serverGivenNextAction?.channel?.chamberRoomId)
                      setMobileActionsMenuAnchor(null)
                    }}
                  >
                    <ReplayIcon sx={{ fontSize: 18, mr: 1.5, color: 'rgba(103, 121, 227, 0.7)' }} />
                    Refresh Screen
                  </MenuItem>
                </Menu>
            )}
            
            <Box
              ref={(node) => {
                videoFullscreenRef.current = node
                refVideoContainer.current = node
              }}
              data-video-container="left-frame"
              sx={{
                position: 'relative',
                // Mobile: Full screen (calendar is in drawer). Desktop: Resizable
                flexGrow: isMobile && isVideoLandscape ? 0 : 1, // Don't grow in landscape mode
                flexShrink: isMobile ? (isVideoLandscape ? 1 : 0) : 1, // Allow shrink in landscape mode
                flexBasis: isMobile ? (isVideoLandscape ? 'auto' : '100%') : 0, // Auto basis in landscape, full width in portrait
                width: isMobile ? (isVideoLandscape ? '100vw' : '100%') : undefined, // Full viewport width in landscape, full width in portrait
                // Mobile: Landscape mode uses calculated height (56.25vw), Portrait uses full viewport height. Desktop: 100% of parent
                height: isMobile ? (isVideoLandscape ? '56.25vw' : '100vh') : '100%',
                minHeight: isMobile ? (isVideoLandscape ? 0 : '100vh') : 0, // No min height in landscape, full height in portrait
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                alignSelf: 'stretch',
                overflow: isMobile ? 'visible' : 'hidden', // Allow overflow on mobile so fixed controls aren't clipped
                zIndex: 100,
                maxHeight: isMobile ? (isVideoLandscape ? '100vh' : '100vh') : '100%', // Don't exceed viewport on mobile
              }}
            >
            <MentorChamberAgoraVideoSurface
              key={`agora-video-${agoraRtcProps?.channel || 'none'}-${isInBookedEventSession ? 'booked' : 'chamber'}`}
              shell={mentorChamberShell}
              agoraRtcProps={resolvedMentorAgoraRtcProps}
              agoraRtmProps={agoraRtmProps}
              handleLeaveRoom={() => {
                leaveThisSession()
              }}
              onParticipantsUpdated={mentorChamberShell.handleParticipantSnapshot}
              callContainerStyles={{
                flex: '1 1 0',
                flexGrow: 1,
                minWidth: 0,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '0',
                height: '100%',
                maxHeight: '100%',
                width: '100%',
                overflow: 'hidden', // Prevent scroll within video call container
              }}
              agoraKitStyleProps={{
                // 🔴 End Call Button (larger, prominent red gradient)
                endCall: {
                  width: '52px',
                  height: '52px',
                  minWidth: '52px',
                  minHeight: '52px',
                  maxWidth: '52px',
                  maxHeight: '52px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.95) 0%, rgba(220, 38, 38, 1) 100%)',
                  border: '1.5px solid rgba(255, 255, 255, 0.4)',
                  boxShadow: '0 6px 24px rgba(239, 68, 68, 0.6), 0 2px 8px rgba(0, 0, 0, 0.3), inset 0 1px 1px rgba(255, 255, 255, 0.35)',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                },
                // Main container with subtle purple-tinted background for modern look
                UIKitContainer: {
                  background: 'linear-gradient(135deg, rgba(248, 250, 252, 1) 0%, rgba(243, 244, 255, 1) 100%)',
                  border: '1px solid rgba(139, 92, 246, 0.1)',
                  boxShadow: 'inset 0 0 20px rgba(139, 92, 246, 0.03)',
                  height: '100%',
                  maxHeight: '100%',
                  overflow: 'hidden', // Prevent scroll, fit content within viewport
                },
                // Beautiful username display on video - transparent glass - FLEXIBLE WIDTH
                usernameText: {
                  background: 'rgba(0, 0, 0, 0.3)',
                  backdropFilter: 'blur(8px)',
                  WebkitBackdropFilter: 'blur(8px)',
                  color: '#ffffff',
                  fontSize: '14px',
                  fontWeight: 500,
                  padding: '6px 12px',
                  borderRadius: '12px',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)',
                  letterSpacing: '0.3px',
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                  // Position at top-left with flexible width
                  position: 'absolute',
                  top: '8px',
                  left: '8px',
                  right: 'auto',
                  margin: '0',
                  // Flexible width - expands to fit content, but respects max-width
                  width: 'auto',
                  maxWidth: 'calc(100% - 16px)', // Leave some padding on both sides
                  minWidth: 'fit-content',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
                // Button container styling - dark glass background for visibility
                localBtnContainer: {
                  background: 'rgba(15, 15, 15, 0.75)',
                  backdropFilter: 'blur(20px) saturate(180%)',
                  WebkitBackdropFilter: 'blur(20px) saturate(180%)',
                  border: '1.5px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '16px',
                  padding: '12px 16px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.6), 0 4px 16px rgba(139, 92, 246, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.05)',
                  display: 'flex',
                  visibility: 'visible',
                  opacity: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  position: 'absolute',
                  bottom: '16px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 10000,
                  pointerEvents: 'none',
                },
                // Global button template styles - white glass effect for clean look
                BtnTemplateStyles: {
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(16px) saturate(180%)',
                  WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                  border: '1.5px solid rgba(255, 255, 255, 0.8)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(139, 92, 246, 0.1), inset 0 1px 0 rgba(255, 255, 255, 1)',
                  pointerEvents: 'auto',
                  color: '#1f2937',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    borderColor: 'rgba(139, 92, 246, 0.6)',
                    transform: 'translateY(-2px) scale(1.05)',
                    boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(139, 92, 246, 0.25), inset 0 1px 0 rgba(255, 255, 255, 1), 0 0 20px rgba(139, 92, 246, 0.3)',
                  },
                },
                // Individual button customizations - white glass with subtle color accents
                localBtnStyles: {
                  muteLocalAudio: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                    border: '1.5px solid rgba(139, 92, 246, 0.2)',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(139, 92, 246, 0.1)',
                    color: '#1f2937',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                      borderColor: 'rgba(139, 92, 246, 0.6)',
                      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(139, 92, 246, 0.25), 0 0 20px rgba(139, 92, 246, 0.3)',
                    },
                  },
                  muteLocalVideo: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                    border: '1.5px solid rgba(139, 92, 246, 0.2)',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(139, 92, 246, 0.1)',
                    color: '#1f2937',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                      borderColor: 'rgba(139, 92, 246, 0.6)',
                      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(139, 92, 246, 0.25), 0 0 20px rgba(139, 92, 246, 0.3)',
                    },
                  },
                  screenshare: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                    border: '1.5px solid rgba(56, 189, 248, 0.2)',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(56, 189, 248, 0.1)',
                    color: '#1f2937',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                      borderColor: 'rgba(56, 189, 248, 0.6)',
                      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(56, 189, 248, 0.25), 0 0 20px rgba(56, 189, 248, 0.3)',
                    },
                  },
                  settings: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                    border: '1.5px solid rgba(168, 85, 247, 0.2)',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(168, 85, 247, 0.1)',
                    color: '#1f2937',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)',
                      borderColor: 'rgba(168, 85, 247, 0.6)',
                      boxShadow: '0 12px 32px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(168, 85, 247, 0.25), 0 0 20px rgba(168, 85, 247, 0.3)',
                    },
                  },
                  endCall: {
                    width: '52px',
                    height: '52px',
                    backgroundColor: 'rgba(220, 38, 38, 0.95)',
                    backdropFilter: 'blur(16px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(16px) saturate(180%)',
                    border: '1.5px solid rgba(239, 68, 68, 0.6)',
                    boxShadow: '0 8px 24px rgba(220, 38, 38, 0.5), 0 4px 12px rgba(239, 68, 68, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
                    color: '#ffffff',
                    '&:hover': {
                      backgroundColor: 'rgba(239, 68, 68, 0.35)',
                      borderColor: 'rgba(239, 68, 68, 0.7)',
                    },
                  },
                },
                // Remote user button styles - glass effect for mic/camera status icons
                remoteBtnStyles: {
                  muteRemoteAudio: {
                    backgroundColor: 'rgba(239, 68, 68, 0.2)',
                    backdropFilter: 'blur(12px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                    border: '1px solid rgba(239, 68, 68, 0.4)',
                    boxShadow: '0 4px 16px rgba(239, 68, 68, 0.2)',
                  },
                  muteRemoteVideo: {
                    backgroundColor: 'rgba(239, 68, 68, 0.2)',
                    backdropFilter: 'blur(12px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(12px) saturate(180%)',
                    border: '1px solid rgba(239, 68, 68, 0.4)',
                    boxShadow: '0 4px 16px rgba(239, 68, 68, 0.2)',
                  },
                },
                // Icon color and size
                theme: '#475569', // Slate-600 for good contrast
                iconSize: 24,
              }}
              playAudioOnUserJoin={false}
              playAudioOnUserLeave={false}
              onCameraClose={() => {
                setIsCameraOpen(false)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'CAMERA_OFF', 'mentor', {
                    camera: false,
                    mic: isAudioOpen,
                  })
                }
              }}
              onCameraOpen={() => {
                setIsCameraOpen(true)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'CAMERA_ON', 'mentor', {
                    camera: true,
                    mic: isAudioOpen,
                  })
                }
              }}
              onAudioClose={() => {
                setIsAudioOpen(false)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'MIC_OFF', 'mentor', {
                    camera: isCameraOpen,
                    mic: false,
                  })
                }
              }}
              onAudioOpen={() => {
                setIsAudioOpen(true)
                if (selectedPatientBookedEventId) {
                  markBookedEventLog(selectedPatientBookedEventId, 'MIC_ON', 'mentor', {
                    camera: isCameraOpen,
                    mic: true,
                  })
                }
              }}
              />
              {!isMobile &&
              allowChamberManualFocus &&
              chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING ? (
                <>
                  <Box
                    sx={{
                      position: 'absolute',
                      left: 24,
                      bottom: 24,
                      zIndex: 12010,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      px: 1.25,
                      py: 1,
                      borderRadius: '20px',
                      background: 'rgba(255, 255, 255, 0.72)',
                      border: '1px solid rgba(216, 180, 254, 0.72)',
                      boxShadow:
                        '0 24px 54px rgba(91, 33, 182, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.86)',
                      backdropFilter: 'blur(18px) saturate(140%)',
                      WebkitBackdropFilter: 'blur(18px) saturate(140%)',
                    }}
                  >
                    <Tooltip title="Select video to focus" arrow>
                      <IconButton
                        onClick={(e) => setFocusMenuAnchor(e.currentTarget)}
                        sx={desktopVideoUtilityButtonSx}
                      >
                        <CenterFocusStrongIcon sx={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <Menu
                    anchorEl={focusMenuAnchor}
                    open={focusMenuOpen}
                    onClose={() => setFocusMenuAnchor(null)}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 240,
                        maxHeight: 400,
                        borderRadius: '16px',
                        boxShadow: '0 18px 46px rgba(91, 33, 182, 0.2)',
                        border: '1px solid rgba(216, 180, 254, 0.42)',
                        overflow: 'auto',
                      },
                    }}
                  >
                    {mentorChamberShell.isManualFocusActive ? (
                      <MenuItem
                        onClick={() => {
                          mentorChamberShell.clearManualFocus()
                          setFocusMenuAnchor(null)
                        }}
                        sx={{ fontSize: '13px', fontWeight: 600, color: '#6779e3' }}
                      >
                        Use automatic focus
                      </MenuItem>
                    ) : null}
                    {getFocusMenuUsers.length > 0 ? (
                      getFocusMenuUsers.map((userInfo) => {
                        const stageUid = effectiveStageFocusUid
                        const isFocused =
                          stageUid !== null &&
                          stageUid !== undefined &&
                          (stageUid === userInfo.uid ||
                            String(stageUid) === String(userInfo.uid) ||
                            Number(stageUid) === Number(userInfo.uid))
                        const profilePicUrl = getProfilePictureUrl(userInfo.profilePicId)
                        const initials = getInitials(userInfo.name)

                        return (
                          <MenuItem
                          key={userInfo.uid}
                          onClick={() => {
                              mentorChamberShell.setPreferredDominantParticipantId(
                                userInfo.participantId,
                              )
                              setFocusMenuAnchor(null)
                            }}
                            sx={{
                              '&:hover': {
                                backgroundColor: 'rgba(103, 121, 227, 0.1)',
                              },
                              backgroundColor: isFocused
                                ? 'rgba(103, 121, 227, 0.15)'
                                : 'transparent',
                              borderLeft: isFocused
                                ? '3px solid #6779e3'
                                : '3px solid transparent',
                            }}
                          >
                            <Avatar
                              src={profilePicUrl || undefined}
                              sx={{
                                width: 32,
                                height: 32,
                                mr: 1.5,
                                fontSize: '14px',
                                bgcolor: profilePicUrl
                                  ? 'transparent'
                                  : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                              }}
                            >
                              {!profilePicUrl && initials}
                            </Avatar>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: isFocused ? 600 : 400,
                                  color: isFocused ? '#6779e3' : 'inherit',
                                }}
                              >
                                {userInfo.name}
                                {userInfo.isLocal ? (
                                  <Typography
                                    component="span"
                                    variant="caption"
                                    sx={{ ml: 0.5, color: 'text.secondary', fontSize: '11px' }}
                                  >
                                    (You)
                                  </Typography>
                                ) : null}
                              </Typography>
                              {userInfo.role ? (
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontSize: '11px',
                                    color: 'text.secondary',
                                    display: 'block',
                                  }}
                                >
                                  {userInfo.role === 'mentor'
                                    ? 'Mentor'
                                    : userInfo.role === 'patient'
                                      ? 'Patient'
                                      : userInfo.role === 'chamber-room'
                                        ? 'Chamber Room'
                                        : userInfo.role}
                                </Typography>
                              ) : null}
                            </Box>
                            {isFocused ? (
                              <CenterFocusStrongIcon
                                sx={{ fontSize: 18, color: '#6779e3', ml: 1 }}
                              />
                            ) : null}
                          </MenuItem>
                        )
                      })
                    ) : (
                      <MenuItem disabled>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.5)' }}
                        >
                          No participants available
                        </Typography>
                      </MenuItem>
                    )}
                  </Menu>

                </>
              ) : null}
            </Box>
          </Box>
        )}
        
        {/* Debug Panel - Desktop only */}
        {!isMobile && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <DebugPanel
            uidToUsernameMap={debugUidToUsernameMap}
            remoteUsers={debugRemoteUsers}
            agoraRtcProps={resolvedMentorAgoraRtcProps}
            agoraRtmProps={agoraRtmProps}
            onRequestFocusUid={(participantId) =>
              mentorChamberShell.setPreferredDominantParticipantId(participantId)
            }
          />
        )}
        
        {/* Mobile Vertical Separator - Hidden on mobile (calendar is in drawer) */}
        {false && isMobile && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <Box
            ref={refMobileResizer}
            sx={{
              width: '100%',
              height: '8px',
              background: 'linear-gradient(to bottom, rgba(103, 121, 227, 0.1), rgba(116, 80, 170, 0.1))',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'row-resize',
              position: 'relative',
              transition: 'all 0.2s ease',
              borderTop: '1px solid rgba(103, 121, 227, 0.15)',
              borderBottom: '1px solid rgba(116, 80, 170, 0.15)',
              flexShrink: 0,
              '&:hover': {
                height: '12px',
                background: 'linear-gradient(to bottom, rgba(103, 121, 227, 0.2), rgba(116, 80, 170, 0.2))',
                borderTop: '2px solid rgba(103, 121, 227, 0.4)',
                borderBottom: '2px solid rgba(116, 80, 170, 0.4)',
              },
              '&:active': {
                height: '16px',
                background: 'linear-gradient(to bottom, rgba(103, 121, 227, 0.3), rgba(116, 80, 170, 0.3))',
              },
            }}
          >
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: '#6779E3',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(103, 121, 227, 0.4)',
                transition: 'all 0.2s ease',
                '&:hover': {
                  width: 28,
                  height: 28,
                  backgroundColor: '#5568D3',
                  boxShadow: '0 3px 12px rgba(103, 121, 227, 0.6)',
                },
              }}
            >
              <DragIndicatorIcon
                sx={{
                  fontSize: '16px',
                  color: 'white',
                  transform: 'rotate(90deg)', // Rotate 90 degrees for vertical dragging
                }}
              />
            </Box>
          </Box>
        )}
        
        {/* Desktop Horizontal Separator - Hidden on mobile */}
        <HotlineSectionSeparator 
          ref={refLeft} 
          className="left-resizer hide-on-print-only"
          style={{
            display: isMobile ? 'none' : 'flex',
            pointerEvents: 'auto',
            zIndex: 10002,
            position: 'relative',
          }}
        >
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              backgroundColor: '#6779E3',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(103, 121, 227, 0.4)',
              transition: 'all 0.2s ease',
              pointerEvents: 'none', // Allow clicks to pass through to separator
              '&:hover': {
                width: 28,
                height: 28,
                backgroundColor: '#5568D3',
                boxShadow: '0 3px 12px rgba(103, 121, 227, 0.6)',
              },
            }}
          >
            <DragIndicatorIcon
              style={{
                fontSize: '16px',
                color: 'white',
                pointerEvents: 'none', // Ensure icon doesn't block events
              }}
            />
          </Box>
        </HotlineSectionSeparator>
        <HotlineChamberInteractionPart
          style={{
            paddingTop: 0,
            padding: 0,
            // Mobile: Hide calendar (it's in drawer). Desktop: Show
            display: isMobile ? 'none' : undefined,
            width: isMobile ? '100%' : undefined,
            // CRITICAL: Fixed height enables scrolling
            height: '100%',
            // Flex properties - don't shrink, don't grow beyond natural size
            flexShrink: 0,
            // Add margin top on mobile when video is floating to prevent overlap
            marginTop: isMobile && isScrolledDown ? '180px' : 0,
            transition: 'margin-top 0.3s ease',
          }}
          ref={(node) => {
            refBox.current = node
            calendarScrollContainerRef.current = node
          }}
          className="resizable-box mobile-calendar-container"
        >
          {/* No wrapper div needed - content renders directly in scroll container */}
            {patientSelected ? (
              <div>
                {patientBookedSlotDetailsLoading ? (
                  <Spinner animation="border" variant="dark" size="sm" />
                ) : (
                  <div>
                    <HCIPMenuContainer className="hide-on-print-only" style={{ flexShrink: 0 }} data-testid="patient-menu-row">
                      {patientMenuOptions?.map((menuItem, menuItemIndex) => (
                        <HCIPMenuItem
                          key={menuItem.id ?? menuItemIndex}
                          selected={menuItem.id === selectedOptionPatientMenu}
                          onClick={() => {
                            setSelectedOptionPatientMenu(menuItem.id)
                            if (menuItem.id === 'assessments') {
                              setAssessmentDrawerOpen(true)
                            }
                          }}
                        >
                          {menuItem.label}
                        </HCIPMenuItem>
                      ))}
                      {/* Save/Leave buttons are now in the main page header */}
                      {selectedOptionPatientMenu === 'screening_report' && (
                        <>
                          <HCIPMenuItem
                            onClick={() => screeningReportRef?.current?.openPreviewDrawer?.()}
                            style={{
                              background: 'linear-gradient(135deg, rgba(103, 121, 227, 0.1) 0%, rgba(103, 121, 227, 0.05) 100%)',
                              color: '#6779e3',
                              border: '1px solid rgba(103, 121, 227, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <PreviewIcon sx={{ fontSize: 16 }} />
                            Preview
                          </HCIPMenuItem>
                          <HCIPMenuItem
                            onClick={() => screeningReportRef?.current?.openHistoryDrawer?.()}
                            style={{
                              background: 'linear-gradient(135deg, rgba(103, 121, 227, 0.1) 0%, rgba(103, 121, 227, 0.05) 100%)',
                              color: '#6779e3',
                              border: '1px solid rgba(103, 121, 227, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <HistoryIcon sx={{ fontSize: 16 }} />
                            History
                          </HCIPMenuItem>
                          <ScreeningReportActionsMenu screeningReportRef={screeningReportRef} />
                        </>
                      )}
                      {/* Prescription Action Buttons */}
                      {selectedOptionPatientMenu === 'prescription' && (
                        <>
                          <HCIPMenuItem
                            onClick={() => setRxDrawerOpen(true)}
                            style={{
                              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(16, 185, 129, 0.05) 100%)',
                              color: '#10b981',
                              border: '1px solid rgba(16, 185, 129, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <MedicationIcon sx={{ fontSize: 16 }} />
                            Rx
                          </HCIPMenuItem>
                        </>
                      )}
                      {/* Therapy Report Action Buttons */}
                      {selectedOptionPatientMenu === 'therapy_report' && (
                        <>
                          <HCIPMenuItem
                            onClick={() => therapyReportRef?.current?.openSettings?.()}
                            style={{
                              background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(139, 92, 246, 0.05) 100%)',
                              color: '#8b5cf6',
                              border: '1px solid rgba(139, 92, 246, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <SettingsIcon sx={{ fontSize: 16 }} />
                            Settings
                          </HCIPMenuItem>
                          <HCIPMenuItem
                            onClick={() => {
                              // Open preview by triggering save and print
                              therapyReportRef?.current?.printReport?.()
                            }}
                            style={{
                              background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(139, 92, 246, 0.05) 100%)',
                              color: '#8b5cf6',
                              border: '1px solid rgba(139, 92, 246, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <PreviewIcon sx={{ fontSize: 16 }} />
                            Preview / Print
                          </HCIPMenuItem>
                        </>
                      )}
                      {/* Assessment Report Action Buttons – same pattern as therapy report, open assessment-report settings */}
                      {selectedOptionPatientMenu === 'assessment_report' && (
                        <>
                          <HCIPMenuItem
                            onClick={() => assessmentReportRef?.current?.openSettings?.()}
                            style={{
                              background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(99, 102, 241, 0.05) 100%)',
                              color: '#6366f1',
                              border: '1px solid rgba(99, 102, 241, 0.2)',
                              fontSize: '12px',
                              padding: '6px 12px',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px',
                            }}
                          >
                            <SettingsIcon sx={{ fontSize: 16 }} />
                            Settings
                          </HCIPMenuItem>
                        </>
                      )}
                    </HCIPMenuContainer>
                    {patientMenuOptions?.length === 0 && (
                      <Box sx={{ p: 3, maxWidth: 560 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                          This booking could not be opened yet
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          We could not determine the right report view for this session. The booking data may be incomplete or still using an older event type.
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                          Event type: {selectedPatientBookedEventData?.eventType || selectedPatientEventType || 'Unknown'}
                        </Typography>
                      </Box>
                    )}
                    <PrescriptionDataProvider>
                      <div>
                        {selectedOptionPatientMenu === 'prescription' && (
                          <PrescriptionMakingPage
                            ref={prescriptionRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientId}
                            propClinicId={selectedPatientClinicId}
                            propClinicBrandId={selectedPatientClinicBrandId}
                            propMentorProfileData={mentorProfileData}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            setHideLayoutComponents={setHideLayoutComponents}
                            // triggerSave={triggerSave}
                            // setTriggerSave={setTriggerSave}
                            auxiliaryDataFromProps={auxiliaryData}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            inChamber
                            afterSaveFunction={(markAsCompleted = false) => {
                              if (newWantedMenuItemId === 'end') {
                                finallyCloseBookedEvent(markAsCompleted)
                              } else {
                                setSelectedOptionPatientMenu(newWantedMenuItemId)
                              }
                            }}
                            showPatientDetailsInHeader
                          />
                        )}
                        {selectedOptionPatientMenu === 'therapy_report' && (
                          <TherapyReportMakingPage
                            ref={therapyReportRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientId}
                            propClinicId={selectedPatientClinicId}
                            propClinicBrandId={selectedPatientClinicBrandId}
                            propMentorProfileData={mentorProfileData}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            triggerSave={triggerSave}
                            setTriggerSave={setTriggerSave}
                            auxiliaryDataFromProps={auxiliaryData}
                            hideDocSide
                            leaveRoom={finallyCloseBookedEvent}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            afterSaveFunction={() => {
                              if (newWantedMenuItemId === 'end') {
                                setSelectedPatientBookedEventId()
                                setPatientSelected(false)
                                setNewWantedMenuItemId()
                                setSelectedOptionPatientMenu()
                              } else {
                                setSelectedOptionPatientMenu(newWantedMenuItemId)
                              }
                            }}
                            showPatientDetailsInHeader
                          />
                        )}
                        {selectedOptionPatientMenu === 'assessment_report' && (
                          <AssessmentReportMakingPage
                            ref={assessmentReportRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientId}
                            propClinicId={selectedPatientClinicId}
                            propClinicBrandId={selectedPatientClinicBrandId}
                            propMentorProfileData={mentorProfileData}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            triggerSave={triggerSave}
                            setTriggerSave={setTriggerSave}
                            auxiliaryDataFromProps={auxiliaryData}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            afterSaveFunction={() => {
                              if (newWantedMenuItemId === 'end') {
                                setSelectedPatientBookedEventId()
                                setPatientSelected(false)
                                setNewWantedMenuItemId()
                                setSelectedOptionPatientMenu()
                              } else {
                                setSelectedOptionPatientMenu(newWantedMenuItemId)
                              }
                            }}
                            chamberRoomId={serverGivenNextAction?.channel?.chamberRoomId}
                            showPatientDetailsInHeader
                          />
                        )}
                        {selectedOptionPatientMenu === 'screening_report' && (
                          <ScreeningReportMakingPage
                            ref={screeningReportRef}
                            propEventId={selectedPatientBookedEventData?.id}
                            propPatientId={selectedPatientId}
                            propClinicId={selectedPatientClinicId}
                            propBookedEventInfo={selectedPatientBookedEventData}
                            propMentorProfileData={mentorProfileData}
                            auxiliaryDataFromProps={auxiliaryData}
                            getProcessAndSetEventData={getAndSetPatientBookedEventDetails}
                            leaveRoom={finallyCloseBookedEvent}
                          />
                        )}
                        {selectedOptionPatientMenu === 'past_prescriptions' && (
                          <LSPastPrescriptionsComponent
                            patientId={selectedPatientId}
                          />
                        )}
                        {selectedOptionPatientMenu === 'patient_history' && (
                          <LSPastVisitReportsComponent
                            patientId={selectedPatientId}
                            referenceBookedEventId={selectedPatientBookedEventData?.id}
                            addTopMargins
                          />
                        )}
                        {selectedOptionPatientMenu === 'vitals' && (
                          <VitalsListingPage
                            patientId={selectedPatientId}
                            clinicId={selectedPatientClinicId}
                          />
                        )}
                        {selectedOptionPatientMenu === 'assessments' && (
                          <Box sx={{ p: 3, maxWidth: 480 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                              Assessment tests
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                              Start or view assessment runs for this session. Use the drawer to select an assessment.
                            </Typography>
                            <Button
                              variant="contained"
                              onClick={() => setAssessmentDrawerOpen(true)}
                              startIcon={<AssignmentIcon />}
                            >
                              Open assessment drawer
                            </Button>
                          </Box>
                        )}
                      </div>
                    </PrescriptionDataProvider>
                  </div>
                )}
              </div>
            ) : (
              <>
                {/* <HotlineCalendarComponentForMentor
                forMentor={true}
                mentorId={mentorProfileData?.id}
                mentorProfileData={mentorProfileData}
                containerRefForAutoScrolling={refBox}
                thisClinicData={chosenClinicData}
                mentorClinicAssociationData={mentorClinicAssociationData}
                bookedSlotClickFunctionOverride={(data) => {
                  if (data?.status !== STATUS_SESSION_CANCELLED) {
                    markJoinOrLeaveSession(data?.id, 'JOIN', 'mentor')
                    setSelectedPatientBookedEventId(data?.id)
                    setPatientSelected(true)
                  }
                }}
              /> */}

                <DayViewCalendarComponent
                  ref={calendarRef}
                  forMentor={true}
                  bookingLisitingApiSignature={`/api/secure/teacher/booked-slots/all-with-patient-info?get-patient-details=true`}
                  mentorAuthorisedToSaveAndGetPatientsUsingIdb={getAllRolesInBoolean().isDoctor}
                  mentorId={mentorProfileData?.id}
                  mentorProfileData={mentorProfileData}
                  mentorClinicAssociationData={mentorClinicAssociationData}
                  meetingBookApiSignature="/api/secure/meeting/book"
                  listOfPaymentLinksApiSignature="/api/secure/teacher/booked-slots/user-payment-link/get"
                  publicBookingJoiningLinksApiSignature="/api/secure/teacher/booked-slots/video-session-tokens/get"
                  patientSearchApiSignature="/api/secure/mentor/patient/list"
                  cancelAppointmentApiSignature="/api/secure/teacher/booked-slots/cancel"
                  pastPatientBookingsApiSignature="/api/secure/teacher/booked-event-history-of-a-patient"
                  createPatientApiSignature="/api/secure/patient/new"
                  sendSecureSessionLinkToPatientSignature="/api/secure/teacher/booked-slots/secure-join-link/send"
                  sendPublicSessionLinkToPatientSignature="/api/secure/teacher/booked-slots/public-join-link/send"
                  getPrescriptionImagesApiSignature="/api/secure/mentor/emr-reports/prescription/images/get-by-eventId"
                  savePrescriptionImagesApiSignature="/api/secure/mentor/emr-reports/prescription/images/save"
                  fileUploadApiSignature="/api/secure/mentor/emr-reports/file/upload"
                  sendPrescriptionPdfApiSignature="/api/secure/teacher/doctor/prescription/generate/pdf"
                  headerContainerStyles={{ display: 'none', height: 0, padding: 0, margin: 0 }}
                  // allProfessionalsDataForAssistant
                  thisClinicData={chosenClinicData}
                  currentView={selectedTab}
                  // setFetchDataTriggerForBookingRequests
                  // canPersonPrintPrescription
                  // chambersData
                  // assistantProfileInThisClinic
                  // LeftSideExtraComponent
                  // RightSideExtraComponent
                  containerRefForAutoScrolling={refBox}
                  bookedSlotClickFunctionOverride={async (data) => {
                    // Check if session is blocked (payment pending - slot held but not confirmed)
                    const isSessionBlocked = 
                      data?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
                      data?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING
                    
                    // Prevent joining blocked sessions
                    if (isSessionBlocked) {
                      toast.warning('This session is awaiting payment confirmation and cannot be joined yet.')
                      return
                    }
                    
                    if (data?.status !== STATUS_SESSION_CANCELLED) {
                      // Check if this is an offline event - offline events should open therapy report editing page, not join video call
                      const isOfflineEvent = data?.meetingSrc === 'offline'
                      
                      // Check if this is a video call event and join the video call channel
                      const isVideoCallEvent = 
                        data?.eventType === allAvailableEventTypes.consultation ||
                        data?.eventType === allAvailableEventTypes.therapySession ||
                        data?.eventType === allAvailableEventTypes.screening ||
                        data?.eventType === allAvailableEventTypes.assessment
                      
                      if (isVideoCallEvent && !isOfflineEvent) {
                        // Join the booked event's video call channel (only for online events)
                        await joinBookedEventVideoCall(data)
                      } else {
                        // Not a video call or is offline, use original behavior (opens therapy report editing page on split page)
                        markBookedEventLog(data?.id, 'JOIN', 'mentor')
                        setSelectedPatientBookedEventId(data?.id)
                        setPatientSelected(true)
                      }
                    }
                  }}
                  // emptySlotClickFunctionOverride={() => null}
                  // LeftSideExtraComponent={<CheckInInformationComponent />}
                  RightSideExtraComponent={
                    <CheckoutButtonComponent
                      text=" "
                      additionalFunctionBeforeAction={() => {
                        chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING &&
                          leaveThisSession()
                      }}
                      styleProp={{
                        width: '16px',
                        flexDirection: 'column',
                        borderRadius: '0px',
                        height: '100%',
                      }}
                      showExitButtonIfNotCheckedIn={true}
                    />
                  }
                  // minimalUI
                  // showBookingPopup={true}
                  useClinicAppointmentTypes={false}
                  clinicAppointmentTypesList={[]}
                  paymentLinkToSendViaQRCode={showPaymentQrToPatient}
                  eachSlotDurationInMins={eachSlotDurationInMins}
                  setEachSlotDurationInMins={setEachSlotDurationInMins}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  onBookedSlotsUpdate={setBookedSlotsInDay}
                />
              </>
            )}
        </HotlineChamberInteractionPart>
        </Box>

        {/* Booked Slots Drawer */}
        <BookedSlotsDrawer
          open={bookedSlotsDrawerOpen}
          onClose={() => setBookedSlotsDrawerOpen(false)}
          bookedSlotsInDay={bookedSlotsInDay}
          selectedDate={selectedDate}
          selectedClinic={chosenClinicData}
          mentorProfileData={mentorProfileData}
          forMentor={true}
        />

        {/* Patient Search Drawer */}
        <PatientSearchDrawer
          open={patientSearchOpen}
          onClose={() => setPatientSearchOpen(false)}
          onSelectPatient={(patient) => {
            setPatientSearchOpen(false)
            // You can add additional logic here if needed
          }}
          clinicId={chosenClinicData?.id}
          clinicBrandId={chosenClinicData?.clinicBrandId}
          mentorProfileData={mentorProfileData}
          searchPatientApiSignature="/api/secure/mentor/patient/list"
          createPatientApiSignature="/api/secure/patient/new"
        />

        {/* Calendar Drawer for Mobile */}
        {isMobile && (
          <Drawer
            anchor="bottom"
            open={calendarDrawerOpen}
            onClose={() => setCalendarDrawerOpen(false)}
            PaperProps={{
              sx: {
                height: '85vh',
                borderTopLeftRadius: '24px',
                borderTopRightRadius: '24px',
                background: 'rgba(255, 255, 255, 0.98)',
                backdropFilter: 'blur(20px) saturate(180%)',
                WebkitBackdropFilter: 'blur(20px) saturate(180%)',
              },
            }}
          >
            {/* Drawer Header with Tabs and Date Picker */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                background: 'rgba(255, 255, 255, 0.98)',
              }}
            >
              {/* Top Row: Title, 3-dots Menu, and Close Button */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  p: 2,
                  pb: 1.5,
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1f2937' }}>
                  Calendar
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {/* 3-dots Menu */}
                  <IconButton
                    onClick={(e) => {
                      const menuAnchor = e.currentTarget
                      setCombinedMenuAnchorEl(menuAnchor)
                    }}
                    sx={{
                      color: 'rgba(103, 121, 227, 0.8)',
                      backgroundColor: 'rgba(103, 121, 227, 0.1)',
                      border: '1px solid rgba(103, 121, 227, 0.2)',
                      padding: '6px',
                      '&:hover': {
                        backgroundColor: 'rgba(103, 121, 227, 0.2)',
                        borderColor: 'rgba(103, 121, 227, 0.4)',
                      },
                    }}
                  >
                    <MoreVertIcon sx={{ fontSize: 20 }} />
                  </IconButton>
                  <Menu
                    anchorEl={combinedMenuAnchorEl}
                    open={Boolean(combinedMenuAnchorEl)}
                    onClose={() => setCombinedMenuAnchorEl(null)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1,
                        minWidth: 200,
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                        border: '1px solid rgba(103, 121, 227, 0.1)',
                      },
                    }}
                  >
                    {/* Tabs Section */}
                    {MENTOR_CLINIC_BOOKING_TABS_LIST.filter((tab) => {
                      return tab.id === 'calendar' || tab.id === 'appointments'
                    }).length > 0 && (
                      <>
                        {MENTOR_CLINIC_BOOKING_TABS_LIST.filter((tab) => {
                          return tab.id === 'calendar' || tab.id === 'appointments'
                        }).map((tab) => {
                          const TabIcon = tab.icon
                          return (
                            <MenuItem
                              key={tab.id}
                              onClick={() => {
                                setSelectedTab(tab.id)
                                setCombinedMenuAnchorEl(null)
                              }}
                              selected={selectedTab === tab.id}
                              sx={{
                                py: 1.5,
                                px: 2,
                                '&.Mui-selected': {
                                  backgroundColor: 'rgba(103, 121, 227, 0.1)',
                                  '&:hover': {
                                    backgroundColor: 'rgba(103, 121, 227, 0.15)',
                                  },
                                },
                              }}
                            >
                              <ListItemIcon>
                                <TabIcon sx={{ fontSize: 20, color: selectedTab === tab.id ? '#6779e3' : 'rgba(103, 121, 227, 0.6)' }} />
                              </ListItemIcon>
                              <ListItemText
                                primary={tab.title}
                                primaryTypographyProps={{
                                  fontWeight: selectedTab === tab.id ? 600 : 400,
                                  color: selectedTab === tab.id ? '#6779e3' : 'rgba(103, 121, 227, 0.7)',
                                }}
                              />
                            </MenuItem>
                          )
                        })}
                        {/* Divider between tabs and actions if both exist */}
                        {(selectedTab === 'calendar' && (handleOpenPatientSearch || handleRefreshBookings || (eachSlotDurationInMins !== undefined && setEachSlotDurationInMins))) && (
                          <Box sx={{ borderTop: '1px solid rgba(103, 121, 227, 0.1)', my: 0.5 }} />
                        )}
                      </>
                    )}

                    {/* Actions Section (only when calendar tab is selected) */}
                    {selectedTab === 'calendar' && (
                      <>
                        {handleOpenPatientSearch && (
                          <MenuItem
                            onClick={() => {
                              handleOpenPatientSearch()
                              setCombinedMenuAnchorEl(null)
                            }}
                          >
                            <ListItemIcon>
                              <SearchIcon sx={{ fontSize: 20, color: 'rgba(103, 121, 227, 0.7)' }} />
                            </ListItemIcon>
                            <ListItemText primary="Search Patient" />
                          </MenuItem>
                        )}
                        {handleRefreshBookings && (
                          <MenuItem
                            onClick={() => {
                              handleRefreshBookings()
                              setCombinedMenuAnchorEl(null)
                            }}
                            disabled={isRefreshingBookings}
                          >
                            <ListItemIcon>
                              {isRefreshingBookings ? (
                                <CircularProgress size={16} sx={{ color: 'rgba(103, 121, 227, 0.7)' }} />
                              ) : (
                                <RefreshIcon sx={{ fontSize: 20, color: 'rgba(103, 121, 227, 0.7)' }} />
                              )}
                            </ListItemIcon>
                            <ListItemText primary="Refresh Bookings" />
                          </MenuItem>
                        )}
                        {eachSlotDurationInMins !== undefined && setEachSlotDurationInMins && (
                          <MenuItem
                            onClick={(e) => {
                              const anchor = combinedMenuAnchorEl
                              setCombinedMenuAnchorEl(null)
                              // Note: Slot duration popover functionality would need to be implemented separately
                              // For now, we'll just close the menu
                            }}
                          >
                            <ListItemIcon>
                              <HeightIcon sx={{ fontSize: 20, color: 'rgba(103, 121, 227, 0.7)' }} />
                            </ListItemIcon>
                            <ListItemText primary="Adjust Slot Duration" />
                          </MenuItem>
                        )}
                      </>
                    )}
                  </Menu>
                  <IconButton
                    onClick={() => setCalendarDrawerOpen(false)}
                    sx={{
                      color: '#6779e3',
                      '&:hover': {
                        backgroundColor: 'rgba(103, 121, 227, 0.1)',
                      },
                    }}
                  >
                    <ExitToAppIcon />
                  </IconButton>
                </Box>
              </Box>

              {/* Tabs Row: Calendar / Appointments */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  px: 2,
                  pb: 1.5,
                }}
              >
                {MENTOR_CLINIC_BOOKING_TABS_LIST.filter((tab) => {
                  const isCalendarOrAppointments = tab.id === 'calendar' || tab.id === 'appointments'
                  return isCalendarOrAppointments
                }).map((tab) => {
                  const TabIcon = tab.icon
                  const isSelected = selectedTab === tab.id
                  return (
                    <Box
                      key={tab.id}
                      onClick={() => setSelectedTab(tab.id)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        px: 2,
                        py: 1,
                        borderRadius: '8px',
                        cursor: 'pointer',
                        background: isSelected
                          ? 'linear-gradient(135deg, rgba(103, 121, 227, 0.15) 0%, rgba(118, 75, 162, 0.12) 100%)'
                          : 'transparent',
                        border: isSelected
                          ? '1.5px solid rgba(103, 121, 227, 0.3)'
                          : '1.5px solid transparent',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          background: isSelected
                            ? 'linear-gradient(135deg, rgba(103, 121, 227, 0.2) 0%, rgba(118, 75, 162, 0.15) 100%)'
                            : 'rgba(103, 121, 227, 0.05)',
                          borderColor: isSelected
                            ? 'rgba(103, 121, 227, 0.4)'
                            : 'rgba(103, 121, 227, 0.2)',
                        },
                      }}
                    >
                      <TabIcon
                        sx={{
                          fontSize: 18,
                          color: isSelected ? '#6779e3' : 'rgba(103, 121, 227, 0.6)',
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontWeight: isSelected ? 600 : 500,
                          color: isSelected ? '#6779e3' : 'rgba(103, 121, 227, 0.7)',
                        }}
                      >
                        {tab.title}
                      </Typography>
                    </Box>
                  )
                })}
              </Box>

              {/* Date Picker Row */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                  px: 2,
                  pb: 2,
                }}
              >
                <IconButton
                  onClick={onPrevClick}
                  size="small"
                  sx={{
                    padding: '4px',
                    borderRadius: '6px',
                    color: '#6779e3',
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(103, 121, 227, 0.2)',
                    '&:hover': {
                      background: 'rgba(103, 121, 227, 0.1)',
                      borderColor: 'rgba(103, 121, 227, 0.4)',
                    },
                  }}
                >
                  <ArrowLeftIcon sx={{ fontSize: 18 }} />
                </IconButton>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    minWidth: '140px',
                    gap: 0.25,
                    px: 1.5,
                  }}
                >
                  <MomentDatePicker
                    date={dayjs(selectedDate, 'DD-MM-YYYY')}
                    onChange={(nextValue) => {
                      const newDate = nextValue?.format('DD-MM-YYYY')
                      setSelectedDate(newDate)
                      window.dispatchEvent(new CustomEvent('calendar-date-change', { detail: { date: newDate } }))
                    }}
                    calendarProps={{
                      minDetail: 'decade',
                      showNeighboringMonth: false,
                      locale: sessionStorage.getItem('languageCode') || 'en',
                    }}
                    clinicSchedules={clinicSchedules}
                    selectedDate={selectedDate}
                    format="DD-MM-YYYY"
                    buttonTextOverride={selectedDate}
                  />
                  {(() => {
                    const today = dayjs().format('DD-MM-YYYY')
                    const yesterday = dayjs().subtract(1, 'day').format('DD-MM-YYYY')
                    const tomorrow = dayjs().add(1, 'day').format('DD-MM-YYYY')

                    let label = null
                    if (selectedDate === today) {
                      label = 'Today'
                    } else if (selectedDate === yesterday) {
                      label = 'Yesterday'
                    } else if (selectedDate === tomorrow) {
                      label = 'Tomorrow'
                    }

                    return label ? (
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#6779e3',
                          fontSize: '10px',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        {label}
                      </Typography>
                    ) : null
                  })()}
                </Box>

                <IconButton
                  onClick={onNextClick}
                  size="small"
                  sx={{
                    padding: '4px',
                    borderRadius: '6px',
                    color: '#6779e3',
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(103, 121, 227, 0.2)',
                    '&:hover': {
                      background: 'rgba(103, 121, 227, 0.1)',
                      borderColor: 'rgba(103, 121, 227, 0.4)',
                    },
                  }}
                >
                  <ArrowRightIcon sx={{ fontSize: 18 }} />
                </IconButton>

                {!isToday && (
                  <Button
                    onClick={handleGoToToday}
                    size="small"
                    sx={{
                      minWidth: 'auto',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      background: 'rgba(103, 121, 227, 0.1)',
                      color: '#6779e3',
                      border: '1px solid rgba(103, 121, 227, 0.2)',
                      fontSize: '12px',
                      fontWeight: 600,
                      textTransform: 'none',
                      '&:hover': {
                        background: 'rgba(103, 121, 227, 0.2)',
                        borderColor: 'rgba(103, 121, 227, 0.4)',
                      },
                    }}
                  >
                    Today
                  </Button>
                )}
              </Box>
            </Box>
            <Box
              ref={(node) => {
                if (isMobile) {
                  refBox.current = node
                  calendarScrollContainerRef.current = node
                }
              }}
              sx={{
                flex: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                p: 0,
              }}
            >
              {!patientSelected ? (
                <DayViewCalendarComponent
                  ref={calendarRef}
                  forMentor={true}
                  bookingLisitingApiSignature={`/api/secure/teacher/booked-slots/all-with-patient-info?get-patient-details=true`}
                  mentorAuthorisedToSaveAndGetPatientsUsingIdb={getAllRolesInBoolean().isDoctor}
                  mentorId={mentorProfileData?.id}
                  mentorProfileData={mentorProfileData}
                  mentorClinicAssociationData={mentorClinicAssociationData}
                  meetingBookApiSignature="/api/secure/meeting/book"
                  listOfPaymentLinksApiSignature="/api/secure/teacher/booked-slots/user-payment-link/get"
                  publicBookingJoiningLinksApiSignature="/api/secure/teacher/booked-slots/video-session-tokens/get"
                  patientSearchApiSignature="/api/secure/mentor/patient/list"
                  cancelAppointmentApiSignature="/api/secure/teacher/booked-slots/cancel"
                  pastPatientBookingsApiSignature="/api/secure/teacher/booked-event-history-of-a-patient"
                  createPatientApiSignature="/api/secure/patient/new"
                  sendSecureSessionLinkToPatientSignature="/api/secure/teacher/booked-slots/secure-join-link/send"
                  sendPublicSessionLinkToPatientSignature="/api/secure/teacher/booked-slots/public-join-link/send"
                  getPrescriptionImagesApiSignature="/api/secure/mentor/emr-reports/prescription/images/get-by-eventId"
                  savePrescriptionImagesApiSignature="/api/secure/mentor/emr-reports/prescription/images/save"
                  fileUploadApiSignature="/api/secure/mentor/emr-reports/file/upload"
                  sendPrescriptionPdfApiSignature="/api/secure/teacher/doctor/prescription/generate/pdf"
                  headerContainerStyles={{ display: 'none', height: 0, padding: 0, margin: 0 }}
                  thisClinicData={chosenClinicData}
                  currentView={selectedTab}
                  containerRefForAutoScrolling={refBox}
                  bookedSlotClickFunctionOverride={async (data) => {
                    if (data?.status !== STATUS_SESSION_CANCELLED) {
                      // Check if this is an offline event - offline events should open therapy report editing page, not join video call
                      const isOfflineEvent = data?.meetingSrc === 'offline'
                      
                      const isVideoCallEvent = 
                        data?.eventType === allAvailableEventTypes.consultation ||
                        data?.eventType === allAvailableEventTypes.therapySession ||
                        data?.eventType === allAvailableEventTypes.screening ||
                        data?.eventType === allAvailableEventTypes.assessment
                      
                      if (isVideoCallEvent && !isOfflineEvent) {
                        // Join the booked event's video call channel (only for online events)
                        await joinBookedEventVideoCall(data)
                        setCalendarDrawerOpen(false) // Close drawer when joining video call
                      } else {
                        // Not a video call or is offline, use original behavior (opens therapy report editing page on split page)
                        markBookedEventLog(data?.id, 'JOIN', 'mentor')
                        setSelectedPatientBookedEventId(data?.id)
                        setPatientSelected(true)
                        setCalendarDrawerOpen(false) // Close drawer when selecting patient
                      }
                    }
                  }}
                  RightSideExtraComponent={
                    <CheckoutButtonComponent
                      text=" "
                      additionalFunctionBeforeAction={() => {
                        chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING &&
                          leaveThisSession()
                      }}
                      styleProp={{
                        width: '16px',
                        flexDirection: 'column',
                        borderRadius: '0px',
                        height: '100%',
                      }}
                      showExitButtonIfNotCheckedIn={true}
                    />
                  }
                  useClinicAppointmentTypes={false}
                  clinicAppointmentTypesList={[]}
                  paymentLinkToSendViaQRCode={showPaymentQrToPatient}
                  eachSlotDurationInMins={eachSlotDurationInMins}
                  setEachSlotDurationInMins={setEachSlotDurationInMins}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  onBookedSlotsUpdate={setBookedSlotsInDay}
                />
              ) : (
                <Box sx={{ p: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    Patient selected. Calendar is not available during active session.
                  </Typography>
                </Box>
              )}
            </Box>
          </Drawer>
        )}


        {/* Notification Panel for clean message display */}
        <NotificationPanel />
        
        {/* Rx Drawer - Prescription Preview */}
        {selectedPatientBookedEventData && (
          <Drawer
            anchor="right"
            open={rxDrawerOpen}
            onClose={() => setRxDrawerOpen(false)}
            PaperProps={{
              sx: {
                width: { xs: '100%', sm: '90%', md: '80%', lg: '70%', xl: '60%' },
                maxWidth: { xs: '100%', sm: '1200px', md: '1400px', lg: '1600px' },
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%', width: '100%', minWidth: 0 }}>
              <PrescriptionDataProvider>
                <RXDrawerComponent
                  mentorProfileData={mentorProfileData}
                  auxiliaryData={auxiliaryData}
                  bookedEventData={selectedPatientBookedEventData}
                  prescriptionRef={prescriptionRef}
                  onClose={() => setRxDrawerOpen(false)}
                />
              </PrescriptionDataProvider>
            </Box>
          </Drawer>
        )}
        
        {/* Idle Popup - only shows when alone in video call */}
        {chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING && (
          <EmrCheckedInIdlePopup
            currentClinicLocationData={chosenClinicData}
            mentorName={mentorProfileData?.name}
            externalIsIdle={isIdle}
            onResetIdle={() => {
              setIsIdle(false)
              if (idleTimerRef.current) {
                clearTimeout(idleTimerRef.current)
                idleTimerRef.current = null
              }
              // Restart timer if still alone
              if (remoteParticipantCount === 0 && chamberScreenStateNow === CHAMBER_SCREEN_STATES.SESSION_RUNNING) {
                idleTimerRef.current = setTimeout(() => {
                  setIsIdle(true)
                }, IDLE_TIME)
              }
            }}
          />
        )}
        
      </ScreeningSectionsProvider>
    </div>
  )
}

const UndecidedClinicIdUIComponent = () => {
  const { mentorProfileData, mentorClinicAssociationData } = useContext(MentorProfileContext)

  const navigate = useNavigate()
  return (
    <div style={{ maxWidth: '400px' }}>
      <div>Please select a clinic to remotely connect:</div>
      <div>
        {mentorClinicAssociationData?.map((clinicLoc, clinicLocIndex) => {
          return (
            <button
              className={`${'bg-light'} rounded m-1`}
              key={clinicLocIndex}
              onClick={() => navigate(`/mentor-home/join-chamber-room/${clinicLoc?.id}`)}
            >
              {clinicLoc?.title || clinicLoc?.name || clinicLoc?.firstName}
            </button>
          )
        })}
      </div>
      <div style={{ marginTop: '32px' }} onClick={() => navigate('/mentor-home')}>
        Exit
      </div>
    </div>
  )
}

export const NerdStatComponent = ({
  externalTrigger,
  resetOutsideTrigger,
  showTriggerButton = true,
  serverGivenNextAction,
}) => {
  const [open, setOpen] = useState(false)
  const [minimized, setMinimized] = useState(false)

  useEffect(() => {
    if (externalTrigger) {
      setOpen(true)
      setMinimized(false)
    }
  }, [externalTrigger])

  return (
    <div
      style={{
        position: 'relative',
        marginTop: 'auto',
        paddingTop: '16px',
        paddingLeft: '16px',
        zIndex: 1,
      }}
      className="hide-on-print-only"
    >
      {open ? (
        <div
          style={{
            width: minimized ? '188px' : 'min(420px, calc(100vw - 32px))',
            maxHeight: minimized ? 'auto' : 'min(420px, calc(100vh - 96px))',
            borderRadius: '16px',
            background: 'rgba(15, 23, 42, 0.86)',
            color: '#e2e8f0',
            padding: '10px',
            fontSize: '12px',
            border: '1px solid rgba(148, 163, 184, 0.2)',
            backdropFilter: 'blur(18px)',
            boxShadow: '0 20px 44px rgba(2, 6, 23, 0.38)',
            overflow: 'hidden',
          }}
        >
          <div
            onClick={() => setMinimized((prev) => !prev)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '12px',
              cursor: 'pointer',
              userSelect: 'none',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              <div style={{ fontWeight: 700, letterSpacing: '0.04em' }}>#Stats</div>
              <div style={{ fontSize: '11px', color: 'rgba(226, 232, 240, 0.72)' }}>
                {minimized ? 'Tap to restore' : 'Tap header to minimize'}
              </div>
            </div>
            <div
              style={{
                fontSize: '11px',
                fontWeight: 700,
                color: '#bfdbfe',
                padding: '4px 8px',
                borderRadius: '999px',
                background: 'rgba(59, 130, 246, 0.16)',
              }}
            >
              {minimized ? 'SHOW' : 'HIDE'}
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: minimized ? '8px' : '12px',
              marginBottom: minimized ? '0' : '16px',
            }}
          >
            <div
              style={{
                cursor: 'pointer',
                fontSize: '11px',
                color: 'rgba(226, 232, 240, 0.74)',
              }}
              onClick={() =>
                setOpen(() => {
                  if (resetOutsideTrigger) {
                    resetOutsideTrigger()
                  }
                  return false
                })
              }
            >
              close
            </div>
          </div>
          {!minimized ? (
            <div
              style={{
                display: 'grid',
                gap: '8px',
                maxHeight: '320px',
                overflowY: 'auto',
                paddingRight: '4px',
              }}
            >
              <div>Last action UTC: {serverGivenNextAction?.chamberScreenAction?.createdTime}</div>
              <div>Action: {serverGivenNextAction?.chamberScreenAction?.action}</div>
              <div>ChamberLastPresent UTC: {serverGivenNextAction?.channel?.chamberLastPresent}</div>
              <div>ChamberRoomId: {serverGivenNextAction?.channel?.chamberRoomId}</div>
              <div>ChamberRoomName: {serverGivenNextAction?.channel?.chamberRoomName}</div>
              <div>ChannelId: {serverGivenNextAction?.channel?.id}</div>
              <div>MentorId: {serverGivenNextAction?.channel?.mentorId}</div>
              <div>MentorLastPresent UTC: {serverGivenNextAction?.channel?.mentorLastPresent}</div>
              <div>MentorName: {serverGivenNextAction?.channel?.mentorName}</div>
            </div>
          ) : null}
        </div>
      ) : (
        showTriggerButton && (
          <div
            style={{
              height: '24px',
              width: '24px',
              borderRadius: '50%',
              background: 'rgba(0,0,0,0.2)',
              color: '#fff',
              position: 'absolute',
              // top: '16px',
              left: '16px',
              bottom: '16px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              zIndex: '9999',
            }}
            onClick={() => setOpen((prev) => !prev)}
          >
            i
          </div>
        )
      )}
    </div>
  )
}
